export const Chiku = {
  Area: [
    [0, 30, 139, 37, 30, 35, 30, 0],   // 川崎,東京国際空港,東京西南部,東京南部,東京西部,東京首部
    [1, 30, 135, 22, 30, 34, 35, 0],   // 大阪西南部,大阪東南部,大阪西北部,大阪東北部,伊丹,吹田
    [2, 30, 139, 22, 30, 35, 25, 0],   // 座間,横浜西部,原町田,荏田,武蔵府中,溝口
    [3, 30, 139, 37, 30, 35, 45, 0],   // 赤羽,草加,浦和,越谷,岩槻,野田市
    [4, 30, 136, 45, 0, 35, 5, 0],   // 蟹江,名古屋南部,清洲,名古屋北部,一宮,小牧
    [5, 30, 139, 22, 30, 35, 40, 0],   // 立川,吉祥寺,所沢,志木,川越南部,与野
    [6, 30, 139, 52, 30, 35, 35, 0],   // 浦安,千葉西部,船橋,習志野,松戸,白井
    [7, 30, 135, 37, 30, 34, 50, 0],   // 淀,宇治,京都西南部,京都東南部,京都西北部,京都東北部
    [8, 30, 139, 30, 0, 35, 15, 0],   // 鎌倉,横須賀,戸塚,本牧,*横浜西部,横浜東部
    [9, 30, 141, 15, 0, 42, 55, 0],   // 石山,清田,札幌,札幌東部,札幌北部,札幌東北部
    [10, 30, 135, 22, 30, 34, 20, 0],   // 内畑,岩湧山,岸和田東部,富田林,堺,古市
    [11, 30, 135, 37, 30, 34, 35, 0],   // 信貴山,大和郡山,生駒山,奈良,枚方,田辺
    [12, 30, 135, 7, 30, 34, 35, 0],   // 神戸南部,神戸首部,西宮,有馬,宝塚
    [13, 30, 130, 15, 0, 33, 30, 0],   // 福岡西南部,福岡南部,福岡西部,福岡,志賀島,古賀
    [14, 30, 139, 22, 30, 35, 55, 0],   // 川越北部,上尾,東松山,鴻巣,熊谷,加須
    [15, 30, 139, 15, 0, 35, 15, 0],   // 平塚,江の島,伊勢原,藤沢,厚木,*座間
    [16, 30, 130, 45, 0, 33, 45, 0],   // 徳力,苅田,八幡,小倉,六連島,下関
    [17, 30, 136, 52, 30, 34, 50, 0],   // 半田,西尾,刈谷,安城,鳴海,知立
    [18, 30, 139, 52, 30, 35, 50, 0],   // 流山,取手,守谷,藤代,水海道,谷田部
    [19, 30, 133, 45, 0, 34, 25, 0],   // 下津井,宇野,茶屋町,八浜,倉敷,岡山南部
    [20, 30, 139, 0, 0, 36, 10, 0],   // 藤岡,本庄,高崎,伊勢崎,前橋,大胡
    [21, 30, 140, 45, 0, 38, 5, 0],   // 岩沼,仙台空港,仙台西南部,仙台東南部,仙台西北部,仙台東北部
    [22, 30, 132, 22, 30, 34, 20, 0],   // 広島,海田市,祇園,中深川,飯室,可部
    [23, 30, 139, 7, 30, 35, 35, 0],   // 与瀬,八王子,五日市,拝島,武蔵御岳,青梅
    [24, 30, 134, 37, 30, 34, 45, 0],   // 姫路南部,加古川,姫路北部,笠原,前之庄,北条
    [25, 30, 138, 15, 0, 34, 50, 0],   // 焼津,静岡西部,静岡東部,牛妻,清水
    [26, 30, 137, 37, 30, 34, 40, 0],   // 浜松,磐田,気賀,笠井,伊平,二俣
    [27, 30, 140, 7, 30, 35, 30, 0],   // 蘇我,東金,千葉東部,八街,佐倉,酒々井
    [28, 30, 136, 37, 30, 35, 15, 0],   // 竹鼻,*一宮,岐阜西部,岐阜,北方,岐阜北部
    [29, 30, 130, 37, 30, 32, 40, 0],   // 宇土,御船,熊本,健軍,植木,肥後大津
    [30, 30, 137, 0, 0, 35, 0, 0],   // *知立,豊田南部,平針,豊田北部,瀬戸,猿投山
    [31, 30, 134, 52, 30, 34, 35, 0],   // 明石,須磨,東二見,前開,三木,淡河
    [32, 30, 139, 0, 0, 37, 40, 0],   // 矢代田,村松,白根,新津,新潟南部,水原
    [33, 30, 127, 37, 30, 26, 10, 0],   // 那覇,与那原,大謝名,沖縄市南部,高志保,沖縄市北部
    [34, 30, 139, 15, 0, 36, 10, 0],   // 深谷,妻沼,上野境,足利南部,桐生,足利北部
    [35, 30, 135, 7, 30, 34, 10, 0],   // 和歌山,丸栖,淡輪,岩出,尾崎,樽井
    [36, 30, 135, 37, 30, 34, 20, 0],   // 五條,吉野山,御所,畝傍山,大和高田,桜井
    [37, 30, 130, 22, 30, 33, 10, 0],   // 羽大塚,八女,久留米西部,久留米,中原,鳥栖
    [38, 30, 136, 30, 0, 34, 50, 0],   // 鈴鹿,南五味塚,四日市西部,四日市東部,菰野,桑名
    [39, 30, 139, 52, 30, 36, 25, 0],   // 上三川,真岡,宇都宮東部,祖母井,宝積寺,仁井田
    [40, 30, 137, 0, 0, 36, 35, 0],   // 宮森新,速星,高岡,富山,伏木,富山港
    [41, 30, 136, 30, 0, 36, 25, 0],   // 粟生,鶴来,松任,金沢,金石,栗崎
    [42, 30, 130, 30, 0, 31, 35, 0],   // 鹿児島北部,桜島北部,脇元,加治木,蒲生,石原
    [43, 30, 137, 22, 30, 34, 40, 0],   // 二川,新居町,豊橋,三ヶ日,新城,三河富岡
    [44, 30, 129, 52, 30, 32, 40, 0],   // 長崎東南部,諫早南部,長崎東北部,諫早南部,大村,諫早
    [45, 30, 139, 37, 30, 36, 0, 0],   // 久喜,宝珠花,栗橋,下総境,古河,諸川
    [46, 30, 131, 22, 30, 33, 10, 0],   // 小野屋,大,,別府西部,別府東部,豊後豊岡,杵築
    [47, 30, 140, 22, 30, 36, 20, 0],   // 水戸,那珂湊,石塚,常陸久慈,常陸大宮,常陸太田
    [48, 30, 133, 7, 30, 34, 20, 0],   // 尾道,常石,三成,福山西部,府中,新市
    [49, 30, 139, 52, 30, 35, 15, 0],   // 鹿野山,久留里,木更津,上総横田,奈良輪,姉崎
    [50, 30, 138, 45, 0, 35, 5, 0],   // 沼津,三島,愛鷹山,裾野,印野,御殿場
    [51, 30, 137, 7, 30, 34, 45, 0],   // 蒲郡,小坂井,幸田,御油,岡崎,三河宮崎
    [52, 30, 135, 22, 30, 34, 50, 0],   // 広根,高槻,妙見山,法貴,埴生,亀岡
    [53, 30, 132, 37, 30, 33, 45, 0],   // 郡中,松山南部,三津浜,松山北部,伊予小浜,伊予北条
    [54, 30, 138, 7, 30, 36, 35, 0],   // 長野,須坂,若槻,中野西部,信濃柏原,替佐
    [55, 30, 130, 30, 0, 33, 25, 0],   // 二日市,甘木,太宰府,大隈,篠栗,飯塚
    [56, 30, 134, 22, 30, 34, 0, 0],   // 石井,徳島,大寺,板東,引田,撫養
    [57, 30, 139, 0, 0, 35, 10, 0],   // 箱根,小田原南部,関本,小田原北部,山北,秦野
    [58, 30, 138, 45, 0, 37, 25, 0],   // 長岡,栃尾,与板,見附,寺泊,三条
    [59, 30, 138, 30, 0, 35, 30, 0],   // 市川大門,河口湖西部,甲府,石和,甲府北部,塩山
    [60, 30, 134, 0, 0, 34, 10, 0],   // 川東,鹿庭,高松南部,志,,高松北部,五剣山
    [61, 30, 140, 15, 0, 37, 10, 0],   // 矢吹,母畑,須賀川西部,須賀川東部,郡山西部,郡山
    [62, 30, 140, 15, 0, 38, 15, 0],   // 山形北部,山寺,寒河江,天童,谷地,楯岡
    [63, 30, 136, 7, 30, 35, 55, 0],   // 鯖江,河和田,福井,永平寺,越前森田,丸岡
    [64, 30, 139, 30, 0, 36, 10, 0],   // 館林,*古河,佐野,下野藤岡,田沼,栃木
    [65, 30, 140, 7, 30, 35, 50, 0],   // 龍ヶ崎,下総滑川,牛久,江戸崎,土浦,木原
    [66, 30, 131, 15, 0, 31, 50, 0],   // 田野,宮崎,日向本庄,宮崎北部,岩崎,佐土原
    [67, 30, 136, 0, 0, 34, 55, 0],   // 三雲,水口,野洲,日野西部,近江八幡,八日市
    [68, 30, 130, 30, 0, 33, 40, 0],   // 脇田,直方,筑前東郷,中間,吉木,折尾
    [69, 30, 130, 22, 30, 32, 55, 0],   // 荒尾,玉名,大牟田,関町,柳川,野町
    [70, 30, 136, 52, 30, 35, 20, 0],   // 犬山,小泉,美濃関,美濃加茂,美濃,上麻生
    [71, 30, 140, 22, 30, 40, 35, 0],   // 弘前,黒石,板柳,浪岡,五所川原,大釈迦
    [72, 30, 138, 30, 0, 35, 5, 0],   // 蒲原,吉原,富士宮,入山瀬,上井出,天母山
    [73, 30, 133, 30, 0, 33, 30, 0],   // 高知,後免,土佐山,土佐山田,田井,繁藤
    [74, 30, 139, 45, 0, 36, 15, 0],   // 小山,下館,小金井,久下田,壬生,*上三川
    [75, 30, 137, 52, 30, 36, 0, 0],   // 北小野,諏訪,塩尻,鉢伏山,松本,山辺
    [76, 30, 140, 22, 30, 37, 45, 0],   // 福島北部,保原,中茂庭,桑折,関,白石南部
    [77, 30, 133, 37, 30, 34, 5, 0],   // 観音寺,福良見,仁尾,善通寺,讃岐粟島,丸亀
    [78, 30, 136, 30, 0, 35, 10, 0],   // 駒野,津島,養老,*竹鼻,大垣,*岐阜西部
    [79, 30, 142, 15, 0, 43, 40, 0],   // 雨紛,西神楽,旭川,永山,鷹栖,比布
    [80, 30, 136, 22, 30, 34, 30, 0],   // 大河内,松阪,大仰,松阪港,津西部,津東部
    [81, 30, 141, 0, 0, 39, 30, 0],   // 志和,日詰,南昌山,矢幅,小岩井農場,盛岡
    [82, 30, 140, 45, 0, 36, 55, 0],   // 磐城泉,小名浜,常磐湯本,平,水石山,四倉
    [83, 30, 138, 0, 0, 34, 35, 0],   // 千浜,御前崎,下平川,相良,掛川,島田
    [84, 30, 141, 15, 0, 40, 30, 0],   // 五戸,八戸西部,犬落瀬,百石,三沢,浜三沢
    [85, 30, 138, 15, 0, 36, 10, 0],   // 春日本郷,臼田,丸子,小諸,上田,車坂峠
    [86, 30, 140, 37, 30, 41, 45, 0],   // 函館,五稜郭,七飯,赤川,大沼公園,横津岳
    [87, 30, 130, 7, 30, 33, 10, 0],   // 牛津,佐賀南部,小城,佐賀北部,古湯,広滝
    [88, 30, 139, 52, 30, 39, 40, 0],   // 秋田西部,土崎,船越,大久保
    [89, 30, 129, 30, 0, 33, 10, 0],   // 楠泊,佐世保北部,肥前川内,江迎,平戸,志佐
    [90, 30, 139, 45, 0, 38, 40, 0],   // 鶴岡,羽黒山,湯野浜,藤島,酒田南部,余目
    [91, 30, 139, 7, 30, 35, 50, 0],   // 原市場,飯能,正丸峠,越生,安戸,武蔵小川
    [92, 30, 140, 30, 0, 35, 40, 0],   // 八日市場,旭,岩部,小南,佐原東部,神栖
    [93, 30, 131, 22, 30, 34, 0, 0],   // 台道,防府,小郡,矢田,山口,仁保
    [94, 30, 138, 52, 30, 36, 15, 0],   // 富岡,*高崎,下室田,*前橋,伊香保,渋川
    [95, 30, 131, 7, 30, 33, 55, 0],   // 宇部,宇部東部,厚狭,阿知須,伊佐,湯ノ口
    [96, 30, 130, 45, 0, 33, 30, 0],   // 筑前山田,伊良原,田川,豊前本庄,金田,行橋
    [97, 30, 139, 45, 0, 37, 25, 0],   // 会津高田,若松,坂下,会津広田,喜多方西部,喜多方東部
    [98, 30, 137, 7, 30, 35, 15, 0],   // 多治見,猿爪,土岐,瑞浪,御嵩,武並
    [99, 30, 140, 37, 30, 40, 40, 0],   // 王余魚沢,雲谷,青森西部,青森東部,油川,浅虫
    [100, 30, 140, 37, 30, 36, 35, 0],   // 日立,高萩,磯原,大津
    [101, 30, 136, 7, 30, 35, 10, 0],   // 能登川,高宮,彦根西部,彦根東部,南浜,長浜
    [102, 30, 132, 30, 0, 34, 10, 0],   // 呉,仁方,吉浦,安芸内海,*海田市,清水原
    [103, 30, 132, 7, 30, 34, 10, 0],   // 大竹,阿多田島,玖波,厳島,津田,廿日市
    [104, 30, 129, 52, 30, 33, 5, 0],   // 嬉野,鹿島,有田,武雄,伊万里,多久
    [105, 30, 141, 7, 30, 38, 25, 0],   // 広淵,石巻,涌谷,飯野川,西野,登米
    [106, 30, 135, 15, 0, 34, 15, 0],   // *岩出,粉河,*樽井,*内畑,岸和田西部,*岸和田東部
    [107, 30, 131, 45, 0, 33, 55, 0],   // 笠戸島,光,徳山,呼坂,須々万本郷,菅野湖
    [108, 30, 141, 0, 0, 39, 10, 0],   // 金ヶ崎,陸中江刺,北上,口内,花巻,土沢
    [109, 30, 133, 7, 30, 35, 20, 0],   // 広瀬,母里,揖屋,米子,境港,美保関
    [110, 30, 140, 52, 30, 38, 15, 0],   // *仙台東北部,塩竈,富谷,松島,吉岡,鹿島台
    [111, 30, 133, 30, 0, 34, 30, 0],   // 笠岡,玉島,矢掛,箭田,三山,総社西部
    [112, 30, 140, 7, 30, 36, 5, 0],   // 常陸藤沢,常陸高浜,柿岡,石岡,加波山,岩間
    [113, 30, 141, 30, 0, 42, 35, 0],   // 苫小牧,勇払,胆振高丘,沼の端,胆振蘭越,千歳
    [114, 30, 134, 22, 30, 34, 45, 0],   // 相生,網干,二木,龍野,三日月,安志
    [115, 30, 132, 0, 0, 33, 55, 0],   // 柳井,大畠,上久原,由宇,玖珂,岩国
    [116, 30, 138, 52, 30, 34, 55, 0],   // 修善寺,伊東,韮山,網代,*三島,熱海
    [117, 30, 131, 0, 0, 31, 35, 0],   // 末吉,尾平野,都城,山王原,庄内,高城
    [118, 30, 136, 37, 30, 34, 20, 0],   // 五ヶ所浦,磯部,伊勢,鳥羽,明野,二見
    [119, 30, 133, 0, 0, 33, 50, 0],   // 伊予小松,西条,壬生川,西条北部,今治東部
    [120, 30, 136, 15, 0, 36, 15, 0],   // 大聖寺,動橋,片山津温泉,小松,美川
    [121, 30, 139, 52, 30, 36, 45, 0],   // 矢板,佐久山,西那須野,大田原,関谷,黒磯
    [122, 30, 136, 45, 0, 36, 30, 0],   // 福光,城端,倶利伽羅,砺波,石動,戸出
    [123, 30, 139, 52, 30, 36, 5, 0],   // 石下,上郷,下妻,筑波,*下館,真壁
    [124, 30, 143, 0, 0, 42, 45, 0],   // 上帯広,大正,芽室,帯広南部,祥栄,帯広北部
    [125, 30, 134, 7, 30, 35, 20, 0],   // 用瀬,因幡郡家,鳥取南部,稲葉山,鳥取北部,浦富
    [126, 30, 138, 7, 30, 37, 0, 0],   // 重倉山,新井,高田西部,高田東部,直江津,潟町
    [127, 30, 140, 0, 0, 37, 55, 0],   // 米沢北部,糠野目,羽前小松,赤湯,長井,羽前中山
    [128, 30, 130, 30, 0, 32, 25, 0],   // 日奈久,坂本,八代,鏡,松合,松橋
    [129, 30, 140, 22, 30, 37, 25, 0],   // 三春,船引,岩代本宮,岩代小浜,二本松,川俣
    [130, 30, 140, 7, 30, 35, 15, 0],   // 大多喜,国吉,鶴舞,上総一宮,海士有木,茂原
    [131, 30, 136, 0, 0, 34, 35, 0],   // 名張,阿保,月ヶ瀬,伊勢路,島ヶ原,上野
    [132, 30, 139, 37, 30, 36, 30, 0],   // 鹿沼,宇都宮西部,文挾,大谷,今市,下野大沢
    [133, 30, 134, 52, 30, 34, 50, 0],   // 社,天神,西脇,比延,中村町,谷川
    [134, 30, 132, 45, 0, 35, 15, 0],   // 稗原,木次,出雲今市,宍道,平田,秋鹿
    [135, 30, 136, 45, 0, 36, 50, 0],   // 羽咋,氷見,柴垣,能登二宮,能登高浜,七尾
    [136, 30, 131, 30, 0, 32, 20, 0],   // 山陰,平岩,上井野,日向,川水流,延岡
    [137, 30, 140, 15, 0, 35, 35, 0],   // *八街,成東,*酒々井,多古,成田,新東京国際空港
    [138, 30, 140, 22, 30, 39, 15, 0],   // 浅舞,横手,角間川,金沢本町,大曲,六郷
    [139, 30, 141, 30, 0, 43, 0, 0],   // 野幌,長沼,江別,栗沢,石狩当別,上幌向
    [140, 30, 138, 45, 0, 37, 5, 0],   // 十日町,五日町,岩沢,小出,小千谷,小平尾
    [141, 30, 140, 52, 30, 38, 30, 0],   // 古川,小牛田,荒谷,高清水,真坂,築館
    [142, 30, 141, 0, 0, 38, 55, 0],   // 平泉,一関,古戸,前沢,供養塚,水沢
    [143, 30, 137, 45, 0, 35, 30, 0],   // 飯田,下市田,安平路山,伊那大島,空木岳,赤穂
    [144, 30, 137, 15, 0, 36, 35, 0],   // 五百石,大岩,上市,越中大浦,滑川,魚津
    [145, 30, 131, 7, 30, 33, 25, 0],   // 耶馬渓東部,下市,土佐井,宇佐,中津,和間
    [146, 30, 135, 7, 30, 33, 55, 0],   // 高家,川原河,湯浅,金屋,海南,動木
    [147, 30, 130, 15, 0, 31, 35, 0],   // 長里,伊集院,串木野,薩摩郡山,川内,塔之原
    [148, 30, 135, 52, 30, 34, 50, 0],   // 朝宮,信楽,瀬田,*三雲,草津,*野洲
    [149, 30, 144, 15, 0, 42, 55, 0],   // 釧路港,釧路,大楽毛,遠矢,下幌呂,細岡
    [150, 30, 139, 0, 0, 35, 55, 0],   // 秩父,*正丸峠,皆野,*安戸,鬼石,寄居
    [151, 30, 134, 0, 0, 34, 35, 0],   // 西大寺,牛窓,備前瀬戸,片上,万富,和気
    [152, 30, 136, 37, 30, 34, 55, 0],   // *四日市東部,大野,*桑名,飛島,弥富,*蟹江
    [153, 30, 133, 52, 30, 34, 55, 0],   // 下弓削,柵原,津山西部,津山東部,香々美,楢
    [154, 30, 132, 52, 30, 34, 10, 0],   // 木江,木浦,白水,瀬戸田,竹原,三原
    [155, 30, 135, 7, 30, 34, 50, 0],   // 三田,武田尾,藍本,木津,篠山,福住
    [156, 30, 140, 37, 30, 37, 55, 0],   // 白石東南部,角田,大河原,亘理,村田,*岩沼
    [157, 30, 139, 15, 0, 37, 50, 0],   // 天王,上赤谷,新発田,菅谷,稲荷岡,中条
    [158, 30, 137, 45, 0, 36, 15, 0],   // 信濃小倉,豊科,有明,明科,大町南部,信濃池田
    [159, 30, 140, 52, 30, 42, 15, 0],   // 室蘭,室蘭,本輪西,室蘭東北部,稀府,鷲別岳
    [160, 30, 134, 7, 30, 34, 0, 0],   // 脇町,川島,西赤谷,市場,*鹿庭,三本松
    [161, 30, 138, 45, 0, 35, 25, 0],   // 富士吉田,御正体山,河口湖東部,都留,笹子,大月
    [162, 30, 140, 22, 30, 35, 55, 0],   // 麻生,潮来,西蓮寺,武井,常陸玉造,鉾田
    [163, 30, 132, 52, 30, 35, 20, 0],   // *宍道,玉造,*秋鹿,松江,恵曇,加賀
    [164, 30, 140, 45, 0, 43, 0, 0],   // 赤井川,阿女鱒岳,仁木,於古発山,余市,小樽西部
    [165, 30, 135, 0, 0, 35, 5, 0],   // 柏原,宮田,黒井,市島,福知山西部,福知山東部
    [166, 30, 130, 37, 30, 33, 10, 0],   // 黒木,十籠,草野,千足,田主丸,吉井
    [167, 30, 138, 15, 0, 35, 35, 0],   // 夜叉神峠,小笠原,鳳凰山,韮崎,長坂上条,若神子
    [168, 30, 132, 37, 30, 34, 25, 0],   // 安芸西条,白市,井原市,乃美,安芸吉田,敷名
    [169, 30, 137, 52, 30, 34, 40, 0],   // 袋井,*下平川,山梨,*掛川,森,八高山
    [170, 30, 130, 45, 0, 31, 10, 0],   // 大根占,半ヶ石,神川,上名,鹿屋,大隅高山
    [171, 30, 137, 52, 30, 35, 45, 0],   // 伊那宮田,信濃溝口,伊那,高遠,宮木,辰野
    [172, 30, 133, 15, 0, 33, 45, 0],   // 日ノ浦,土佐小松,別子銅山,弟地,新居浜,東予土居
    [173, 30, 130, 7, 30, 32, 35, 0],   // 口之津,須川,肥前小浜,雲仙,愛野,島原
    [174, 30, 135, 15, 0, 35, 15, 0],   // 綾部,和知,梅迫,丹波大町,西舞鶴,東舞鶴
    [175, 30, 130, 37, 30, 32, 55, 0],   // 来民,菊池,山鹿,八方ヶ岳,高井川,宮ノ尾
    [176, 30, 132, 30, 0, 33, 10, 0],   // 宇和島,松丸,伊予吉田,近永,卯之町,野村
    [177, 30, 138, 0, 0, 36, 20, 0],   // 信濃西条,別所温泉,麻績,坂城,稲荷山,信濃松代
    [178, 30, 137, 22, 30, 35, 25, 0],   // 恵那,中津川,美濃福岡,妻籠,付知,三留野
    [179, 30, 141, 52, 30, 43, 30, 0],   // 滝川,赤平,江部乙,イルムケップ山,妹背牛,石狩深川
    [180, 30, 141, 45, 0, 43, 10, 0],   // 岩見沢,三笠,美唄,幾春別,晩生内,茶志内
    [181, 30, 133, 15, 0, 33, 20, 0],   // 須崎,甲崎,佐川,土佐高岡,越知,伊野
    [182, 30, 129, 52, 30, 33, 20, 0],   // 徳須恵,相知,唐津,浜崎,呼子,岐志
    [183, 30, 138, 52, 30, 36, 30, 0],   // 金井,鯉沢,上野中山,沼田,猿ヶ京,後閑
    [184, 30, 135, 15, 0, 33, 40, 0],   // 紀伊白浜,紀伊田辺,紀伊南部,秋津川,古井,西
    [185, 30, 143, 52, 30, 43, 40, 0],   // 開成,津別,北見,美幌,端野,緋牛内
    [186, 30, 131, 45, 0, 32, 55, 0],   // 植松,佐伯,津久見,浅海井,臼杵,無垢島
    [187, 30, 138, 30, 0, 37, 15, 0],   // 越後野田,法坂,柏崎,塚野山,宮川,西山
    [188, 30, 140, 7, 30, 36, 20, 0],   // 羽黒,笠間,中飯,徳蔵,茂木,野口
    [189, 30, 133, 37, 30, 35, 15, 0],   // 蒜山,下鍛冶屋,泰久寺,関金宿,伯耆浦安,倉吉
    [190, 30, 138, 45, 0, 37, 40, 0],   // 弥彦,越後吉田,角田山,巻,内野,内野
    [191, 30, 137, 7, 30, 36, 5, 0],   // 三日町,高山,飛騨古川,町方,林,船津
    [192, 30, 136, 0, 0, 35, 25, 0],   // 海津,竹生島,駄口,木之本,敦賀,中河内
    [193, 30, 141, 30, 0, 38, 50, 0],   // 気仙沼,唐桑,鹿折,陸前広田,今泉,大船渡
    [194, 30, 134, 45, 0, 35, 20, 0],   // 八鹿,直見,江原,出石,豊岡,須田
    [195, 30, 130, 37, 30, 32, 0, 0],   // 吉松,加久藤,大塚,肥後大畑,一勝地,人吉
    [196, 30, 136, 52, 30, 34, 35, 0],   // 福江,師崎,佐久島,河和,吉田
    [197, 30, 135, 0, 0, 35, 30, 0],   // 四辻,宮津,峰山,日置,網野,丹後平
    [198, 30, 130, 15, 0, 31, 15, 0],   // 枕崎,石垣,加世田,知覧,唐仁原,神殿
    [199, 30, 141, 7, 30, 38, 40, 0],   // 佐沼,米谷,若柳,米川,有壁,千廐南部
    [200, 30, 136, 0, 0, 35, 45, 0],   // 河野,今庄,糠,武生,織田,*鯖江
    [201, 30, 133, 15, 0, 34, 30, 0],   // *新市,神辺,金丸,井原,小畠,地頭
    [202, 30, 130, 52, 30, 33, 5, 0],   // 鯛生,宮原,豊後大野,杖立,日田,天ヶ瀬
    [203, 30, 140, 0, 0, 37, 0, 0],   // 黒田原,旗宿,那須湯本,白河,新甲子,上小屋
    [204, 30, 132, 22, 30, 33, 25, 0],   // 八幡浜,東多田,出海,大洲,伊予長浜,串
    [205, 30, 135, 30, 0, 34, 5, 0],   // 梁瀬,上垣内,高野山,猿谷貯水池,橋本,富貴
    [206, 30, 127, 45, 0, 26, 25, 0],   // 石川,金武,石川,名護南部,瀬底島,名護
    [207, 30, 133, 30, 0, 33, 50, 0],   // 佐々連尾山,野鹿池山,伊予三島,伊予新宮,川之江,讃岐豊浜
    [208, 30, 140, 45, 0, 37, 35, 0],   // 小宮,原町,磐城草野,磐城鹿島,青葉,相馬中村
    [209, 30, 141, 15, 0, 40, 10, 0],   // 一戸,伊保内,陸奥福岡,陸中軽米,三戸,市野沢
    [210, 30, 134, 45, 0, 34, 15, 0],   // 広田,由良,都志,洲本,郡家,志筑
    [211, 30, 139, 45, 0, 34, 55, 0],   // 館山,千倉,那古,安房古川,保田,金束
    [212, 30, 140, 22, 30, 39, 0, 0],   // 横堀,菅生,湯沢,稲庭,西馬音内,十文字
    [213, 30, 136, 15, 0, 34, 45, 0],   // 平松,椋本,鈴鹿峠,亀山,土山,伊船
    [214, 30, 140, 45, 0, 35, 40, 0],   // 銚子,*銚子,鹿島矢田部,神栖
    [215, 30, 141, 0, 0, 40, 35, 0],   // 法量,十和田,銀南木,七戸,上清水目,乙供
    [216, 30, 130, 45, 0, 31, 35, 0],   // 牛根境,岩川,国,,財部,日当山,高野
    [217, 30, 134, 30, 0, 33, 45, 0],   // 阿波由岐,阿部,馬場,橘,立江,阿波富岡
    [218, 30, 138, 7, 30, 35, 50, 0],   // 信濃富士見,小淵沢,茅野,八ヶ岳西部,南大塩,蓼科
    [219, 30, 131, 22, 30, 32, 5, 0],   // 妻,高鍋,石河内,川南,尾鈴山,都農
    [220, 30, 137, 22, 30, 36, 45, 0],   // *魚津,宇奈月,三日市,舟見,青木,泊
    [221, 30, 140, 7, 30, 38, 40, 0],   // 古口,舟形,羽根沢温泉,新庄,大沢,羽前金山
    [222, 30, 140, 7, 30, 36, 35, 0],   // 烏山,上小瀬,馬頭,常陸大沢,下野小川,大子
    [223, 30, 140, 0, 0, 40, 0, 0],   // 鹿渡,小又口,森岳,下岩川,能代,二ツ井
    [224, 30, 130, 7, 30, 33, 25, 0],   // 雷山,脊振山,前原,*福岡西南部,宮浦,*福岡西部
    [225, 30, 140, 15, 0, 36, 55, 0],   // 八溝山,塙,磐城金山,棚倉,泉崎,磐城石川
    [226, 30, 130, 15, 0, 32, 0, 0],   // 出水,宮之元,米ノ津,湯出,水俣,水俣
    [227, 30, 130, 52, 30, 31, 50, 0],   // 高千穂峰,高崎新田,日向小林,高原,日向大久保,須木
    [228, 30, 133, 52, 30, 34, 0, 0],   // 辻,貞光,内田,讃岐塩工,滝宮,*川東
    [229, 30, 140, 22, 30, 40, 5, 0],   // 桂瀬,明利又,鷹巣東部,扇田,早口,大館
    [230, 30, 141, 30, 0, 42, 50, 0],   // 恵庭,長都,石狩広島,南長沼,*野幌,*長沼
    [231, 30, 139, 52, 30, 39, 10, 0],   // 象潟,川辺,平沢,前郷,本荘,本荘
    [232, 30, 127, 37, 30, 26, 0, 0],   // 喜屋武岬,糸満,知念,*那覇,*与那原
    [233, 30, 134, 7, 30, 34, 50, 0],   // 日笠,上郡,林野,上月,真加部,佐用
    [234, 30, 132, 37, 30, 33, 30, 0],   // 内子,町村,中山,総津,上灘,砥部
    [235, 30, 133, 37, 30, 34, 50, 0],   // 有漢市場,下加茂,呰部,西川,勝山,久世
    [236, 30, 133, 22, 30, 34, 45, 0],   // 備中市場,高梁,吹屋,川面市場,新見,井倉
    [237, 30, 131, 22, 30, 32, 55, 0],   // 竹田,三重町,朝地,田中,豊後今市,野津原
    [238, 30, 131, 0, 0, 31, 20, 0],   // 大隅柏原,都井岬,志布志,串間,大隅松山,園田
    [239, 30, 140, 22, 30, 36, 10, 0],   // 下吉影,徳宿,小鶴,磯浜,*水戸,*那珂湊
    [240, 30, 136, 22, 30, 35, 50, 0],   // 宝慶寺,中竜鉱山,越前大野,荒島岳,山王,越前勝山
    [241, 30, 132, 0, 0, 34, 50, 0],   // 浜田,石見今福,下府,都野津,江津
    [242, 30, 136, 22, 30, 35, 20, 0],   // 関ヶ原,*大垣,美束,池野,横山,谷汲
    [243, 30, 131, 15, 0, 34, 10, 0],   // 秋吉台,*山口,秋吉台北部,佐々並,三隅中,萩
    [244, 30, 132, 37, 30, 34, 40, 0],   // 安芸横田,甲立,前川,三次,口羽町,上布野
    [245, 30, 132, 30, 0, 32, 55, 0],   // 城辺,宿毛,柏,楠山,伊予岩松,御内
    [246, 30, 135, 52, 30, 33, 40, 0],   // 新宮,鵜殿,大里,阿田和,瀞八丁,木本
    [247, 30, 138, 45, 0, 36, 5, 0],   // 神ヶ原,万場,下仁田,上野吉井,松井田,*富岡
    [248, 30, 138, 45, 0, 34, 40, 0],   // 伊豆松崎,下田,仁科,湯ヶ野,土肥,湯ヶ島
    [249, 30, 141, 0, 0, 39, 45, 0],   // 姥屋敷,鷹高,大更,渋民,平館,沼宮内
    [250, 30, 139, 22, 30, 38, 5, 0],   // 坂町,越後下関,村上,越後門前,柏尾,塩野町
    [251, 30, 139, 7, 30, 35, 25, 0],   // 大山,*厚木,青野原,上溝,*与瀬,*八王子
    [252, 30, 133, 22, 30, 35, 15, 0],   // 江尾,延助,伯耆溝口,伯耆大山,淀江,船上山
    [253, 30, 138, 37, 30, 36, 55, 0],   // 赤沢,越後湯沢,大割野,塩沢,千手,*十日町
    [254, 30, 130, 7, 30, 32, 20, 0],   // 小宮地,棚底,本渡,大島子,御領,天草赤崎
    [255, 30, 136, 22, 30, 34, 15, 0],   // 古和浦,贄浦,伊勢佐原,脇出,横野,国束山
    [256, 30, 131, 0, 0, 32, 45, 0],   // 肥後吉田,高森,阿蘇山,根子岳,坊中,坂梨
    [257, 30, 132, 52, 30, 34, 25, 0],   // 河内,垣内,下徳良,甲山,備後小国,本郷
    [258, 30, 132, 30, 0, 35, 10, 0],   // 石見大田,反辺,田儀,神西湖,*大社,大社
    [259, 30, 141, 45, 0, 39, 15, 0],   // 小佐野,釜石,橋野,大槌,陸中金沢,陸中山田
    [260, 30, 140, 52, 30, 37, 20, 0],   // 夜の森,磐城富岡,浪江,磐城双葉,小高,塚原
    [261, 30, 139, 7, 30, 36, 25, 0],   // 鼻毛石,大間々,赤城山,上野花輪,高平,袈裟丸山
    [262, 30, 129, 37, 30, 32, 45, 0],   // 三重,長崎西北部,神浦,長浦,板浦,喰場
    [263, 30, 135, 52, 30, 35, 10, 0],   // 比良山,沖島,北小松,勝野,饗庭野,今津
    [264, 30, 136, 7, 30, 36, 10, 0],   // 三国,越前中川,北潟,*大聖寺,*片山津温泉
    [265, 30, 131, 30, 0, 33, 25, 0],   // 若宮,下原,両子山,鶴川,香々地,富来浦
    [266, 30, 135, 52, 30, 34, 25, 0],   // 古市場,高見山,初瀬,大和大野,大和白石,*名張
    [267, 30, 132, 52, 30, 34, 40, 0],   // 吉舎,上下,三良坂,稲草,永田,庄原
    [268, 30, 130, 52, 30, 34, 5, 0],   // 川棚温泉,田部,小串,西市,滝部,俵山
    [269, 30, 131, 7, 30, 33, 10, 0],   // 豊後中村,湯平,豊後森,日出生台,深耶馬渓,斉藤
    [270, 30, 130, 22, 30, 31, 50, 0],   // 宮之城,薩摩黒木,湯田,永野,*宮之元,大口
    [271, 30, 140, 22, 30, 35, 25, 0],   // 四天木,上総片貝,木戸,*成東,木戸
    [272, 30, 142, 15, 0, 44, 10, 0],   // 温根別,士別,西風連,天塩風連,母子里,名寄
    [273, 30, 140, 7, 30, 38, 5, 0],   // *羽前中山,上山,白鷹山,山形南部,宮宿,*山形北部
    [274, 30, 131, 15, 0, 31, 30, 0],   // 榎原,油津,飫肥,鵜戸,坂元,郷之原
    [275, 30, 133, 45, 0, 34, 40, 0],   // 総社東部,岡山北部,東山内,金川,*下加茂,福渡
    [276, 30, 132, 45, 0, 32, 45, 0],   // 下川口,土佐清水,来栖野,下ノ加江,有岡,土佐中村
    [277, 30, 131, 45, 0, 34, 35, 0],   // 石見横田,都茂郷,益田,仙道郷,高島,三隅
    [278, 30, 138, 15, 0, 37, 50, 0],   // 羽茂本郷,赤泊,河原田,畑野,沢根,両津
    [279, 30, 138, 7, 30, 34, 45, 0],   // *島田,住吉,向谷,*焼津,伊久美,*静岡西部
    [280, 30, 140, 30, 0, 39, 30, 0],   // 羽後長野,大神成,角館,抱返り渓谷,下桧木内,田沢湖
    [281, 30, 137, 15, 0, 35, 0, 0],   // 東大沼,三河湖,足助,寧比曽岳,小渡,川ヶ渡
    [282, 30, 135, 30, 0, 35, 15, 0],   // 島,中,口坂本,久坂,高浜,小浜
    [283, 30, 136, 45, 0, 37, 10, 0],   // 下唐川,穴水,門前,長沢,皆月,輪島
    [284, 30, 141, 7, 30, 41, 10, 0],   // 城ヶ沢,近川,むつ,蒲野沢,大畑,入口
    [285, 30, 130, 30, 0, 31, 10, 0],   // 開聞岳,指宿,今和泉,二月田,喜入
    [286, 30, 141, 45, 0, 39, 35, 0],   // 茂市,宮古,峠ノ神山,田老,有芸,田老鉱山
    [287, 30, 140, 15, 0, 35, 5, 0],   // 勝浦,御宿,上総大原,*国吉,上総長者
    [288, 30, 137, 0, 0, 36, 20, 0],   // 白木峰,打保,利賀,猪谷,山田温泉,八尾
    [289, 30, 136, 45, 0, 35, 30, 0],   // 岩佐,*美濃,下洞戸,苅安,上ヶ瀬,郡上八幡
    [290, 30, 136, 22, 30, 35, 5, 0],   // 竜ヶ岳,阿下喜,篠立,*駒野,霊仙山,*養老
    [291, 30, 130, 45, 0, 32, 30, 0],   // 柿迫,葉木,甲佐,畝野,*御船,浜町
    [292, 30, 138, 30, 0, 36, 10, 0],   // 信濃田口,荒船山,御代田,南軽井沢,浅間山,軽井沢
    [293, 30, 138, 15, 0, 36, 50, 0],   // 飯山,往郷,猿橋,野沢温泉,*新井,柳島
    [294, 30, 132, 52, 30, 33, 35, 0],   // 久万,東川,石墨山,面河渓,伊予川内,石鎚山
    [295, 30, 138, 37, 30, 36, 25, 0],   // 浅間隠山,榛名湖,長野原,群馬原町,小雨,中之条
    [296, 30, 141, 37, 30, 40, 10, 0],   // 大川目,久慈,陸中大野,陸中中野,種市,八木
    [297, 30, 140, 37, 30, 40, 5, 0],   // 大葛,湯瀬,十二所,花輪,小坂,毛馬内
    [298, 30, 138, 22, 30, 37, 5, 0],   // 安塚,松代,原之町,石黒,柿崎,*越後野田
    [299, 30, 130, 0, 0, 32, 0, 0],   // 阿久根,指江,黒之瀬戸,牛深,薩摩鷹巣
    [300, 30, 140, 30, 0, 37, 10, 0],   // 上蓬田,上三坂,田母神,小野新町,柳橋,上大越
    [301, 30, 137, 30, 0, 34, 55, 0],   // 三河大野,熊,海老,三河本郷,田口,見出
    [302, 30, 135, 0, 0, 33, 45, 0],   // 印南,三尾,御坊,紀伊由良,*高家
    [303, 30, 140, 7, 30, 39, 30, 0],   // 新波,刈和野,羽後和田,羽後境,秋田東部,岩見三内
    [304, 30, 134, 22, 30, 35, 0, 0],   // 土万,山崎,千草,安積,西河内,音水湖
    [305, 30, 144, 7, 30, 43, 50, 0],   // 女満別,東藻琴,呼人,藻琴,能取湖,網走
    [306, 30, 139, 37, 30, 35, 5, 0],   // 三浦三崎,*保田,浦賀,上総湊,*横須賀,富津
    [307, 30, 129, 37, 30, 33, 0, 0],   // 面高,川棚,佐世保南部,早岐,*佐世保北部,蔵宿
    [308, 30, 141, 15, 0, 38, 55, 0],   // 千廐北部,折壁,沖田,陸中大原,阿原山,鷹ノ巣山
    [309, 30, 140, 0, 0, 35, 0, 0],   // 安房和田,鴨川,安房小湊,坂畑,上総中野
    [310, 30, 125, 15, 0, 24, 40, 0],   // 上地,東平安名岬,平良,福北,西平安名岬,*西平安名岬
    [311, 30, 137, 7, 30, 34, 35, 0],   // 野田,田原,仁崎,老津,*蒲郡,*小坂井
    [312, 30, 138, 22, 30, 35, 20, 0],   // 身延,人穴,切石,精進,鰍沢,*市川大門
    [313, 30, 137, 37, 30, 35, 15, 0],   // 平谷,満島,浪合,山田河内,伊那駒場,時又
    [314, 30, 137, 45, 0, 36, 55, 0],   // 小滝,越後大野,糸魚川,梶屋敷,梶屋敷
    [315, 30, 139, 45, 0, 36, 40, 0],   // *下野大沢,氏家,玉生,*矢板,高原山,*西那須野
    [316, 30, 140, 15, 0, 40, 45, 0],   // 森田,*五所川原,菰槌,金木,車力,中里
    [317, 30, 140, 37, 30, 38, 30, 0],   // 薬莱山,中新田,西上野目,岩出山,鳴子,川渡
    [318, 30, 139, 0, 0, 37, 25, 0],   // 栃堀,光明山,森町,粟ヶ岳,加茂,越後白山
    [319, 30, 140, 52, 30, 38, 45, 0],   // 岩ヶ崎,金成,沼倉,萩荘,本寺,*平泉
    [320, 30, 141, 45, 0, 42, 50, 0],   // 追,,川端,三川,雨霧山,栗山,夕張
    [321, 30, 140, 45, 0, 42, 25, 0],   // 伊達,*稀府,虻田,壮瞥,洞爺,仲洞爺
    [322, 30, 132, 22, 30, 34, 35, 0],   // 琴谷,佐々井,志路原,八重,大朝,生田
    [323, 30, 140, 30, 0, 40, 20, 0],   // 白沢,陸中濁川,阿闍羅山,碇ヶ関,大鰐,沖浦
    [324, 30, 135, 45, 0, 33, 25, 0],   // 串本,古座,下里,滝の拝,紀伊勝浦
    [325, 30, 130, 7, 30, 32, 50, 0],   // 湯江,多比良,肥前大浦,多良
    [326, 30, 133, 7, 30, 34, 45, 0],   // 福永,油木,帝釈峡,東城,小奴可,備中矢田
    [327, 30, 131, 0, 0, 34, 10, 0],   // *西市,於福,*俵山,長門湯本,長門古市,仙崎
    [328, 30, 131, 37, 30, 33, 0, 0],   // 犬飼,*津久見,戸次本町,*臼杵,鶴崎,坂ノ市
    [329, 30, 137, 7, 30, 37, 15, 0],   // 宇出津,宇出津,松波,松波,宝立山,能登飯田
    [330, 30, 131, 7, 30, 32, 30, 0],   // 胡摩山,諸塚,鞍岡,諸塚山,馬見原,三田井
    [331, 30, 136, 7, 30, 34, 0, 0],   // 尾鷲,九鬼,引本浦,島勝浦,大杉峡谷,長島
    [332, 30, 140, 45, 0, 37, 50, 0],   // 丸森,新地,*角田,山下,*亘理,荒浜
    [333, 30, 130, 52, 30, 32, 10, 0],   // 免田,槻木,多良木,市房山,梶原,古屋敷
    [334, 30, 128, 37, 30, 32, 35, 0],   // 玉之浦,富江,三井楽,五島福江,肥前柏,岐宿
    [335, 30, 133, 45, 0, 33, 25, 0],   // 安芸,安芸,手結,土佐土居,美良布,畑山
    [336, 30, 136, 37, 30, 36, 40, 0],   // 津幡,*石動,加賀高松,宝達山,*羽咋
    [337, 30, 129, 22, 30, 28, 15, 0],   // 住用,奄美小湊,名瀬西部,名瀬東部,龍郷
    [338, 30, 136, 45, 0, 34, 15, 0],   // 浜島,波切,*磯部,安乗,*鳥羽,浦村
    [339, 30, 134, 45, 0, 34, 30, 0],   // 仮屋,仮屋,*明石,高砂,*東二見
    [340, 30, 140, 37, 30, 35, 55, 0],   // 常陸鹿島,荒野
    [341, 30, 138, 22, 30, 36, 30, 0],   // 四阿山,大前,御飯岳,上野草津,中野東部,岩菅山
    [342, 30, 136, 7, 30, 34, 25, 0],   // 菅野,宮前,倶留尊山,伊勢奥津,*阿保,二本木
    [343, 30, 142, 52, 30, 42, 55, 0],   // 御影,*祥栄,十勝清水,上然別,鹿追,瓜幕
    [344, 30, 135, 22, 30, 35, 5, 0],   // 園部,殿田,胡麻,四ツ谷,*和知,*島
    [345, 30, 133, 52, 30, 35, 20, 0],   // 三朝,岩坪,松崎,鹿野,青谷,浜村
    [346, 30, 141, 22, 30, 40, 20, 0],   // *市野沢,階上岳,苫米地,新井田,*八戸西部,八戸東部
    [347, 30, 134, 45, 0, 35, 5, 0],   // 生野,丹波和田,但馬新井,大名草,但馬竹田,矢名瀬
    [348, 30, 138, 52, 30, 35, 35, 0],   // *大月,上野原,七保,猪丸,丹波,奥多摩湖
    [349, 30, 142, 22, 30, 43, 20, 0],   // 富良野,本幸,上富良野,旭野,美馬牛,置杵牛
    [350, 30, 140, 22, 30, 38, 35, 0],   // 尾花沢,魚取沼,月楯,羽前赤倉,瀬見,向町
    [351, 30, 139, 45, 0, 39, 50, 0],   // 船川,*船越,北浦,寒風山,大潟
    [352, 30, 139, 45, 0, 38, 55, 0],   // 酒田北部,羽後観音寺,十里塚,吹浦,小砂川,小砂川
    [353, 30, 141, 37, 30, 45, 10, 0],   // 兜沼,沼川,上勇知,樺岡,稚内,声問
    [354, 30, 131, 52, 30, 34, 10, 0],   // 周防須万,渋前,周防広瀬,周防本郷,六日市,宇佐郷
    [355, 30, 132, 15, 0, 34, 50, 0],   // 石見今市,矢上,川戸,川本,浅利,大家
    [356, 30, 132, 45, 0, 34, 0, 0],   // 菊間,今治西部,大浜,波止浜,大長,*木江
    [357, 30, 133, 45, 0, 33, 50, 0],   // 大歩危,京上,阿波川口,阿波中津,阿波池田,*辻
    [358, 30, 131, 37, 30, 34, 10, 0],   // 堀,周防鹿野,大原湖,莇ヶ岳,徳佐中,椛谷
    [359, 30, 138, 22, 30, 35, 55, 0],   // 八ヶ岳東部,御所平,松原湖,信濃中島,高野町,海瀬
    [360, 30, 141, 45, 0, 43, 25, 0],   // 浦臼,砂川,総進,*滝川,石狩大和,*江部乙
    [361, 30, 137, 0, 0, 35, 40, 0],   // 沢,焼石,郡上市島,下呂,二間手,萩原
    [362, 30, 133, 0, 0, 33, 10, 0],   // 土佐川口,窪川,米の川,久礼,新田,萩中
    [363, 30, 132, 7, 30, 34, 25, 0],   // 湯来,川角,戸河内,坪野,三段峡,加計
    [364, 30, 134, 7, 30, 34, 15, 0],   // *志,,讃岐津田,*五剣山,五剣山,土庄,草壁
    [365, 30, 134, 22, 30, 35, 25, 0],   // 扇ノ山,村岡,湯,味取,浜坂,余部
    [366, 30, 124, 7, 30, 24, 20, 0],   // 石垣,白保,伊野田,伊野田,伊原間,伊原間
    [367, 30, 139, 30, 0, 36, 40, 0],   // 日光南部,*今市,日光北部,鬼怒川温泉,川俣湖,川治
    [368, 30, 137, 22, 30, 35, 10, 0],   // *川ヶ渡,根羽,明智,横道,岩村,美濃焼山
    [369, 30, 143, 15, 0, 42, 45, 0],   // 糠内,農野牛,幕別,川合,十勝川温泉,十勝池田
    [370, 30, 134, 15, 0, 33, 45, 0],   // 長安口貯水池,桜谷,雲早山,阿井,阿波寄井,阿波三渓
    [371, 30, 136, 45, 0, 34, 40, 0],   // 内海,*師崎,野間,*河和,常滑,*半田
    [372, 30, 130, 22, 30, 32, 20, 0],   // 高戸,田浦,姫浦,*日奈久,天草松島,*八代
    [373, 30, 141, 30, 0, 39, 5, 0],   // 世田米,盛,陸前八日町,五葉山,遠野,陸中大橋
    [374, 30, 132, 22, 30, 34, 5, 0],   // 大君,倉橋島,江田島,*呉,似島,*吉浦
    [375, 30, 130, 15, 0, 33, 45, 0],   // 津屋崎,津屋崎,神湊
    [376, 30, 130, 37, 30, 31, 50, 0],   // 横川,霧島温泉,栗野,韓国岳,*吉松,*加久藤
    [377, 30, 140, 7, 30, 37, 25, 0],   // 山潟,磐梯熱海,関都,玉井,中ノ沢,安達太良山
    [378, 30, 141, 7, 30, 39, 15, 0],   // *口内,野手崎,*土沢,宮守,石鳥谷,大迫
    [379, 30, 140, 22, 30, 36, 35, 0],   // 山方,町屋,大中宿,竪破山,袋田,里美牧場
    [380, 30, 135, 45, 0, 35, 25, 0],   // 遠敷,熊川,西津,三方,常神,早瀬
    [381, 30, 133, 0, 0, 34, 5, 0],   // 幸新田,四阪島,*木浦,岩城,*瀬戸田,備後土生
    [382, 30, 137, 52, 30, 36, 30, 0],   // 日名,*稲荷山,高府,信濃中条,塩島,戸隠
    [383, 30, 130, 52, 30, 33, 25, 0],   // 英彦山,耶馬渓西部,*伊良原,下河内,*豊前本庄,椎田
    [384, 30, 137, 7, 30, 35, 30, 0],   // 河岐,切井,金山,神土,*焼石,小和知
    [385, 30, 140, 45, 0, 42, 40, 0],   // 三ノ原,留寿都,羊蹄山,喜茂別,倶知安,京極
    [386, 30, 137, 45, 0, 34, 55, 0],   // 秋葉山,犬居,中部,気田,佐久間,門桁
    [387, 30, 133, 30, 0, 35, 0, 0],   // 刑部,*勝山,上刑部,横部,美作新庄,湯原湖
    [388, 30, 132, 52, 30, 35, 0, 0],   // 比婆新市,比婆山,阿井町,下横田,湯村,横田
    [389, 30, 142, 22, 30, 43, 35, 0],   // 美瑛,志比内,*西神楽,岐登牛山,*永山,当麻
    [390, 30, 134, 7, 30, 35, 5, 0],   // 日本原,古町,大背,坂根,智頭,郷原
    [391, 30, 133, 45, 0, 34, 10, 0],   // *善通寺,*滝宮,*丸亀,白峰山,本島,五色台
    [392, 30, 132, 45, 0, 33, 10, 0],   // 江川崎,田野々,下鍵山,土佐松原,土居,梼原
    [393, 30, 130, 30, 0, 31, 25, 0],   // 瀬々串,垂水,鹿児島南部,桜島南部,*鹿児島北部,*桜島北部
    [394, 30, 139, 30, 0, 35, 5, 0],   // 三浦三崎,*三浦三崎,秋谷,*浦賀,*鎌倉,*横須賀
    [395, 30, 140, 15, 0, 40, 0, 0],   // 沖田面,阿仁前田,米内沢,*桂瀬,鷹巣西部,*鷹巣東部
    [396, 30, 143, 7, 30, 42, 30, 0],   // 尾田,忠類,更別,上更別,中札内,駒畠
    [397, 30, 139, 30, 0, 37, 25, 0],   // 沼沢沼,宮下,安座,柳津,徳沢,野沢
    [398, 30, 140, 30, 0, 42, 45, 0],   // 蘭越,ニセコ,チセヌプリ,ニセコアンヌプリ,岩内,小沢
    [399, 30, 141, 22, 30, 38, 40, 0],   // 志津川,伊里前,馬籠,津谷,津谷川,*気仙沼
    [400, 30, 130, 52, 30, 30, 30, 0],   // 大隅野間,大隅野間,浜津脇,浜津脇,西之表,安納
    [401, 30, 143, 7, 30, 44, 15, 0],   // 中宇津々,中渚滑,豊野,紋別,沙留
    [402, 30, 143, 30, 0, 43, 35, 0],   // 北見勝山,小利別,置戸,訓子府,留辺蘂西部,留辺蘂東部
    [403, 30, 136, 45, 0, 35, 45, 0],   // 門原,徳永,白鳥,那留,石徹白,大鷲
    [404, 30, 143, 30, 0, 44, 0, 0],   // 遠軽,若里,上湧別,芭露,中湧別,登栄床
    [405, 30, 137, 37, 30, 36, 0, 0],   // 寄合渡,贄川,梓湖,古見,上高地,波田
    [406, 30, 134, 37, 30, 34, 10, 0],   // 鳴門海峡,諭鶴羽山,福良,*広田,都志,*都志
    [407, 30, 140, 0, 0, 38, 10, 0],   // 荒砥,*白鷹山,太郎,*宮宿,貫見,左沢
    [408, 30, 140, 7, 30, 39, 10, 0],   // 矢島,羽後田代,大琴,老方,岩野目沢,八沢木
    [409, 30, 129, 37, 30, 33, 40, 0],   // 郷ノ浦,印通寺,湯本,芦辺,勝本,勝本
    [410, 30, 131, 30, 0, 34, 25, 0],   // 長門広瀬,十種峰,宇田,長門新市,須佐,江崎
    [411, 30, 128, 52, 30, 32, 45, 0],   // 浦,佐尾,漁生浦,奈良尾,串島,有川
    [412, 30, 141, 7, 30, 40, 15, 0],   // 上斗米,*陸奥福岡,田子,*三戸,金ヶ沢,剣吉
    [413, 30, 139, 52, 30, 37, 30, 0],   // *会津広田,猪苗代,*喜多方東部,磐梯山,熱塩,桧原湖
    [414, 30, 138, 37, 30, 37, 10, 0],   // 岡野町,*岩沢,*法坂,*小千谷,*塚野山,片貝
    [415, 30, 130, 22, 30, 32, 40, 0],   // 雲仙,網津,島原,肥後船津,下沖洲,伊倉
    [416, 30, 141, 37, 30, 43, 50, 0],   // 大和田,幌糠,留萌,ポロシリ山,小平,達布
    [417, 30, 138, 52, 30, 37, 0, 0],   // 六日町,兎岳,*五日町,八海山,*小出,大湯
    [418, 30, 133, 15, 0, 35, 0, 0],   // 油野,足立,上石見,千屋実,印賀,根雨
    [419, 30, 130, 22, 30, 33, 25, 0],   // 不入道,*二日市,*福岡南部,*太宰府,*福岡,*篠栗
    [420, 30, 137, 37, 30, 35, 45, 0],   // 上松,木曽駒ヶ岳,木曽福島,宮ノ越,末川,薮原
    [421, 30, 134, 0, 0, 33, 15, 0],   // 室戸岬,室戸岬,羽根,佐喜浜,奈半利,入木
    [422, 30, 139, 15, 0, 36, 5, 0],   // 三ヶ尻,*熊谷,*深谷,*妻沼,*上野境,*足利南部
    [423, 30, 145, 30, 0, 43, 10, 0],   // 落石,根室南部,友知,根室北部,婦羅理
    [424, 30, 143, 7, 30, 43, 0, 0],   // 駒場,東士幌,中士幌,士幌,中音更,上士幌
    [425, 30, 140, 30, 0, 36, 55, 0],   // 橋場,上平石,磐城新宿,上遠野,竹貫,下市萱
    [426, 30, 132, 15, 0, 33, 15, 0],   // 伊予高山,伊予高山,伊予大島,三瓶,湊浦,*八幡浜
    [427, 30, 134, 15, 0, 33, 30, 0],   // 甲浦,奥浦,牟岐,小川口,山河内
    [428, 30, 134, 37, 30, 35, 25, 0],   // 栃本,*江原,神鍋山,*豊岡,香住,城崎
    [429, 30, 144, 45, 0, 43, 20, 0],   // 西春別,中西別,計根別,上春別,西竹,中標津
    [430, 30, 132, 30, 0, 34, 55, 0],   // 木路原,赤名,石見小原,野萱,三瓶山西部,三瓶山東部
    [431, 30, 130, 22, 30, 32, 5, 0],   // *湯出,山野,*水俣,大関山,計石,佐敷
    [432, 30, 141, 45, 0, 39, 50, 0],   // 岩泉,小本,沼袋,田野畑,玉川,普代
    [433, 30, 139, 45, 0, 37, 10, 0],   // 田島,甲子山,林中,湯野上,東尾岐,上三寄
    [434, 30, 138, 45, 0, 35, 20, 0],   // 須走,駿河小山,*富士吉田,*御正体山,*河口湖東部,*都留
    [435, 30, 140, 45, 0, 39, 40, 0],   // 国見温泉,雫石,秋田駒ヶ岳,篠崎,曲崎山,松川温泉
    [436, 30, 141, 22, 30, 38, 20, 0],   // 荻浜,寄磯,女川,出島,雄勝,大須
    [437, 30, 141, 7, 30, 40, 50, 0],   // 野辺地,平沼,目越,戸鎖,陸奥横浜,陸奥横浜
    [438, 30, 138, 0, 0, 34, 55, 0],   // 家山,*伊久美,高郷,石上,蕎麦粒山,千頭
    [439, 30, 135, 45, 0, 34, 10, 0],   // 南日裏,弥山,中戸,洞川,*吉野山,新子
    [440, 30, 131, 7, 30, 32, 55, 0],   // *坂梨,桜町,久住山,久住,湯坪,大船山
    [441, 30, 128, 52, 30, 27, 40, 0],   // 伊仙,亀津,平土野,ジャナレ島,山
    [442, 30, 142, 0, 0, 42, 25, 0],   // 門別,厚賀,富川,庫富,旭岡,平取
    [443, 30, 129, 45, 0, 32, 30, 0],   // 野母,肥前高島,千々,長崎西南部,*長崎東南部
    [444, 30, 144, 22, 30, 43, 40, 0],   // 野上峠,緑,上徳,札弦,小清水,清里
    [445, 30, 133, 0, 0, 33, 25, 0],   // 王在家,長者,柳井川,大崎,*東川,上土居
    [446, 30, 140, 30, 0, 37, 40, 0],   // 月舘,萩平,*保原,霊山,*桑折,舟生
    [447, 30, 141, 0, 0, 40, 0, 0],   // 七時雨山,陸奥中山,陸奥荒屋,駒ヶ嶺,稲庭岳,浄法寺
    [448, 30, 145, 0, 0, 43, 25, 0],   // 中春別,床丹,俵橋,尾岱沼,川北,標津
    [449, 30, 139, 30, 0, 38, 25, 0],   // 勝木,雷,鼠ヶ関,木野俣,温海,山五十川
    [450, 30, 142, 7, 30, 43, 20, 0],   // 奥芦別,島ノ下,上芦別,野花南,芦別,瑠辺蘂山
    [451, 30, 140, 37, 30, 37, 20, 0],   // *上大越,上川内,常葉,古道,上移,下津島
    [452, 30, 131, 37, 30, 32, 40, 0],   // 熊田,古江,重岡,三川内,千束,上直見
    [453, 30, 136, 7, 30, 34, 50, 0],   // 甲賀,*鈴鹿峠,*水口,*土山,*日野西部,日野東部
    [454, 30, 143, 7, 30, 42, 15, 0],   // 札楽古,広尾,中豊似,豊似,開進,大樹
    [455, 30, 141, 45, 0, 42, 30, 0],   // 上厚真,鵡川,上厚真,軽舞,遠浅,厚真
    [456, 30, 140, 0, 0, 39, 45, 0],   // *土崎,松原,*大久保,蓬内台,五城目,湯ノ又
    [457, 30, 135, 22, 30, 33, 30, 0],   // 紀伊日置,江住,富田,市鹿野,*紀伊田辺,合川
    [458, 30, 129, 37, 30, 33, 15, 0],   // *江迎,楠久,*志佐,今福,鷹島,高串
    [459, 30, 131, 22, 30, 33, 25, 0],   // 立石,*若宮,豊後高田,*両子山,浜,*香々地
    [460, 30, 136, 15, 0, 35, 25, 0],   // 虎御前山,*美束,近江川合,*横山,美濃川上,美濃広瀬
    [461, 30, 129, 52, 30, 32, 55, 0],   // 武留路山,多良岳,彼杵,古枝,*嬉野,*鹿島
    [462, 30, 144, 22, 30, 43, 15, 0],   // 中久著呂,標茶,上オソツベツ,磯,内,弟子屈,南弟子屈
    [463, 30, 139, 15, 0, 37, 35, 0],   // 高石,越後豊川,馬下,津川,出湯,東赤谷
    [464, 30, 140, 30, 0, 38, 5, 0],   // 遠刈田,*村田,今宿,陸前川崎,作並,熊ヶ根
    [465, 30, 133, 22, 30, 34, 15, 0],   // 宇治島,六島,鞆,白石島,福山東部,寄島
    [466, 30, 132, 52, 30, 32, 55, 0],   // *土佐中村,田野浦,蕨岡,土佐佐賀,大用,伊与喜
    [467, 30, 139, 52, 30, 42, 15, 0],   // 左股,後志日進,北檜山,八束,丹羽,今金
    [468, 30, 138, 0, 0, 36, 5, 0],   // *鉢伏山,霧ヶ峰,*山辺,和田,三才山,武石
    [469, 30, 138, 0, 0, 36, 50, 0],   // 妙高山,赤倉,湯川内,関山,槙,*重倉山
    [470, 30, 142, 15, 0, 43, 55, 0],   // 福原,蘭留,三和,和寒,剣淵,上士別
    [471, 30, 136, 37, 30, 37, 5, 0],   // 富来,中島,剣地,*下唐川,能登黒島,*門前
    [472, 30, 130, 45, 0, 31, 25, 0],   // 上祓川,持留,百引,野方,*牛根境,*岩川
    [473, 30, 135, 0, 0, 35, 20, 0],   // 三岳山,河守,大江山,内宮,*四辻,*宮津
    [474, 30, 129, 52, 30, 32, 15, 0],   // 大江,河浦,天草高浜,鬼海ヶ浦,天草下田
    [475, 30, 140, 15, 0, 37, 40, 0],   // 土湯温泉,福島南部,板谷,*福島北部,栗子山,*中茂庭
    [476, 30, 129, 7, 30, 28, 5, 0],   // 瀬武,古仁屋,西古見,奄美久慈,宇検,湯湾
    [477, 30, 136, 30, 0, 35, 30, 0],   // *谷汲,美濃神海,樽見,谷合,能郷,下大須
    [478, 30, 135, 37, 30, 33, 45, 0],   // 皆地,本宮,発心門,伏拝,重里,十津川温泉
    [479, 30, 135, 37, 30, 35, 5, 0],   // 周山,大原,上弓削,花脊,*中,久多
    [480, 30, 130, 52, 30, 32, 40, 0],   // *浜町,大平,大矢野原,*肥後吉田,立野,*阿蘇山
    [481, 30, 143, 22, 30, 43, 5, 0],   // 押帯,本別,活込,足寄太,芽登,愛冠
    [482, 30, 140, 7, 30, 41, 45, 0],   // 桂岡,瓜谷山,江差,館,乙部,鶉町
    [483, 30, 138, 15, 0, 35, 5, 0],   // 駿河落合,和田島,湯の森,篠井山,梅ヶ島,南部
    [484, 30, 141, 22, 30, 39, 55, 0],   // 小屋瀬,陸中五日市,葛巻,安家森,陸中戸田,陸中関
    [485, 30, 128, 0, 0, 26, 30, 0],   // 瀬嵩,天仁屋,仲尾次,国頭平良,大宜味,辺土名
    [486, 30, 133, 7, 30, 36, 5, 0],   // 菱浦,都万,都万,都万,隠岐北方,隠岐北方
    [487, 30, 140, 0, 0, 36, 20, 0],   // 岩瀬,*羽黒,*真岡,*中飯,*祖母井,*茂木
    [488, 30, 139, 0, 0, 34, 45, 0],   // 稲取,天城山,富戸,*伊東,川奈
    [489, 30, 139, 22, 30, 36, 25, 0],   // 番場,仙波,沢入,中粕尾,足尾,古峰原
    [490, 30, 140, 30, 0, 41, 55, 0],   // 木地挽山,*大沼公園,姫川,駒ヶ岳,渡島森,砂原
    [491, 30, 134, 37, 30, 35, 0, 0],   // 寺前,粟賀町,長谷,*生野,神子畑,*但馬新井
    [492, 30, 140, 7, 30, 40, 35, 0],   // 枯木平,岩木山,種里,十面沢,鰺ヶ沢,*森田
    [493, 30, 141, 0, 0, 43, 0, 0],   // 余市岳,手稲山,張碓,銭函,小樽東部,銭函
    [494, 30, 140, 0, 0, 39, 25, 0],   // 岩谷,新沢,内道川,*新波,羽川,*羽後和田
    [495, 30, 141, 52, 30, 43, 45, 0],   // 石狩沼田,多,志,恵比島,鷹泊,浅野,鷹泊貯水池
    [496, 30, 145, 0, 0, 43, 10, 0],   // 東円朱別,姉別,上風蓮,奥行,豊原,別海
    [497, 30, 134, 0, 0, 33, 45, 0],   // 北川,阿波出原,剣山,谷口,阿波古見,阿波川井
    [498, 30, 131, 22, 30, 32, 35, 0],   // 日之影,行縢山,大菅,祝子川,見立,木浦鉱山
    [499, 30, 127, 52, 30, 26, 10, 0],   // 津堅,屋慶名,宮城島,宮城島
    [500, 30, 137, 0, 0, 35, 15, 0],   // 高蔵寺,*多治見,*小泉,*土岐,*美濃加茂,*御嵩
    [501, 30, 131, 7, 30, 32, 15, 0],   // 石堂山,尾八重,日向大河内,神門,上椎葉,清水岳
    [502, 30, 135, 52, 30, 34, 40, 0],   // 柳生,*月ヶ瀬,笠置山,*島ヶ原,*朝宮,*信楽
    [503, 30, 132, 7, 30, 33, 45, 0],   // 平郡島,平郡島東部,阿月,安下庄,*大畠,久賀
    [504, 30, 140, 0, 0, 37, 15, 0],   // 羽鳥湖,岩代長沼,岩代福良,岩代中野,原,*山潟
    [505, 30, 130, 7, 30, 31, 20, 0],   // 野間岳,*加世田,片浦,*唐仁原,*久多島,伊作
    [506, 30, 140, 45, 0, 37, 10, 0],   // 川前,上浅見川,坂シ内,成子内,*上川内,*夜の森
    [507, 30, 136, 30, 0, 36, 10, 0],   // 加賀丸山,白峰,尾小屋,市原,別宮,口直海
    [508, 30, 141, 37, 30, 44, 10, 0],   // 力昼,三渓,苫前,上羽幌,羽幌,曙
    [509, 30, 137, 15, 0, 35, 55, 0],   // 飛騨小坂,胡桃島,久々野,朝日貯水池,*高山,飛騨青屋
    [510, 30, 139, 30, 0, 37, 5, 0],   // 松戸原,糸沢,会津山口,針生,和泉田,大芦
    [511, 30, 143, 30, 0, 42, 40, 0],   // 旅来,十勝大津,茂岩,浦幌,十弗,常室
    [512, 30, 138, 52, 30, 37, 10, 0],   // *小出,*大湯,*小平尾,須原,半蔵金,穴沢
    [513, 30, 131, 45, 0, 34, 25, 0],   // 津和野,安蔵寺山,日原,石谷,*石見横田,*都茂郷
    [514, 30, 141, 15, 0, 43, 10, 0],   // 石狩,太美,望来,望来,厚田
    [515, 30, 139, 52, 30, 37, 50, 0],   // 入田沢,米沢,玉庭,*米沢北部,手ノ子,*羽前小松
    [516, 30, 138, 15, 0, 36, 25, 0],   // 真田,嬬恋田代,菅平,*四阿山,*須坂,*御飯岳
    [517, 30, 140, 15, 0, 41, 0, 0],   // 津軽相内,薄市,小泊,増川岳,龍飛崎,三廐
    [518, 30, 140, 15, 0, 39, 25, 0],   // 悪戸野,*大曲,*刈和野,刈和野東部,*羽後境,稲沢
    [519, 30, 140, 52, 30, 40, 45, 0],   // 折紙山,*上清水目,東岳,狩場沢,小湊,清水川
    [520, 30, 132, 0, 0, 34, 35, 0],   // 出合原,*三段峡,宇津川,臥龍山,木都賀,波佐
    [521, 30, 140, 15, 0, 42, 30, 0],   // 渡島双葉,長万部,黒松内,静狩,熱郛,白井川
    [522, 30, 140, 7, 30, 38, 25, 0],   // 海味,*谷地,葉山,富並,肘折,海谷
    [523, 30, 139, 45, 0, 38, 25, 0],   // 大鳥,赤見堂岳,上田沢,湯殿山,下名川,大網
    [524, 30, 139, 0, 0, 37, 55, 0],   // 新潟北部,松浜,松浜
    [525, 30, 143, 52, 30, 43, 55, 0],   // 日吉,越歳,浜佐呂間,卯原内,サロマ湖東部,常呂
    [526, 30, 129, 7, 30, 34, 10, 0],   // 小茂田,厳原,阿連,鶏知,廻,仁位
    [527, 30, 135, 22, 30, 33, 55, 0],   // 寒川,龍神,紀伊清水,護摩壇山,田,*梁瀬
    [528, 30, 130, 7, 30, 31, 45, 0],   // 羽島,*川内,西方,東郷,大川,紫尾山
    [529, 30, 140, 0, 0, 36, 40, 0],   // 喜連川,*馬頭,*佐久山,*下野小川,*大田原,黒羽田町
    [530, 30, 141, 45, 0, 44, 50, 0],   // 更岸,雄信内,振老,安牛,幌延,本流
    [531, 30, 136, 30, 0, 34, 35, 0],   // *松阪港,伊勢浜田,*津東部,白子
    [532, 30, 134, 30, 0, 35, 15, 0],   // 戸倉峠,大屋市場,氷ノ山,関宮,*村岡,*栃本
    [533, 30, 140, 7, 30, 35, 45, 0],   // 小林,*成田,*龍ヶ崎,*下総滑川,*牛久,*江戸崎
    [534, 30, 138, 45, 0, 35, 50, 0],   // 雁坂峠,雲取山,中津峡,三峰,両神山,長又
    [535, 30, 137, 45, 0, 36, 40, 0],   // 白馬町,*塩島,白馬岳,雨中,越後平岩,雨飾山
    [536, 30, 130, 37, 30, 32, 15, 0],   // 高沢,肥後田代,中津道,頭地,*坂本,宮園
    [537, 30, 138, 22, 30, 35, 40, 0],   // *韮崎,*甲府北部,*若神子,茅ヶ岳,谷戸,瑞牆山
    [538, 30, 132, 37, 30, 33, 25, 0],   // 鹿野川,惣川,*内子,*町村,*中山,*総津
    [539, 30, 129, 15, 0, 34, 25, 0],   // 三根,志多賀,鹿見,琴,佐護,佐須奈
    [540, 30, 139, 0, 0, 36, 40, 0],   // *後閑,追貝,藤原湖,鎌田,藤原,至仏山
    [541, 30, 134, 15, 0, 34, 35, 0],   // 西島,日生,幡州赤穂,備前三石,*相生
    [542, 30, 135, 52, 30, 33, 55, 0],   // 大沼,七色貯水池,池原,高代山,釈迦ヶ岳,河合
    [543, 30, 132, 45, 0, 35, 0, 0],   // 頓原,*比婆新市,出雲吉田,*阿井町,掛合,*湯村
    [544, 30, 133, 52, 30, 35, 10, 0],   // 奥津,美作加茂,上斎原,加瀬木,*三朝,*岩坪
    [545, 30, 141, 15, 0, 42, 30, 0],   // 白老,社台,森野,錦岡,風不死岳,樽前山
    [546, 30, 133, 30, 0, 33, 45, 0],   // 本山,杉,*佐々連尾山,*野鹿池山,*伊予三島,*伊予新宮
    [547, 30, 140, 37, 30, 39, 15, 0],   // 羽後黒沢,陸中川尻,左草,新町,真昼岳,陸中猿橋
    [548, 30, 139, 45, 0, 36, 55, 0],   // 塩原,*関谷,日留賀岳,板室,栗生沢,那須岳
    [549, 30, 136, 45, 0, 36, 15, 0],   // 中宮温泉,鳩谷,西赤尾,上梨,湯涌,下梨
    [550, 30, 142, 22, 30, 43, 5, 0],   // 石狩金山,幾寅,山部,西達布,布部,麓郷
    [551, 30, 142, 15, 0, 42, 20, 0],   // 静内,御園,共栄,明和,新和,太陽
    [552, 30, 136, 52, 30, 37, 15, 0],   // *長沢,鵜川,*輪島,柳田,輪島,曽々木
    [553, 30, 127, 45, 0, 26, 40, 0],   // 伊江島,仲宗根,*楚洲,伊是名島
    [554, 30, 138, 45, 0, 36, 40, 0],   // 四万,*猿ヶ京,三国峠,水上,土樽,茂倉岳
    [555, 30, 139, 37, 30, 37, 55, 0],   // 長者原,叶水,小国,小国東部,舟渡,五味沢
    [556, 30, 144, 7, 30, 43, 5, 0],   // 阿寒,*下幌呂,徹別,鶴居,上幌呂,茂雪裡
    [557, 30, 130, 52, 30, 33, 50, 0],   // *小倉,喜多久,*下関,白野江,安岡,小月
    [558, 30, 133, 15, 0, 33, 35, 0],   // 思地,川口,日比原,西石原,*日ノ浦,*土佐小松
    [559, 30, 139, 52, 30, 40, 30, 0],   // 十二湖,白神岳,深浦,長慶平,驫木,北金ヶ沢
    [560, 30, 135, 52, 30, 35, 55, 0],   // 梅浦,*織田,越前蒲生,越前蒲生,鮎川
    [561, 30, 143, 45, 0, 43, 35, 0],   // 訓津峠,本岐,常川,*開成,相内,*北見
    [562, 30, 141, 45, 0, 39, 0, 0],   // 綾里,綾里,越喜来,陸前千歳,小白浜,平田
    [563, 30, 128, 30, 0, 27, 15, 0],   // 沖永良部島西部,沖永良部島西部,沖永良部島東部,沖永良部島東部
    [564, 30, 142, 37, 30, 42, 5, 0],   // 浦河,荻伏,西舎,歌笛,上野深
    [565, 30, 132, 45, 0, 34, 15, 0],   // 三津,*白水,田万里市,*竹原,*白市,*河内
    [566, 30, 136, 15, 0, 34, 55, 0],   // *土山,*伊船,*日野東部,御在所山,百済寺,*竜ヶ岳
    [567, 30, 142, 7, 30, 42, 40, 0],   // 荷負,振内,穂別,仁世宇,稲里,胆振福山
    [568, 30, 133, 7, 30, 35, 5, 0],   // 多里,*上石見,阿毘縁,*印賀,布部,井尻
    [569, 30, 140, 22, 30, 38, 0, 0],   // 不忘山,白石,蔵王山,*遠刈田,笹谷峠,*今宿
    [570, 30, 143, 0, 0, 44, 0, 0],   // 上雄柏,丸立峠,滝西,立牛,滝上,北見滝下
    [571, 30, 142, 22, 30, 44, 45, 0],   // 本幌別,志美宇丹,歌登,下幌別,ポロヌプリ山,枝幸
    [572, 30, 142, 30, 0, 44, 5, 0],   // 奥士別,岩尾内湖,日進,新下川,上名寄,下川
    [573, 30, 140, 37, 30, 38, 45, 0],   // 鬼首,花山湖,軍沢,切留,桂沢,栗駒山
    [574, 30, 130, 45, 0, 30, 20, 0],   // 上中,上中,島間,島間,*大隅野間
    [575, 30, 141, 30, 0, 43, 15, 0],   // 弁華別,市南,青山中央,月形,二番川,ピンネシリ
    [576, 30, 144, 30, 0, 42, 55, 0],   // 昆布森,仙鳳趾,上尾幌,尾幌,塘路湖,片無去
    [577, 30, 134, 45, 0, 35, 30, 0],   // *豊岡,*須田,*城崎,久美浜,城崎,塩江
    [578, 30, 133, 30, 0, 35, 30, 0],   // 御来屋,赤崎
    [579, 30, 138, 22, 30, 36, 45, 0],   // 夜間瀬,切明,*往郷,鳥甲山,*野沢温泉,信濃森
    [580, 30, 140, 45, 0, 41, 20, 0],   // 長後,白土山,佐井,奥戸,大間
    [581, 30, 141, 7, 30, 38, 15, 0],   // 宮戸島,小野,渡波,*広淵,*石巻
    [582, 30, 140, 52, 30, 41, 40, 0],   // 汐首,戸井,鉄山,古武井,川汲,尾札部
    [583, 30, 140, 37, 30, 38, 20, 0],   // 定義,根白石,升沢,七ツ森,*薬莱山,*中新田
    [584, 30, 140, 15, 0, 41, 30, 0],   // 千軒,涌元,湯ノ里,渡島知内,神明,木古内
    [585, 30, 129, 15, 0, 33, 10, 0],   // 野子,志々伎,紐差,生月
    [586, 30, 143, 37, 30, 43, 50, 0],   // 花園,上仁頃,若佐,佐呂間山,*若里,佐呂間
    [587, 30, 142, 52, 30, 44, 20, 0],   // 上興部,秋里,トーウツ岳,興部,雄武,沢木
    [588, 30, 131, 22, 30, 34, 20, 0],   // *萩,生雲中,越ヶ浜,*長門広瀬,櫃島,*宇田
    [589, 30, 142, 30, 0, 43, 50, 0],   // 愛別,中愛別,協和,旭山,乙部山,新奥士別
    [590, 30, 136, 52, 30, 37, 0, 0],   // *七尾,庵,和倉,小口瀬戸,*穴水,前波
    [591, 30, 131, 7, 30, 31, 45, 0],   // *高城,築地原,有水,*田野,紙屋,*日向本庄
    [592, 30, 142, 52, 30, 42, 35, 0],   // 岩内川上流,上札内,拓成,十勝清川,上美生,*上帯広
    [593, 30, 134, 0, 0, 34, 50, 0],   // 周匝,*日笠,*柵原,*林野,*津山東部,*真加部
    [594, 30, 140, 37, 30, 40, 55, 0],   // 蓬田,小湊,蟹田,小湊,陸奥平館,脇野沢
    [595, 30, 136, 7, 30, 34, 15, 0],   // 宮川貯水池,間弓,七日市,江馬,*菅野,*宮前
    [596, 30, 143, 37, 30, 43, 20, 0],   // 大誉地,上足寄,陸別,陸別東部,釧路川上,上陸別
    [597, 30, 136, 52, 30, 36, 0, 0],   // 新淵,六廐,御母衣,夏廐,平瀬,猪臥山
    [598, 30, 140, 0, 0, 40, 15, 0],   // 羽後水沢,根城岱,中浜,羽後焼山,二ッ森,冷水岳
    [599, 30, 132, 15, 0, 35, 5, 0],   // 温泉津,仁万,大浦
    [600, 30, 131, 7, 30, 32, 0, 0],   // 大森岳,*岩崎,掃部岳,三納,村所,瓢丹淵
    [601, 30, 140, 37, 30, 36, 50, 0],   // 川部,勿来,*上平石,*磐城泉,*上遠野,*常磐湯本
    [602, 30, 132, 30, 0, 32, 40, 0],   // 母島,母島,柏島,福浦,小筑紫
    [603, 30, 141, 0, 0, 42, 25, 0],   // *鷲別岳,登別温泉,カルルス温泉,飛生,蟠渓,徳舜瞥山
    [604, 30, 139, 15, 0, 37, 15, 0],   // 田子倉湖,会津小林,只見,会津横田,駒形山,貉ヶ森山
    [605, 30, 130, 37, 30, 30, 55, 0],   // 佐多岬,佐多岬,浜尻,伊座敷,辺塚
    [606, 30, 141, 15, 0, 40, 45, 0],   // 甲地,六川目,*平沼,天ヶ森,*戸鎖,尾駮
    [607, 30, 131, 52, 30, 32, 45, 0],   // 蒲江,蒲江,畑野浦,沖黒島,*佐伯,鶴御崎
    [608, 30, 142, 37, 30, 42, 55, 0],   // 沙流岳,十勝石山,上トマム,新得,落合,狩勝峠
    [609, 30, 140, 22, 30, 35, 50, 0],   // 佐原西部,*佐原東部,*麻生,*潮来,*西蓮寺,*武井
    [610, 30, 141, 37, 30, 39, 55, 0],   // 安家,*沼袋,端神,*玉川,岩瀬張,陸中野田
    [611, 30, 130, 52, 30, 33, 20, 0],   // 大行司,裏耶馬渓,*英彦山,*耶馬渓西部,*伊良原,*下河内
    [612, 30, 140, 52, 30, 40, 20, 0],   // 中滝,清水頭,十和田湖東部,戸来岳,陸奥焼山,奥瀬
    [613, 30, 144, 30, 0, 43, 20, 0],   // *磯,内,泉川,*南弟子屈,虹別,摩周湖南部,養老牛
    [614, 30, 145, 0, 0, 42, 55, 0],   // 琵琶瀬,琵琶瀬,霧多布,茶内,奔幌戸
    [615, 30, 135, 30, 0, 33, 35, 0],   // *市鹿野,下露,*合川,木守,栗栖川,*皆地
    [616, 30, 135, 52, 30, 35, 5, 0],   // 堅田,*近江八幡,*比良山,*沖島,*北小松,*勝野
    [617, 30, 143, 15, 0, 43, 55, 0],   // 丸瀬布南部,瀬戸瀬温泉,丸瀬布北部,瀬戸瀬,立牛岳,上富美
    [618, 30, 130, 52, 30, 32, 55, 0],   // 鞍岳,*坊中,立門,満願寺,*鯛生,*宮原
    [619, 30, 133, 45, 0, 33, 40, 0],   // 奈呂,大栃,東土居,久保沼井,*大歩危,*京上
    [620, 30, 137, 22, 30, 36, 0, 0],   // *朝日貯水池,野麦,*飛騨青屋,乗鞍岳,旗鉾,焼岳
    [621, 30, 131, 22, 30, 32, 20, 0],   // 坪谷,*山陰,田代,*上井野,宇納間,*川水流
    [622, 30, 140, 15, 0, 36, 50, 0],   // 町付,東館,*八溝山,*塙,*磐城金山,*棚倉
    [623, 30, 142, 45, 0, 43, 40, 0],   // 愛山渓温泉,層雲峡,菊水,ニセイカウシュツペ山,上川,中越
    [624, 30, 131, 52, 30, 33, 10, 0],   // 佐賀関,佐賀関,*三崎,三崎
    [625, 30, 137, 52, 30, 35, 15, 0],   // 伊那和田,池口岳,上町,光岳,上久堅,大沢岳
    [626, 30, 140, 52, 30, 39, 25, 0],   // 鉛,花巻温泉,須賀倉山,*志和,鶯宿,*南昌山
    [627, 30, 140, 15, 0, 40, 20, 0],   // 真名子,越山,尾太岳,田代岳,陸奥田代,久渡寺
    [628, 30, 132, 52, 30, 34, 55, 0],   // 比和,西城,*比婆新市,*比婆山,*阿井町,*下横田
    [629, 30, 140, 52, 30, 41, 10, 0],   // 陸奥川内,戸沢,陸奥畑,恐山,*白土山,薬研温泉
    [630, 30, 144, 0, 0, 42, 55, 0],   // 白糠,庶路,中庶路,山花,上庶路,*阿寒
    [631, 30, 133, 7, 30, 34, 35, 0],   // 木野山,*金丸,高蓋,*小畠,*福永,*油木
    [632, 30, 137, 30, 0, 35, 40, 0],   // 奥三界岳,木曽須原,王滝,*上松,御岳高原,*木曽福島
    [633, 30, 138, 45, 0, 34, 35, 0],   // 石廊崎,神子元島,*伊豆松崎,*下田,*仁科,*湯ヶ野
    [634, 30, 141, 15, 0, 39, 30, 0],   // 陸中折壁,早池峰山,区界,松草,大志田,青松葉山
    [635, 30, 136, 7, 30, 35, 40, 0],   // 板取,広野,*今庄,宅良,*武生,稲荷
    [636, 30, 132, 15, 0, 34, 40, 0],   // 大仙原,*志路原,石見坂本,*大朝,*石見今市,*矢上
    [637, 30, 144, 45, 0, 43, 0, 0],   // 厚岸,厚岸湖,釧路太田,糸魚沢,別寒辺牛川中流,茶内原野
    [638, 30, 144, 7, 30, 43, 35, 0],   // サマッカリヌプリ,屈斜路湖,古梅,藻琴山,北見福住,末広
    [639, 30, 141, 30, 0, 39, 25, 0],   // 大出,白見山,高桧山,江繋,陸中川内,陸中川井
    [640, 30, 141, 52, 30, 44, 40, 0],   // 天塩清川,佐久,泉源,天塩中川,*雄信内,問寒別
    [641, 30, 135, 15, 0, 35, 5, 0],   // 村雲,*園部,莵原,*胡麻,*綾部,*和知
    [642, 30, 144, 37, 30, 43, 45, 0],   // 斜里岳,瑠辺斯岳,斜里,朱円,斜里,峰浜
    [643, 30, 130, 22, 30, 30, 15, 0],   // 栗生,尾之間,永田岳,宮之浦岳,一湊,屋久宮之浦
    [644, 30, 142, 7, 30, 44, 55, 0],   // 松音知,中頓別,イソサンヌプリ山,下頓別,安別,浜頓別
    [645, 30, 141, 15, 0, 39, 10, 0],   // 人首,種山ヶ原,*野手崎,小友,*宮守,上宮守
    [646, 30, 131, 30, 0, 33, 55, 0],   // 佐波島,野島,*防府,福川,*矢田,島地
    [647, 30, 134, 0, 0, 33, 30, 0],   // 馬路,名留川,土佐魚梁瀬,久尾,赤城尾山,湯桶丸
    [648, 30, 130, 22, 30, 31, 0, 0],   // 長崎鼻,三俣,*開聞岳
    [649, 30, 136, 52, 30, 36, 45, 0],   // 飯久保,*伏木,*氷見,宇波,*能登二宮,虻ガ島
    [650, 30, 138, 45, 0, 34, 55, 0],   // 達磨山,*修善寺,大瀬崎,*韮山,*沼津,*三島
    [651, 30, 142, 15, 0, 44, 25, 0],   // 美深,智恵文,紋穂内,雄木禽,恩根内,函岳
    [652, 30, 135, 15, 0, 35, 30, 0],   // 丹後由良,青葉山,亀島,成生岬,丹後平田,冠島
    [653, 30, 139, 37, 30, 32, 55, 0],   // 八丈島南部,八丈小島,八丈島
    [654, 30, 140, 30, 0, 43, 0, 0],   // 茅沼,銀山,稲倉石,然別,両古美山,豊浜
    [655, 30, 142, 7, 30, 43, 35, 0],   // 石狩新城,神楽岳,神ノ居古潭,*雨紛,上湯内,*旭川
    [656, 30, 140, 37, 30, 39, 0, 0],   // 小安温泉,真湯温泉,椿台,焼石岳,田子内,三界山
    [657, 30, 140, 45, 0, 39, 55, 0],   // 八幡平,茶臼岳,熊沢,竜ヶ森,*湯瀬,田山
    [658, 30, 144, 52, 30, 43, 35, 0],   // 武佐,*川北,武佐岳,伊茶仁,西古多糠,薫別
    [659, 30, 133, 45, 0, 35, 5, 0],   // 美作宮原,*香々美,富西谷,*奥津,*下鍛冶屋,*上斎原
    [660, 30, 140, 7, 30, 37, 50, 0],   // 米沢東部,*栗子山,*糠野目,名号,*赤湯,二井宿
    [661, 30, 137, 37, 30, 35, 10, 0],   // 茶臼山,三河大谷,*平谷,*満島,*浪合,*山田河内
    [662, 30, 140, 30, 0, 42, 30, 0],   // 礼文華,豊浦,礼文華峠,大岸,後志立川,昆布岳
    [663, 30, 138, 7, 30, 38, 0, 0],   // 相川,*沢根,金北山,金北山,北田野浦
    [664, 30, 138, 37, 30, 35, 40, 0],   // *塩山,大菩薩峠,川浦,柳沢峠,金峰山,*雁坂峠
    [665, 30, 138, 37, 30, 35, 55, 0],   // 居倉,*中津峡,浜平,*両神山,十石峠,*神ヶ原
    [666, 30, 132, 52, 30, 33, 25, 0],   // 越知面,*王在家,笠取山,*柳井川,*久万,*東川
    [667, 30, 129, 52, 30, 28, 10, 0],   // 喜界島南部,*喜界島南部,喜界島南部,喜界島南部,喜界島北部,喜界島北部北部
    [668, 30, 140, 7, 30, 38, 55, 0],   // 差首鍋,及位,丁岳,松ノ木峠,中直根,上笹子
    [669, 30, 126, 37, 30, 26, 10, 0],   // *久米島南部,久米島南部,久米島,久米島
    [670, 30, 130, 52, 30, 31, 5, 0],   // 稲尾岳,*半ヶ石,岸良,*上名,内之浦
    [671, 30, 143, 45, 0, 42, 50, 0],   // 直別,音別,霧里,河原,ヌプキベツ,縫別
    [672, 30, 129, 0, 0, 33, 5, 0],   // 津和崎,津和崎,小値賀島,小値賀島,宇久島,宇久島
    [673, 30, 132, 52, 30, 35, 55, 0],   // *知夫,知夫,知夫,崎,浦郷,菱浦
    [674, 30, 139, 37, 30, 37, 40, 0],   // 飯里,加納,大日岳,川入,飯豊山,岩倉
    [675, 30, 129, 37, 30, 28, 20, 0],   // 赤尾木,赤木名,笠利崎
    [676, 30, 140, 7, 30, 41, 20, 0],   // 白神岬,渡島吉岡,渡島福島,大千軒岳,*千軒
    [677, 30, 130, 22, 30, 32, 35, 0],   // 三角,*松合,*雲仙,*網津,*島原,*肥後船津
    [678, 30, 137, 15, 0, 36, 20, 0],   // 鹿間,下之本,東茂住,有峰湖,千垣,小見
    [679, 30, 143, 7, 30, 43, 15, 0],   // 勢多山,萩ヶ岡,糠平,芽登温泉,幌加,幌加美里別ダム
    [680, 30, 142, 0, 0, 45, 10, 0],   // エタンパック山,浅茅野,鬼志別,猿払,知来別,浜鬼志別
    [681, 30, 137, 22, 30, 34, 55, 0],   // 高里,*三河大野,*三河湖,*海老,*寧比曽岳,*田口
    [682, 30, 132, 7, 30, 33, 20, 0],   // 二名津,*伊予大島,三机,*湊浦,湊浦
    [683, 30, 141, 15, 0, 39, 45, 0],   // 外山,岩洞,陸中南山形,藪川,陸中北山形,*小屋瀬
    [684, 30, 142, 7, 30, 44, 40, 0],   // 筬島,音威子府,ペンケ山,小頓別,敏音知,上頓別
    [685, 30, 131, 15, 0, 32, 45, 0],   // 祖母山,*見立,豊後柏原,小原,*桜町,*竹田
    [686, 30, 140, 22, 30, 39, 45, 0],   // 番鳥森,上桧木内,比立内,戸鳥内,阿仁合,森吉山
    [687, 30, 140, 15, 0, 42, 5, 0],   // 野田追岳,濁川,山越,落部,八雲
    [688, 30, 130, 7, 30, 33, 5, 0],   // 牛屋,七ツ家,*牛津,*佐賀南部,*小城,*佐賀北部
    [689, 30, 138, 37, 30, 35, 20, 0],   // 富士山,*須走,鳴沢,*富士吉田,*河口湖西部,*河口湖東部
    [690, 30, 138, 0, 0, 35, 30, 0],   // 信濃大河原,塩見岳,鹿塩,間ノ岳,市野瀬,仙丈ヶ岳
    [691, 30, 137, 37, 30, 36, 25, 0],   // 烏帽子岳,*大町南部,黒部湖,大町,十字峡,神城
    [692, 30, 141, 45, 0, 44, 25, 0],   // 天塩有明,正修,初山別,大成,歌越,東野
    [693, 30, 141, 30, 0, 39, 40, 0],   // 害鷹森,和井内,釜津田,陸中大川,早坂高原,門
    [694, 30, 142, 22, 30, 42, 50, 0],   // 日高,千栄,占冠中央,双珠別湖,占冠,下トマム
    [695, 30, 138, 37, 30, 37, 30, 0],   // 出雲崎,*与板,出雲崎,*寺泊,*弥彦
    [696, 30, 132, 0, 0, 34, 25, 0],   // 安芸冠山,*湯来,野入,*戸河内,*出合原,*三段峡
    [697, 30, 142, 30, 0, 42, 15, 0],   // 富沢,*歌笛,ペラリ山,美河,農屋,セタウシ山
    [698, 30, 129, 37, 30, 31, 35, 0],   // 手打,青瀬,青瀬,中甑
    [699, 30, 143, 22, 30, 42, 30, 0],   // 晩成,湧洞沼南部,生花,湧洞沼,二宮,*旅来
    [700, 30, 141, 52, 30, 42, 55, 0],   // *雨霧山,紅葉山,*夕張,シュウパロ湖,美流渡,栄町
    [701, 30, 142, 0, 0, 43, 55, 0],   // *鷹泊貯水池,沼牛,長留内岳,幌加内,三頭山,政和
    [702, 30, 142, 52, 30, 43, 10, 0],   // 岩松,東ヌプカウシヌプリ,ニペソツ,然別湖,ペンケベツ,ウペペサンケ山ケ山
    [703, 30, 132, 15, 0, 33, 0, 0],   // 魚神山,日振島,結出,戸島,遊子
    [704, 30, 140, 45, 0, 40, 30, 0],   // 温川,*陸奥焼山,酸ヶ湯,八甲田山,*雲谷,田代平
    [705, 30, 138, 45, 0, 36, 20, 0],   // 三ノ倉,*下室田,*榛名湖,*伊香保,*群馬原町,*金井
    [706, 30, 140, 0, 0, 35, 30, 0],   // 五井,*蘇我,*千葉西部,*千葉東部,*習志野,*佐倉
    [707, 30, 138, 0, 0, 37, 5, 0],   // 名立大町,*高田西部,名立大町,*直江津
    [708, 30, 141, 7, 30, 42, 45, 0],   // 漁岳,恵庭岳,札幌岳,空沼岳,定山渓,*石山
    [709, 30, 134, 22, 30, 35, 15, 0],   // 岩屋堂,*戸倉峠,若桜,*氷ノ山,*扇ノ山,*村岡
    [710, 30, 130, 22, 30, 31, 30, 0],   // 春山,*鹿児島南部,*伊集院,*鹿児島北部,*薩摩郡山,*脇元
    [711, 30, 137, 0, 0, 35, 55, 0],   // 飛騨大原,山之口,*六廐,位山,*夏廐,*三日町
    [712, 30, 142, 52, 30, 42, 0, 0],   // 幌満,様似,アポイ岳,上杵臼,新富
    [713, 30, 130, 0, 0, 32, 30, 0],   // 天草富岡,*御領,*口之津,*諫早南部,*肥前小浜
    [714, 30, 141, 7, 30, 45, 5, 0],   // 仙法志,鬼脇,鴛泊,雄忠志内,鴛泊
    [715, 30, 140, 52, 30, 39, 5, 0],   // 石淵ダム,*供養塚,夏油温泉,*金ヶ崎,和賀仙人,*北上
    [716, 30, 139, 30, 0, 36, 55, 0],   // 湯西川,五十里湖,湯ノ花,荒海山,*松戸原,*糸沢
    [717, 30, 139, 7, 30, 35, 0, 0],   // 初島,真鶴岬,*小田原南部
    [718, 30, 139, 52, 30, 42, 0, 0],   // 相沼,熊石,渡島鮎川,貝取澗,遊楽部岳
    [719, 30, 131, 30, 0, 33, 40, 0],   // 竹田津,姫島
    [720, 30, 140, 22, 30, 38, 20, 0],   // *天童,関山峠,*楯岡,船形山,延沢,銀山温泉
    [721, 30, 125, 7, 30, 24, 45, 0],   // 伊良部島,*平良,伊良部島,*西平安名岬,池間島,池間島
    [722, 30, 139, 37, 30, 36, 25, 0],   // 下野大柿,*壬生,*鹿沼,*宇都宮西部,*文挾,*大谷
    [723, 30, 130, 30, 0, 30, 10, 0],   // 栗生,*尾之間,尾之間,*宮之浦岳,安房
    [724, 30, 131, 15, 0, 31, 20, 0],   // 都井岬,本城,幸島,*榎原,*油津
    [725, 30, 143, 30, 0, 42, 55, 0],   // 東台,活平,宝生,川流布,*本別,栄穂
    [726, 30, 132, 30, 0, 34, 50, 0],   // 出羽,*口羽町,*木路原,*赤名,*石見小原,*野萱
    [727, 30, 129, 22, 30, 32, 50, 0],   // 池島,釜ノ浦,大立島,蛎浦
    [728, 30, 128, 7, 30, 26, 40, 0],   // *辺土名,安波
    [729, 30, 136, 30, 0, 35, 45, 0],   // 能郷白山,平家岳,*中竜鉱山,越前朝日,*荒島岳,下山
    [730, 30, 140, 15, 0, 42, 45, 0],   // 歌棄,目名,島古丹,雷電山,雷電岬
    [731, 30, 144, 15, 0, 43, 25, 0],   // 辺計礼山,*弟子屈,和琴,美留和,*屈斜路湖,川湯
    [732, 30, 139, 0, 0, 35, 25, 0],   // 中川,*大山,大室山,*青野原,*上野原,*与瀬
    [733, 30, 131, 30, 0, 32, 50, 0],   // 中津留,*千束,*三重町,佩楯山,*田中,*犬飼
    [734, 30, 145, 15, 0, 43, 10, 0],   // 厚床,別当賀,風蓮,東梅,本別海
    [735, 30, 139, 15, 0, 36, 45, 0],   // 丸沼,男体山,三平峠,川俣温泉,燧ヶ岳,帝釈山
    [736, 30, 141, 37, 30, 44, 55, 0],   // 音類,*振老,稚咲内,*幌延,豊徳,豊富
    [737, 30, 138, 30, 0, 36, 25, 0],   // 北軽井沢,*浅間隠山,*大前,*長野原,*上野草津,*小雨
    [738, 30, 141, 45, 0, 42, 45, 0],   // 早来,幌内,*追,,*川端,*三川,*雨霧山
    [739, 30, 144, 0, 0, 43, 20, 0],   // 雌阿寒岳,ピリカネップ,阿寒湖,雄阿寒岳,木禽岳,コトニヌプリ
    [740, 30, 142, 0, 0, 44, 10, 0],   // 霧立峠,添牛内,羽幌岳,朱鞠内,ピッシリ山,蕗之台
    [741, 30, 142, 45, 0, 44, 5, 0],   // 藻瀬狩山,茂瀬,名寄川上流,上札久留,一の橋,西興部
    [742, 30, 141, 22, 30, 38, 10, 0],   // 網地島,金華山,網地島,金華山,*荻浜,*寄磯
    [743, 30, 143, 0, 0, 43, 30, 0],   // 石狩岳,十勝三股,大雪湖,石北峠,大函,武利岳
    [744, 30, 140, 45, 0, 41, 55, 0],   // *横津岳,臼尻,鹿部,鹿部,松屋崎
    [745, 30, 143, 15, 0, 43, 30, 0],   // クマネシリ岳,東三国山,曲り沢峠,常元,富士見,大和
    [746, 30, 142, 37, 30, 44, 30, 0],   // オシトツ,上雄武,シアッシリ山,中幌内,上音標,音標
    [747, 30, 136, 0, 0, 34, 10, 0],   // 大台ヶ原山,*大杉峡谷,大和柏木,*宮川貯水池,大豆生,*七日市
    [748, 30, 130, 45, 0, 33, 25, 0],   // 小石原,*英彦山,*筑前山田,*伊良原,*田川,*豊前本庄
    [749, 30, 131, 52, 30, 33, 40, 0],   // *祝島,宇和島,祝島,室津,光,水場
    [750, 30, 141, 30, 0, 40, 15, 0],   // 小軽米,*陸中大野,*階上岳,*種市,*新井田,角ノ浜
    [751, 30, 130, 52, 30, 32, 25, 0],   // 椎原,不土野,*葉木,国見岳,*畝野,緑川
    [752, 30, 138, 22, 30, 38, 5, 0],   // 両津北部,水津,小田,小田,鷲崎,鷲崎
    [753, 30, 139, 7, 30, 34, 10, 0],   // 神津島,式根島,式根島,新島,新島
    [754, 30, 134, 30, 0, 33, 35, 0],   // 牟岐,日和佐,*阿波由岐,*阿部
    [755, 30, 137, 0, 0, 35, 35, 0],   // 美濃川合,*金山,*沢,*焼石,*郡上市島,*下呂
    [756, 30, 139, 45, 0, 34, 50, 0],   // 布良,白浜,*館山,*千倉,*那古,*安房古川
    [757, 30, 145, 0, 0, 43, 55, 0],   // 遠音別岳,八木浜,幌別,羅臼,知床五湖,硫黄山
    [758, 30, 134, 7, 30, 34, 30, 0],   // 小江,寒霞渓,*牛窓,*片上,*日生
    [759, 30, 141, 0, 0, 42, 40, 0],   // 双葉,白老岳,栄,*漁岳,中山峠,*札幌岳
    [760, 30, 131, 37, 30, 32, 25, 0],   // *日向,*延岡,延岡北部,島浦
    [761, 30, 130, 7, 30, 31, 10, 0],   // 坊,枕崎,坊,*枕崎,*野間岳,*加世田
    [762, 30, 140, 7, 30, 42, 15, 0],   // 上八雲,*八雲,ルコツ岳,黒岩,美利河,国縫
    [763, 30, 141, 37, 30, 43, 35, 0],   // 吉野,*石狩大和,国領,恵岱別,信砂御料,美葉牛
    [764, 30, 132, 45, 0, 33, 0, 0],   // 川登,*蕨岡,口屋内,*大用,*江川崎,*田野々
    [765, 30, 143, 7, 30, 41, 55, 0],   // 襟裳岬,襟裳岬,えりも,庶野,袴腰山,日高目黒
    [766, 30, 141, 52, 30, 44, 55, 0],   // *安牛,上問寒別,*本流,豊神,日曹,上猿払
    [767, 30, 140, 15, 0, 40, 15, 0],   // 藤琴,*早口,*真名子,*越山,*尾太岳,*田代岳
    [768, 30, 140, 37, 30, 36, 20, 0],   // 那珂湊,常陸久慈,日立南部
    [769, 30, 139, 45, 0, 35, 10, 0],   // *上総湊,鬼泪山,*富津,*鹿野山,大堀,*木更津
    [770, 30, 133, 37, 30, 34, 45, 0],   // 豪渓,*東山内,*有漢市場,*下加茂,*呰部,*西川
    [771, 30, 134, 30, 0, 34, 35, 0],   // 真浦,真浦,真浦,*網干,*姫路南部
    [772, 30, 137, 15, 0, 35, 40, 0],   // *小和知,加子母,宮地,滝越,湯屋,御嶽山
    [773, 30, 139, 22, 30, 34, 0, 0],   // 三宅島,三宅島,三宅島,三宅島
    [774, 30, 140, 22, 30, 41, 45, 0],   // 桂岳,茂辺地,富里,陣屋,設計山,*木地挽山
    [775, 30, 140, 22, 30, 43, 5, 0],   // 神恵内,*稲倉石,ポンネアンチシ山,*両古美山,余別,美国
    [776, 30, 135, 37, 30, 33, 30, 0],   // 三尾川,*古座,*下露,*滝の拝,*木守,紀伊大野
    [777, 30, 138, 7, 30, 35, 10, 0],   // 井川,*湯の森,畑薙湖,*梅ヶ島,上河内岳,七面山
    [778, 30, 132, 52, 30, 33, 50, 0],   // 東三方ヶ森,*伊予小松,鈍川,*壬生川,*今治西部,*今治東部
    [779, 30, 140, 7, 30, 36, 55, 0],   // 伊王野,*八溝山,*旗宿,*磐城金山,*白河,*泉崎
    [780, 30, 128, 22, 30, 27, 0, 0],   // 与論島
    [781, 30, 139, 22, 30, 42, 0, 0],   // 青苗,*青苗,赤石,赤石,神威脇,奥尻
    [782, 30, 138, 7, 30, 37, 45, 0],   // 宿根木,小木,宿根木,*羽茂本郷,稲鯨,*河原田
    [783, 30, 143, 52, 30, 43, 10, 0],   // 右股,布伏内,シュンクシタカラ湖,上徹別,上白愛,*雌阿寒岳
    [784, 30, 127, 52, 30, 26, 55, 0],   // 伊是名島,伊平屋島南部,伊平屋島北部,伊平屋島北部,伊平屋島北部部
    [785, 30, 139, 7, 30, 37, 5, 0],   // 奥只見湖,高幽山,未丈が岳,会津朝日岳,毛猛山,*田子倉湖
    [786, 30, 139, 15, 0, 34, 40, 0],   // 大島南部,大島南部,大島北部,大島北部
    [787, 30, 143, 0, 0, 43, 45, 0],   // 平山,上支湧別,北見峠,白滝,雄柏山,旧白滝
    [788, 30, 135, 52, 30, 35, 40, 0],   // 竹波,杉津,*河野,糠,*糠
    [789, 30, 140, 0, 0, 38, 45, 0],   // 清川,*羽根沢温泉,中野俣,*大沢,升田,*差首鍋
    [790, 30, 138, 30, 0, 36, 50, 0],   // *鳥甲山,苗場山,*信濃森,*赤沢,松之山温泉,*大割野
    [791, 30, 136, 30, 0, 35, 55, 0],   // *荒島岳,*下山,*越前勝山,願教寺山,北谷,加賀市ノ瀬
    [792, 30, 135, 37, 30, 34, 0, 0],   // 伯母子岳,風屋,*上垣内,辻堂,*猿谷貯水池,*南日裏
    [793, 30, 133, 22, 30, 35, 30, 0],   // 御来屋,*御来屋
    [794, 30, 141, 22, 30, 43, 25, 0],   // 濃昼,*二番川,柏木,四番川,浜益,御料地
    [795, 30, 144, 30, 0, 43, 10, 0],   // 五十石,中チャンベツ,*標茶,上チャンベツ,*磯,内,*泉川
    [796, 30, 142, 37, 30, 43, 25, 0],   // 白金温泉,オプタテシケ山,藤山,トムラウシ山,俵真布,旭岳
    [797, 30, 140, 0, 0, 42, 35, 0],   // 賀老,大平山,永豊,本目,寿都
    [798, 30, 141, 15, 0, 41, 0, 0],   // *陸奥横浜,出戸,有畑,陸奥泊,*近川,小田野沢
    [799, 30, 143, 37, 30, 43, 5, 0],   // *栄穂,ピラウンナイ川,奥仙美里,ウコタキヌプリ,螺湾,上螺湾
    [800, 30, 138, 30, 0, 34, 55, 0],   // 駒越,興津,*蒲原,*吉原
    [801, 30, 143, 15, 0, 44, 10, 0],   // 上渚滑,志文,*中渚滑,小向,*紋別
    [802, 30, 141, 22, 30, 43, 40, 0],   // 群別岳,暑寒別岳,別苅,暑寒沢,別苅,増毛
    [803, 30, 141, 45, 0, 43, 5, 0],   // 上志文,*美流渡,*岩見沢,*三笠,*美唄,*幾春別
    [804, 30, 140, 37, 30, 40, 25, 0],   // *碇ヶ関,十和田湖西部,*沖浦,*温川,温湯,*酸ヶ湯
    [805, 30, 141, 52, 30, 45, 15, 0],   // 曲淵,*鬼志別,モイマ山,*知来別,宗谷,峰岡
    [806, 30, 123, 45, 0, 24, 15, 0],   // 西表大原,西表大原,美原,小浜島,鳩間島
    [807, 30, 140, 0, 0, 41, 35, 0],   // 原口,七ツ岳,石崎,湯ノ岱,上ノ国,*桂岡
    [808, 30, 136, 7, 30, 33, 50, 0],   // 磯崎,賀田,早田,*尾鷲,*九鬼
    [809, 30, 139, 45, 0, 42, 20, 0],   // 太櫓,*北檜山,瀬棚,*丹羽,美谷,カスベ岳
    [810, 30, 141, 30, 0, 39, 20, 0],   // 土淵,能舟木,*大出,*白見山,*高桧山,*江繋
    [811, 30, 142, 15, 0, 42, 35, 0],   // 日高旭,貫気別山,*振内,豊糠,*仁世宇,三岩
    [812, 30, 141, 0, 0, 37, 35, 0],   // 大甕,南海老,相馬中村
    [813, 30, 140, 22, 30, 38, 50, 0],   // 神室山,鬼首峠,羽後川井,秋ノ宮,*横堀,*菅生
    [814, 30, 137, 30, 0, 35, 55, 0],   // 木曽西野,*末川,*野麦,*寄合渡,*乗鞍岳,*梓湖
    [815, 30, 143, 22, 30, 43, 20, 0],   // 喜登牛,上利別,喜登牛山,西斗満,*東三国山,勲祢別川上流
    [816, 30, 138, 15, 0, 36, 5, 0],   // 蓼科山,*高野町,*春日本郷,*臼田,*丸子,*小諸
    [817, 30, 141, 52, 30, 39, 25, 0],   // *陸中山田,霞露ヶ岳,津軽石,トドヶ崎,*宮古,閉伊崎
    [818, 30, 141, 45, 0, 44, 0, 0],   // *達布,滝下,ルペシュペナイ川,大天狗岳,*三渓,白頭山
    [819, 30, 139, 30, 0, 38, 40, 0],   // 三瀬,三瀬,羽前加茂
    [820, 30, 131, 0, 0, 33, 40, 0],   // 蓑島,神ノ島,*喜多久
    [821, 30, 140, 37, 30, 39, 45, 0],   // 田沢,*秋田駒ヶ岳,羽後玉川,*曲崎山,玉川温泉,*八幡平
    [822, 30, 133, 7, 30, 33, 40, 0],   // 筒上山,*日比原,瓶ヶ森,*日ノ浦,*西条,*別子銅山
    [823, 30, 136, 15, 0, 34, 40, 0],   // 佐田,*津西部,*平松,*椋本,*鈴鹿峠,*亀山
    [824, 30, 141, 7, 30, 40, 30, 0],   // 切田,*五戸,*十和田,*犬落瀬,*七戸,*三沢
    [825, 30, 137, 0, 0, 36, 15, 0],   // 角川,*林,*白木峰,*打保,*利賀,*猪谷
    [826, 30, 133, 0, 0, 35, 15, 0],   // 上山佐,*布部,*玉造,*広瀬,*松江,*揖屋
    [827, 30, 139, 52, 30, 37, 45, 0],   // 飯森山,白布温泉,*入田沢,*米沢,*玉庭,*米沢北部
    [828, 30, 140, 30, 0, 41, 0, 0],   // 津軽小国,*蟹田,大川平,*陸奥平館,袰月,袰月
    [829, 30, 139, 30, 0, 37, 50, 0],   // 二王子岳,*飯豊山,エブリ差岳,*長者原,安角,*小国
    [830, 30, 141, 37, 30, 44, 40, 0],   // 遠別,丸松,天塩,*更岸
    [831, 30, 132, 22, 30, 33, 50, 0],   // 周防小泊,由利島,伊保田,津和地,柱島,鹿老渡
    [832, 30, 142, 30, 0, 44, 20, 0],   // 見晴山,サンル,ピヤシリ山,幌内越峠,仁宇布,*オシトツ
    [833, 30, 142, 30, 0, 44, 35, 0],   // 黒岩山,*シアッシリ山,上徳志別,*上音標,*志美宇丹,乙忠部
    [834, 30, 142, 45, 0, 42, 40, 0],   // 礼内岳,*拓成,妙敷山,*上美生,芽室岳,渋山
    [835, 30, 141, 15, 0, 40, 0, 0],   // 宇別,*葛巻,仁昌寺,*陸中戸田,*一戸,*伊保内
    [836, 30, 137, 37, 30, 36, 50, 0],   // 小川温泉,*越後平岩,親不知,*小滝,親不知,*糸魚川
    [837, 30, 139, 52, 30, 38, 15, 0],   // 朝日岳,*太郎,大井沢,*貫見,*赤見堂岳,本道寺
    [838, 30, 130, 52, 30, 32, 5, 0],   // 白髪岳,田代ヶ八重,*免田,*槻木,*多良木,*市房山
    [839, 30, 140, 45, 0, 40, 10, 0],   // *花輪,四角岳,*毛馬内,犬吠森,小坂鉱山,*中滝
    [840, 30, 143, 22, 30, 43, 45, 0],   // 花丘,*留辺蘂西部,岩戸,伊吹,*瀬戸瀬温泉,生田原
    [841, 30, 135, 22, 30, 34, 10, 0],   // 龍門山,*高野山,*粉河,*橋本,*内畑,*岩湧山
    [842, 30, 137, 37, 30, 34, 35, 0],   // 中田島,掛塚,*浜松,*磐田,*気賀,*笠井
    [843, 30, 131, 22, 30, 31, 45, 0],   // 日向青島,*宮崎,*宮崎北部
    [844, 30, 136, 37, 30, 34, 5, 0],   // 片田,相賀浦,*浜島
    [845, 30, 142, 7, 30, 42, 55, 0],   // 長和,ニニウ,白金,屏風山,滝ノ沢岳,夕張岳
    [846, 30, 140, 22, 30, 35, 20, 0],   // 東浪見,*四天木,*上総片貝,*木戸
    [847, 30, 140, 45, 0, 41, 5, 0],   // *脇野沢,脇野沢,源藤城,*陸奥川内,牛滝,*陸奥畑
    [848, 30, 142, 0, 0, 44, 25, 0],   // 遠別川上流,苫頓別山,茶古志山,小車岳,共和,小車
    [849, 30, 140, 37, 30, 37, 35, 0],   // 飯樋,*小宮,*萩平,*磐城草野,*霊山,*青葉
    [850, 30, 129, 7, 30, 34, 0, 0],   // 豆酘,豆酘,豆酘,*小茂田,*厳原
    [851, 30, 130, 45, 0, 34, 15, 0],   // 滝部,*滝部,角島,阿川,長門川尻
    [852, 30, 135, 37, 30, 35, 20, 0],   // *久坂,古屋,*小浜,*遠敷,鋸崎,*西津
    [853, 30, 137, 37, 30, 35, 30, 0],   // 兀岳,*飯田,南木曽岳,*安平路山,*木曽須原,*空木岳
    [854, 30, 140, 52, 30, 45, 15, 0],   // 香深,礼文岳,礼文岳,船泊,船泊
    [855, 30, 139, 15, 0, 37, 0, 0],   // 会津駒ヶ岳,檜枝岐,*高幽山,内川,*会津朝日岳,城郭朝日山
    [856, 30, 139, 30, 0, 37, 20, 0],   // 野尻,博士山,*沼沢沼,*宮下,*安座,*柳津
    [857, 30, 133, 7, 30, 35, 0, 0],   // 道後山,*油野,*多里,*上石見,*阿毘縁,*印賀
    [858, 30, 133, 30, 0, 33, 25, 0],   // 土佐長浜,*高知,*後免,*土佐山,*土佐山田
    [859, 30, 129, 0, 0, 32, 50, 0],   // *奈良尾,友住,*有川,友住,立串,頭ヶ島
    [860, 30, 142, 0, 0, 43, 10, 0],   // 桂沢湖,幾春別岳,芦別湖,崕山,美唄山,*奥芦別
    [861, 30, 140, 30, 0, 36, 50, 0],   // 磐城片貝,*川部,*橋場,*上平石,*磐城新宿,*上遠野
    [862, 30, 139, 52, 30, 41, 25, 0],   // 松前,江良,江良,原口,*原口
    [863, 30, 141, 0, 0, 37, 5, 0],   // 四倉,下浅見川,井出
    [864, 30, 138, 30, 0, 37, 55, 0],   // 岩首,水津,*水津
    [865, 30, 140, 15, 0, 39, 45, 0],   // 太平山,*番鳥森,天上倉山,*比立内,八木沢,*阿仁合
    [866, 30, 143, 52, 30, 43, 25, 0],   // イユダニヌプリ山,*阿寒湖,北見相生,*木禽岳,*本岐,上里
    [867, 30, 141, 22, 30, 42, 45, 0],   // 支笏湖温泉,*胆振蘭越,島松山,*恵庭,*清田,*石狩広島
    [868, 30, 141, 22, 30, 41, 15, 0],   // 猿ヶ森,尻屋,尻尾崎
    [869, 30, 142, 15, 0, 45, 0, 0],   // *下頓別,斜内,*浜頓別,頓別,浅茅野台地
    [870, 30, 131, 30, 0, 34, 15, 0],   // 長門峡,*大原湖,*生雲中,*徳佐中,*長門広瀬,*十種峰
    [871, 30, 134, 0, 0, 34, 25, 0],   // 豊島,*土庄,犬島,*小江,*西大寺,*牛窓
    [872, 30, 131, 0, 0, 30, 45, 0],   // 国上,国上
    [873, 30, 139, 37, 30, 39, 50, 0],   // 加茂青砂,*船川,戸賀,*北浦,戸賀
    [874, 30, 129, 45, 0, 31, 40, 0],   // *青瀬,*中甑,里,海鼠池,里
    [875, 30, 141, 7, 30, 41, 45, 0],   // 恵山,渡島銚子
    [876, 30, 133, 30, 0, 34, 10, 0],   // 紫雲出山,*仁尾,*六島,*讃岐粟島,*白石島,讃岐広島
    [877, 30, 131, 7, 30, 25, 45, 0],   // 南大東島,南大東島,南大東島,南大東島,*北大東島,北大東島
    [878, 30, 131, 37, 30, 33, 15, 0],   // 家島,佐賀関,住吉浜,*下原
    [879, 30, 136, 22, 30, 35, 40, 0],   // 美濃徳山,*能郷,冠山,*能郷白山,*宝慶寺,*中竜鉱山
    [880, 30, 122, 52, 30, 24, 25, 0],   // 与那国島,与那国島
    [881, 30, 139, 22, 30, 38, 20, 0],   // 笹川,蒲萄,寒川,*勝木,*鼠ヶ関
    [882, 30, 142, 7, 30, 27, 0, 0],   // 父島,兄島,兄島
    [883, 30, 132, 45, 0, 34, 55, 0],   // 櫃田,*比和,*頓原,*比婆新市,*出雲吉田,*阿井町
    [884, 30, 134, 52, 30, 34, 5, 0],   // 初島町,由良,加太,*由良,加太
    [885, 30, 140, 30, 0, 40, 50, 0],   // 源八森,*油川,大倉岳,*蓬田,*津軽小国,*蟹田
    [886, 30, 129, 22, 30, 33, 25, 0],   // 生月島北部,的山大島,的山大島,二神島
    [887, 30, 139, 22, 30, 37, 30, 0],   // 御神楽岳,*安座,*越後豊川,*徳沢,*津川,日出谷
    [888, 30, 142, 22, 30, 42, 5, 0],   // 三石,東静内,*富沢
    [889, 30, 137, 30, 0, 36, 30, 0],   // 立山,*黒部湖,劒岳,*十字峡,毛勝山,欅平
    [890, 30, 141, 30, 0, 40, 10, 0],   // 戸呂町,*大川目,*小軽米,*陸中大野,*階上岳,*種市
    [891, 30, 135, 30, 0, 33, 50, 0],   // 恩行司,*発心門,*龍神,*重里,*護摩壇山,*伯母子岳
    [892, 30, 140, 7, 30, 42, 0, 0],   // ササマクリ山,乙部岳,砂蘭部岳,*野田追岳,春日,*山越
    [893, 30, 138, 7, 30, 35, 25, 0],   // 赤石岳,新倉,*塩見岳,奈良田,*間ノ岳,*夜叉神峠
    [894, 30, 144, 52, 30, 43, 50, 0],   // 海別岳,根室峯浜,真鯉,*遠音別岳,宇登呂,*幌別
    [895, 30, 143, 22, 30, 43, 0, 0],   // 十勝高島,*宝生,*押帯,*本別,*活込,*足寄太
    [896, 30, 124, 37, 30, 24, 35, 0],   // 多良間島,多良間島,水納島
    [897, 30, 141, 22, 30, 38, 35, 0],   // 折立,陸前相川,*志津川,*伊里前,*馬籠,*津谷
    [898, 30, 137, 22, 30, 36, 15, 0],   // 長倉,笠ヶ岳,*下之本,三俣蓮華岳,*有峰湖,薬師岳
    [899, 30, 136, 22, 30, 36, 5, 0],   // 龍谷,*北谷,山中,*加賀丸山,*動橋,*尾小屋
    [900, 30, 144, 15, 0, 43, 10, 0],   // *鶴居,下久著呂,*茂雪裡,*中久著呂,奥久著呂,*上オソツベツ
    [901, 30, 142, 37, 30, 43, 10, 0],   // 北落合,佐幌岳,シーソラプチ川上流,十勝ペンケ山,十勝岳,チカベツ山ツ山
    [902, 30, 140, 0, 0, 38, 30, 0],   // 月山,*葉山,立谷沢,*肘折,木の沢,*古口
    [903, 30, 140, 7, 30, 40, 30, 0],   // 川原平,*陸奥田代,*枯木平,*岩木山,*種里,*十面沢
    [904, 30, 142, 0, 0, 42, 40, 0],   // 胆振豊田,*荷負,上幌内,*穂別,十三里,*稲里
    [905, 30, 127, 7, 30, 26, 10, 0],   // 久場島,座間味,渡名喜島
    [906, 30, 130, 7, 30, 32, 15, 0],   // 宮野河内,唐木崎,*小宮地,*棚底,*本渡,*大島子
    [907, 30, 132, 52, 30, 32, 40, 0],   // 足摺岬,足摺岬,*土佐清水,津呂,*下ノ加江,大名鹿
    [908, 30, 141, 30, 0, 45, 5, 0],   // 清明,*豊徳,夕来,*兜沼,抜海,*上勇知
    [909, 30, 142, 45, 0, 44, 25, 0],   // 毛鐘尻山,*トーウツ岳,*上雄武,*雄武,*中幌内,北見幌内
    [910, 30, 144, 30, 0, 43, 35, 0],   // 摩周湖北部,養老牛温泉,*緑,サマッケヌプリ山,*札弦,*斜里岳
    [911, 30, 142, 45, 0, 43, 55, 0],   // 宇江内山,天塩岳,於鬼頭岳,渚滑岳,*藻瀬狩山,*茂瀬
    [912, 30, 137, 52, 30, 35, 10, 0],   // 水窪湖,寸又峡温泉,*伊那和田,*池口岳,*上町,*光岳
    [913, 30, 137, 7, 30, 37, 30, 0],   // 馬緤,珠州岬
    [914, 30, 142, 37, 30, 43, 40, 0],   // 石狩瑞穂,*愛山渓温泉,東山,*菊水,*中愛別,*上川
    [915, 30, 141, 0, 0, 40, 15, 0],   // 石亀,*上斗米,*清水頭,*田子,*戸来岳,*金ヶ沢
    [916, 30, 140, 45, 0, 39, 20, 0],   // *新町,尻平川,*陸中猿橋,*鉛,北川舟,*須賀倉山
    [917, 30, 128, 30, 0, 32, 30, 0],   // 坪,玉之浦,*玉之浦,嵯峨ノ島,*三井楽
    [918, 30, 139, 7, 30, 37, 20, 0],   // 守門岳,*只見,*光明山,*駒形山,*粟ヶ岳,室谷
    [919, 30, 142, 15, 0, 43, 10, 0],   // 芦別岳,*山部,布部岳,*布部,*島ノ下,*富良野
    [920, 30, 140, 45, 0, 42, 55, 0],   // 瑞穂,本倶登山,*赤井川,*阿女鱒岳,*仁木,*於古発山
    [921, 30, 143, 37, 30, 42, 35, 0],   // 湧洞沼,*十勝大津,*浦幌,厚内
    [922, 30, 139, 45, 0, 40, 20, 0],   // 岩館,大間越,十二湖,*十二湖
    [923, 30, 132, 22, 30, 32, 45, 0],   // 鵜来島,*母島,高茂岬,*福浦,伊予鹿島,*城辺
    [924, 30, 139, 45, 0, 42, 35, 0],   // 須築,狩場山,原歌
    [925, 30, 138, 15, 0, 37, 15, 0],   // 柿崎,*柿崎,青梅川
    [926, 30, 141, 0, 0, 41, 25, 0],   // 下風呂,木野部
    [927, 30, 141, 15, 0, 43, 35, 0],   // 幌,*浜益,雄冬,*群別岳,別苅,*別苅
    [928, 30, 144, 45, 0, 43, 15, 0],   // フッポウシ川,矢臼別,*西春別,*中西別,*計根別,*上春別
    [929, 30, 141, 15, 0, 44, 20, 0],   // 焼尻島,*焼尻島,焼尻島,焼尻島
    [930, 30, 139, 45, 0, 38, 5, 0],   // *五味沢,羽前上郷,徳網,羽前葉山,相模山,*朝日岳
    [931, 30, 143, 15, 0, 43, 45, 0],   // ,岐,*花丘,上武利,*岩戸,*丸瀬布南部,*瀬戸瀬温泉
    [932, 30, 140, 15, 0, 43, 10, 0],   // 珊内,*ポンネアンチシ山,神威岬,*余別,*神威岬,積丹岬
    [933, 30, 129, 15, 0, 28, 10, 0],   // *奄美久慈,山間,*湯湾,*住用,大棚,*名瀬西部
    [934, 30, 142, 7, 30, 43, 50, 0],   // 江丹別,*鷹栖,*沼牛,*福原,*幌加内,*三和
    [935, 30, 139, 30, 0, 33, 50, 0],   // 御蔵島,御蔵島,*三宅島
    [936, 30, 133, 7, 30, 33, 5, 0],   // 興津浦,*窪川,土佐志和,*久礼,一子碆
    [937, 30, 140, 7, 30, 37, 40, 0],   // 吾妻山,*土湯温泉,天元台,*板谷,*米沢東部,*栗子山
    [938, 30, 140, 30, 0, 43, 10, 0],   // *両古美山,*豊浜,*美国,古平,積丹岬
    [939, 30, 139, 45, 0, 35, 25, 0],   // 東扇島,*奈良輪,*東京国際空港,*東京南部,*浦安
    [940, 30, 142, 0, 0, 43, 25, 0],   // 文珠,*上芦別,*赤平,*芦別,*イルムケップ山,*石狩新城
    [941, 30, 145, 15, 0, 43, 25, 0],   // 床丹,野付崎,野付崎
    [942, 30, 143, 52, 30, 43, 5, 0],   // 上茶路,*上庶路,*右股,*布伏内,*シュンクシタカラ湖,*上徹別
    [943, 30, 139, 45, 0, 42, 10, 0],   // 久遠,*貝取澗,後志太田,*左股,*太櫓,*北檜山
    [944, 30, 132, 37, 30, 35, 25, 0],   // 日御碕,*平田,坂浦,坂浦,坂浦
    [945, 30, 142, 52, 30, 42, 20, 0],   // ピリカヌプリ,トヨニ岳,神威岳,ヌビナイ川上流,ポンヤオロマップ岳,拓進  拓進
    [946, 30, 135, 0, 0, 34, 20, 0],   // *尾崎,田之代
    [947, 30, 139, 15, 0, 36, 40, 0],   // 皇海山,中禅寺湖,*丸沼,*男体山,*三平峠,*川俣温泉
    [948, 30, 138, 37, 30, 36, 40, 0],   // 野反湖,*四万,佐武流山,*三国峠,*苗場山,*土樽
    [949, 30, 141, 52, 30, 44, 15, 0],   // 幌別山,*羽幌岳,羽幌貯水池,*ピッシリ山,*正修,*遠別川上流
    [950, 30, 136, 45, 0, 36, 0, 0],   // 二ノ峰,*新淵,白山,*御母衣,新岩間温泉,*平瀬
    [951, 30, 140, 30, 0, 41, 40, 0],   // 当別,立待岬,*茂辺地,*函館,*陣屋,*七飯
    [952, 30, 145, 45, 0, 43, 20, 0],   // 納沙布
    [953, 30, 135, 15, 0, 33, 30, 0],   // *紀伊日置,鴨居,*富田,*紀伊白浜,*紀伊田辺
    [954, 30, 140, 0, 0, 39, 0, 0],   // 湯ノ台,*丁岳,鳥海山,*中直根,*川辺,*矢島
    [955, 30, 143, 37, 30, 44, 5, 0],   // *芭露,サロマ湖,*登栄床,三里浜
    [956, 30, 124, 0, 0, 24, 15, 0],   // 竹富島,竹富島,石垣,*石垣,川平,*伊野田
    [957, 30, 142, 30, 0, 44, 50, 0],   // *下幌別,徳志別,*枝幸,目梨泊
    [958, 30, 144, 15, 0, 43, 55, 0],   // *藻琴,浜小清水,*網走,能取岬
    [959, 30, 141, 37, 30, 44, 5, 0],   // 港町,*ルペシュペナイ川,*力昼,*三渓,*苫前,*上羽幌
    [960, 30, 134, 15, 0, 35, 35, 0],   // 田後,*浜坂
    [961, 30, 143, 7, 30, 42, 10, 0],   // 広尾岳,音調津,*札楽古,*広尾,*中豊似,*豊似
    [962, 30, 135, 30, 0, 33, 25, 0],   // 江住,田並,*江住,*三尾川,*市鹿野,*下露
    [963, 30, 141, 37, 30, 43, 30, 0],   // 南幌加,*総進,*吉野,*石狩大和,*国領,*恵岱別
    [964, 30, 141, 37, 30, 45, 25, 0],   // 野寒布岬,富磯
    [965, 30, 130, 37, 30, 33, 55, 0],   // 岩屋,*六連島,白島,六連島,蓋井島
    [966, 30, 136, 22, 30, 34, 5, 0],   // 錦,見江島,*古和浦,*贄浦
    [967, 30, 129, 45, 0, 33, 30, 0],   // 波戸岬,*呼子,加唐島,小川島,*印通寺,烏帽子島
    [968, 30, 143, 22, 30, 42, 20, 0],   // 豊似,浜大樹,*晩成,*湧洞沼南部
    [969, 30, 139, 37, 30, 38, 10, 0],   // 三面,*徳網,円吾山,*相模山,鳴海山,大鳥池
    [970, 30, 142, 52, 30, 43, 25, 0],   // トムラウシ山,ニペソツ山,五色ヶ原,*石狩岳,白雲岳,*大雪湖
    [971, 30, 138, 52, 30, 36, 55, 0],   // 巻機山,奥利根湖,*六日町,*兎岳,*五日町,*八海山
    [972, 30, 129, 22, 30, 34, 40, 0],   // 泉
    [973, 30, 144, 45, 0, 42, 55, 0],   // 尻羽岬,床潭,*厚岸,*厚岸湖,*釧路太田,*糸魚沢
    [974, 30, 145, 7, 30, 44, 5, 0],   // *硫黄山,岬,ルシャ川,知床岳,知床岬,知床岬
    [975, 30, 142, 0, 0, 26, 30, 0],   // 母島南部,母島南部,母島北部,母島北部,母島北部
    [976, 30, 144, 45, 0, 43, 35, 0],   // 第二俣落,*武佐,俣落岳,*武佐岳,*瑠辺斯岳,*西古多糠
    [977, 30, 139, 15, 0, 34, 25, 0],   // 鵜渡根島,利島
    [978, 30, 135, 7, 30, 35, 45, 0],   // 丹後中浜,丹後中浜
    [979, 30, 139, 0, 0, 35, 50, 0],   // 武蔵日原,*原市場,*秩父,*正丸峠,*皆野,*安戸
    [980, 30, 141, 52, 30, 45, 10, 0],   // 下豊別,*エタンパック山,*曲淵,*鬼志別,*モイマ山,*知来別
    [981, 30, 140, 0, 0, 42, 30, 0],   // メップ岳,二股温泉,*賀老,*大平山,*永豊,*本目
    [982, 30, 136, 52, 30, 34, 30, 0],   // 答志,伊良湖岬,*福江,*師崎,*佐久島
    [983, 30, 141, 7, 30, 42, 20, 0],   // 登別温泉,*登別温泉,登別温泉,*飛生,*白老
    [984, 30, 136, 37, 30, 37, 0, 0],   // 能登福浦,*能登高浜,*富来,*中島,*剣地,*下唐川
    [985, 30, 142, 37, 30, 42, 25, 0],   // *セタウシ山,ピリガイ山,日高大山,ヤオロマップ岳,イドンナップ岳,札内川上流   札内川上流
    [986, 30, 135, 0, 0, 34, 0, 0],   // 箕島,*湯浅,*初島町,*海南,*加太,*和歌山
    [987, 30, 139, 7, 30, 38, 25, 0],   // 粟島,粟島
    [988, 30, 141, 22, 30, 39, 25, 0],   // 竪沢,*大出,*早池峰山,*高桧山,*松草,*陸中川内
    [989, 30, 141, 0, 0, 42, 55, 0],   // 無意根山,*定山渓,*余市岳,*手稲山,*張碓,*銭函
    [990, 30, 127, 7, 30, 26, 30, 0],   // 粟国島,*粟国島,粟国島,*粟国島
    [991, 30, 144, 7, 30, 44, 5, 0],   // 能取岬,*能取岬
    [992, 30, 139, 45, 0, 32, 25, 0],   // 八丈青ヶ島
    [993, 30, 140, 22, 30, 42, 0, 0],   // 狗神岳,*姫川,*濁川,*渡島森,*落部
    [994, 30, 140, 30, 0, 40, 0, 0],   // 太平湖,サンケ森,*明利又,*大葛,*扇田,*十二所
    [995, 30, 129, 52, 30, 30, 45, 0],   // 薩摩黒島,薩摩黒島
    [996, 30, 130, 22, 30, 30, 10, 0],   // 栗生,*栗生,*栗生,*尾之間,*永田岳,*宮之浦岳
    [997, 30, 131, 7, 30, 34, 35, 0],   // 見島
    [998, 30, 141, 52, 30, 45, 30, 0],   // 宗谷岬
    [999, 30, 140, 22, 30, 39, 40, 0],   // 羽後庄内,*下桧木内,*番鳥森,*上桧木内,*比立内,*戸鳥内
    [1000, 30, 135, 30, 0, 35, 30, 0],   // 難波江,*鋸崎
    [1001, 30, 142, 52, 30, 42, 15, 0],   // 日高幌別川上流,楽古岳,*ピリカヌプリ,*トヨニ岳,*神威岳,*ヌビナイ川上流ナイ川上流
    [1002, 30, 139, 52, 30, 40, 5, 0],   // 羽後浜田,*森岳,能代,*能代,*羽後水沢
    [1003, 30, 137, 22, 30, 34, 35, 0],   // 高塚,*二川,*新居町,*豊橋,*三ヶ日
    [1004, 30, 138, 0, 0, 36, 45, 0],   // 高妻山,*信濃柏原,*妙高山,*赤倉,*湯川内,*関山
    [1005, 30, 127, 30, 0, 26, 15, 0],   // 慶伊瀬島,*大謝名,*高志保,残波岬
    [1006, 30, 131, 30, 0, 32, 0, 0],   // 日向日置,*高鍋,*川南
    [1007, 30, 137, 52, 30, 34, 35, 0],   // 向岡,*千浜,*袋井,*下平川,*山梨,*掛川
    [1008, 30, 139, 7, 30, 36, 55, 0],   // 尾瀬ヶ原,*燧ヶ岳,平ガ岳,*会津駒ヶ岳,*奥只見湖,*高幽山
    [1009, 30, 142, 45, 0, 44, 20, 0],   // 奥興部,*上興部,*毛鐘尻山,*トーウツ岳,*上雄武,*雄武
    [1010, 30, 142, 30, 0, 42, 35, 0],   // 新冠湖,*イドンナップ岳,ヌカンライ岳,幌尻岳,二岐岳,ピパイロ岳
    [1011, 30, 140, 0, 0, 40, 45, 0],   // 田野沢,*鰺ヶ沢
    [1012, 30, 130, 7, 30, 31, 40, 0],   // 荒川浜,*串木野,*羽島,*川内,*西方,*東郷
    [1013, 30, 133, 15, 0, 36, 10, 0],   // *都万,西郷,*隠岐北方,布施,西村
    [1014, 30, 131, 22, 30, 33, 55, 0],   // 竹島,*佐波島,*台道,*防府,*小郡,*矢田
    [1015, 30, 129, 45, 0, 29, 45, 0],   // 中之島,中之島,中之島,中之島,口之島
    [1016, 30, 128, 45, 0, 32, 30, 0],   // 坪,黄島,*富江,崎山,*五島福江,螺蠑島
    [1017, 30, 131, 0, 0, 34, 25, 0],   // 長門古市,青海島北部
    [1018, 30, 123, 45, 0, 24, 0, 0],   // 波照間島,*西表大原,黒島
    [1019, 30, 140, 52, 30, 39, 0, 0],   // 鳴沢温泉,*古戸,*石淵ダム,*供養塚,*夏油温泉,*金ヶ崎
    [1020, 30, 141, 45, 0, 39, 30, 0],   // 高滝森,*津軽石,*茂市,*宮古,*峠ノ神山,*田老
    [1021, 30, 138, 15, 0, 34, 40, 0],   // 相良,*住吉,*焼津
    [1022, 30, 131, 37, 30, 34, 40, 0],   // 飯浦,*益田,*高島,高島
    [1023, 30, 134, 15, 0, 33, 25, 0],   // 伏越ノ鼻,*甲浦,*奥浦,*牟岐
    [1024, 30, 133, 15, 0, 34, 5, 0],   // 魚島,伊吹島,魚島,百貫島,*宇治島
    [1025, 30, 133, 0, 0, 35, 35, 0],   // 瀬崎,瀬崎
    [1026, 30, 132, 0, 0, 33, 0, 0],   // 保戸島,*水ノ子島,保戸島,*日振島,*戸島
    [1027, 30, 134, 7, 30, 33, 10, 0],   // 室戸岬,*室戸岬,*佐喜浜
    [1028, 30, 139, 30, 0, 39, 10, 0],   // 飛島
    [1029, 30, 140, 22, 30, 43, 0, 0],   // 後志泊,*茅沼,*神恵内,*稲倉石,*ポンネアンチシ山,*両古美山
    [1030, 30, 130, 0, 0, 33, 35, 0],   // 芥屋,*宮浦,玄界島
    [1031, 30, 130, 7, 30, 30, 25, 0],   // 口永良部島,口永良部島
    [1032, 30, 140, 52, 30, 41, 0, 0],   // 小湊,*脇野沢,*陸奥川内,*戸沢
    [1033, 30, 142, 7, 30, 42, 10, 0],   // 東静内,静内,*静内
    [1034, 30, 142, 30, 0, 42, 30, 0],   // 岩清水,*日高大山,*新冠湖,*イドンナップ岳,*ヌカンライ岳,*幌尻岳岳
    [1035, 30, 124, 0, 0, 24, 10, 0],   // 黒島,*竹富島,*竹富島,*石垣,*石垣
    [1036, 30, 124, 15, 0, 24, 35, 0],   // 平久保崎
    [1037, 30, 138, 7, 30, 35, 45, 0],   // 甲斐駒ヶ岳,*長坂上条,*信濃富士見,*小淵沢,*茅野,*八ヶ岳西部
    [1038, 30, 139, 0, 0, 34, 40, 0],   // 下田,*稲取,*天城山,*富戸
    [1039, 30, 139, 15, 0, 38, 5, 0],   // 坂町,*坂町,*村上,*柏尾
    [1040, 30, 143, 30, 0, 44, 15, 0],   // 沼上浜
    [1041, 30, 141, 15, 0, 24, 40, 0],   // 硫黄島,硫黄島,*硫黄島
    [1042, 30, 133, 30, 0, 34, 5, 0],   // 伊吹島,*観音寺,*紫雲出山,*仁尾,*六島,*讃岐粟島
    [1043, 30, 145, 15, 0, 43, 5, 0],   // 厚床,落石岬,*厚床,*別当賀,*風蓮,*東梅
    [1044, 30, 134, 22, 30, 34, 15, 0],   // 引田
    [1045, 30, 140, 15, 0, 41, 15, 0],   // 龍飛崎,*渡島福島
    [1046, 30, 134, 37, 30, 34, 0, 0],   // 阿波富岡,板東,諭鶴羽山,*鳴門海峡,*諭鶴羽山
    [1047, 30, 123, 30, 0, 24, 10, 0],   // 仲御神島,*ウビラ石,舟浮,船浦
    [1048, 30, 139, 45, 0, 40, 35, 0],   // 深浦,*深浦,*驫木
    [1049, 30, 142, 45, 0, 42, 20, 0],   // 元浦川上流,*ピリカヌプリ,*ピリガイ山,*神威岳,*ヤオロマップ岳,*ポンヤオロマップ岳ポンヤオロマップ岳
    [1050, 30, 132, 45, 0, 32, 40, 0],   // 下川口,*足摺岬,*下川口,*土佐清水,*来栖野,*下ノ加江
    [1051, 30, 129, 7, 30, 29, 5, 0],   // 宝島,小宝島
    [1052, 30, 129, 30, 0, 29, 25, 0],   // 悪石島,諏訪瀬島
    [1053, 30, 132, 22, 30, 33, 40, 0],   // 伊予青島,上灘,大水無瀬島,*周防小泊,*由利島
    [1054, 30, 145, 7, 30, 43, 40, 0],   // 伊茶仁
    [1055, 30, 128, 15, 0, 26, 35, 0],   // 高江,*安波
    [1056, 30, 129, 15, 0, 27, 55, 0],   // 秋徳,秋徳,*古仁屋,節子
    [1057, 30, 138, 37, 30, 34, 40, 0],   // 伊豆松崎,*伊豆松崎,*仁科,*仁科,*土肥
    [1058, 30, 129, 15, 0, 32, 55, 0],   // 肥前江島,肥前江島,*大立島,野子,帆上ノ瀬
    [1059, 30, 129, 30, 0, 33, 5, 0],   // 肥前黒島,*佐世保南部,*楠泊,*佐世保北部,*肥前川内,*江迎
    [1060, 30, 133, 37, 30, 34, 25, 0],   // 水島港,*下津井,*玉島,*茶屋町,*箭田,*倉敷
    [1061, 30, 142, 37, 30, 42, 50, 0],   // ペンケヌーシ岳,*芽室岳,*沙流岳,*十勝石山,*上トマム,*新得
    [1062, 30, 129, 22, 30, 34, 15, 0],   // 鶏知,仁位,*志多賀
    [1063, 30, 140, 45, 0, 39, 35, 0],   // 羽後朝日岳,*鶯宿,*国見温泉,*雫石,*秋田駒ヶ岳,*篠崎
    [1064, 30, 130, 15, 0, 30, 45, 0],   // 薩摩硫黄島,薩摩竹島
    [1065, 30, 143, 0, 0, 44, 15, 0],   // 欝岳,*中宇津々,*秋里,*豊野,*興部,*沙留
    [1066, 30, 131, 15, 0, 34, 25, 0],   // 通,*越ヶ浜,相島,*櫃島
    [1067, 30, 136, 37, 30, 37, 20, 0],   // 皆月,*皆月,*七ツ島
    [1068, 30, 136, 0, 0, 36, 10, 0],   // 三国,*三国,北潟,*北潟
    [1069, 30, 137, 37, 30, 36, 15, 0],   // 穂高岳,*信濃小倉,槍ヶ岳,*有明,*烏帽子岳,*大町南部
    [1070, 30, 141, 37, 30, 44, 25, 0],   // 天塩有明,*天塩有明,*初山別,*歌越
    [1071, 30, 129, 30, 0, 29, 40, 0],   // 平島,諏訪瀬島,臥蛇島
    [1072, 30, 125, 7, 30, 24, 40, 0],   // 上地,*上地,*伊良部島,*平良,*伊良部島,*西平安名岬
    [1073, 30, 139, 30, 0, 37, 45, 0],   // 蒜場山,*大日岳,*二王子岳,*飯豊山,*エブリ差岳,*長者原
    [1074, 30, 142, 22, 30, 44, 40, 0],   // 屋根棟山,*上徳志別,*本幌別,*志美宇丹,*歌登,*下幌別
    [1075, 30, 153, 52, 30, 24, 15, 0],   // 南鳥島
    [1076, 30, 127, 52, 30, 26, 5, 0],   // 久高島,*津堅,*屋慶名
    [1077, 30, 128, 52, 30, 27, 35, 0],   // 伊仙崎,*伊仙,*亀津,*平土野,*ジャナレ島
    [1078, 30, 144, 30, 0, 43, 55, 0],   // 止別,*斜里
    [1079, 30, 129, 52, 30, 32, 5, 0],   // 片島,*指江,魚貫崎,*牛深,*大江,*河浦
    [1080, 30, 141, 15, 0, 43, 25, 0],   // *濃昼,柏木,*柏木,*幌,*浜益
    [1081, 30, 129, 7, 30, 28, 0, 0],   // 与路,*秋徳,*瀬武,*古仁屋,*西古見,*奄美久慈
    [1082, 30, 131, 7, 30, 31, 15, 0],   // 内之浦,*都井岬,*都井岬,*串間,*本城
    [1083, 30, 136, 52, 30, 37, 50, 0],   // 舳倉島
    [1084, 30, 131, 52, 30, 32, 30, 0],   // 深島
    [1085, 30, 139, 15, 0, 41, 25, 0],   // 渡島大島,渡島大島,渡島大島,渡島大島
    [1086, 30, 129, 37, 30, 32, 30, 0],   // 野母崎,*野母,端島,*肥前高島,*長崎西南部
    [1087, 30, 127, 15, 0, 26, 5, 0],   // 阿波連岬,*座間味,前島,前島
    [1088, 30, 128, 15, 0, 31, 55, 0],   // 男島及女島,*男島及女島,男島及女島,男島及女島
    [1089, 30, 132, 7, 30, 32, 40, 0],   // 鵜来島,*沖黒島
    [1090, 30, 132, 22, 30, 35, 20, 0],   // *大社,*日御碕,日御碕
    [1091, 30, 132, 37, 30, 34, 0, 0],   // 安居島,*菊間,上黒島,*大浜,*仁方,*大長
    [1092, 30, 140, 37, 30, 42, 15, 0],   // *伊達
    [1093, 30, 142, 0, 0, 27, 30, 0],   // *嫁島,媒島,聟島,聟島
    [1094, 30, 132, 7, 30, 33, 40, 0],   // 周防八島,*平郡島,*平郡島東部,*阿月,*安下庄
    [1095, 30, 123, 22, 30, 25, 40, 0],   // 魚釣島,魚釣島,*魚釣島
    [1096, 30, 123, 37, 30, 25, 50, 0],   // 黄尾嶼,黄尾嶼
    [1097, 30, 126, 52, 30, 26, 20, 0],   // 久米島東部,渡名喜島
    [1098, 30, 128, 52, 30, 28, 45, 0],   // 横当島,横当島
    [1099, 30, 128, 52, 30, 33, 5, 0],   // 肥前赤島,*津和崎,肥前赤島,*小値賀島,*宇久島
    [1100, 30, 129, 22, 30, 30, 45, 0],   // 草垣群島,草垣群島
    [1101, 30, 129, 22, 30, 31, 5, 0],   // 宇治群島,*宇治群島,宇治群島,*宇治群島
    [1102, 30, 130, 0, 0, 31, 20, 0],   // 野間岳,*野間岳,片浦,*片浦,*久多島
    [1103, 30, 130, 45, 0, 30, 40, 0],   // 馬毛島,*西之表,馬毛島
    [1104, 30, 131, 45, 0, 32, 20, 0],   // 
    [1105, 30, 132, 15, 0, 34, 0, 0],   // 伊勢小島,*柱島,甲島,*大君,*阿多田島,*江田島
    [1106, 30, 134, 45, 0, 33, 45, 0],   // 伊島,伊島
    [1107, 30, 136, 45, 0, 37, 35, 0],   // 七ツ島,七ツ島
    [1108, 30, 140, 0, 0, 41, 50, 0],   // 江差,*江差,乙部,*乙部,*相沼,*ササマクリ山
    [1109, 30, 140, 22, 30, 42, 20, 0],   // 国縫,*長万部,*礼文華
    [1110, 30, 141, 15, 0, 25, 20, 0],   // 北硫黄島,北硫黄島
    [1111, 30, 142, 0, 0, 39, 40, 0],   // 田老,田老鉱山
    [1112, 30, 124, 30, 0, 25, 55, 0],   // 赤尾嶼
    [1113, 30, 126, 45, 0, 26, 35, 0],   // 鳥島
    [1114, 30, 127, 7, 30, 26, 5, 0],   // 久場島,*阿波連岬,*久場島,*座間味
    [1115, 30, 127, 30, 0, 26, 10, 0],   // 慶伊瀬島,*那覇,*慶伊瀬島,*大謝名,*高志保
    [1116, 30, 128, 0, 0, 26, 25, 0],   // 金武,*瀬嵩,*天仁屋,*仲尾次,*国頭平良
    [1117, 30, 128, 7, 30, 27, 50, 0],   // 硫黄鳥島
    [1118, 30, 128, 45, 0, 32, 50, 0],   // 漁生浦,*漁生浦,*串島
    [1119, 30, 129, 0, 0, 32, 40, 0],   // 佐尾,*佐尾,*奈良尾,*友住
    [1120, 30, 129, 37, 30, 33, 30, 0],   // 波戸岬,*波戸岬,*加唐島,*郷ノ浦,*印通寺
    [1121, 30, 129, 52, 30, 30, 0, 0],   // 口之島,*吐カ喇平瀬
    [1122, 30, 130, 0, 0, 33, 50, 0],   // 小呂島
    [1123, 30, 130, 0, 0, 34, 10, 0],   // 沖島,*沖島
    [1124, 30, 130, 0, 0, 34, 35, 0],   // 
    [1125, 30, 131, 7, 30, 24, 25, 0],   // 沖大東島
    [1126, 30, 131, 22, 30, 34, 40, 0],   // *須佐
    [1127, 30, 131, 52, 30, 34, 50, 0],   // 浜田,*浜田,*下府
    [1128, 30, 132, 0, 0, 33, 25, 0],   // 三崎,*三机
    [1129, 30, 132, 22, 30, 32, 40, 0],   // 鵜来島,*母島,*鵜来島,*母島,*高茂岬,*福浦
    [1130, 30, 132, 52, 30, 35, 35, 0],   // *瀬崎
    [1131, 30, 133, 7, 30, 36, 0, 0],   // 崎,*菱浦,*都万,*都万,*都万
    [1132, 30, 133, 15, 0, 34, 0, 0],   // 新居浜,*魚島,*伊吹島,*魚島
    [1133, 30, 133, 45, 0, 35, 30, 0],   // 倉吉,*青谷
    [1134, 30, 134, 30, 0, 35, 40, 0],   // 余部
    [1135, 30, 135, 15, 0, 34, 30, 0],   // 堺,*堺,*大阪西南部,*西宮,*大阪西北部
    [1136, 30, 135, 45, 0, 33, 20, 0],   // *串本,*古座,*下里
    [1137, 30, 135, 45, 0, 35, 45, 0],   // *糠,*梅浦
    [1138, 30, 136, 22, 30, 36, 30, 0],   // 松任,*松任,*金石
    [1139, 30, 137, 37, 30, 36, 45, 0],   // 黒薙温泉,*白馬岳,*小川温泉,*越後平岩,*親不知,*小滝
    [1140, 30, 138, 22, 30, 38, 20, 0],   // 鷲崎
    [1141, 30, 139, 0, 0, 34, 10, 0],   // 神津島,*神津島,*式根島,*新島
    [1142, 30, 139, 30, 0, 42, 15, 0],   // 奥尻
    [1143, 30, 139, 45, 0, 41, 20, 0],   // 小島,*江良
    [1144, 30, 140, 0, 0, 41, 20, 0],   // 松前,*白神岬,*松前,*渡島吉岡,*江良,*大千軒岳
    [1145, 30, 140, 15, 0, 30, 25, 0],   // 鳥島
    [1146, 30, 140, 30, 0, 41, 15, 0],   // 
    [1147, 30, 140, 52, 30, 27, 10, 0],   // 西之島
    [1148, 30, 140, 52, 30, 35, 35, 0],   // *銚子
    [1149, 30, 141, 0, 0, 38, 10, 0],   // 塩竈,*塩竈,*宮戸島,*松島,*小野
    [1150, 30, 141, 7, 30, 41, 5, 0],   // 有畑,*有畑,*城ヶ沢,*近川,*むつ,*蒲野沢
    [1151, 30, 141, 22, 30, 24, 10, 0],   // 南硫黄島
    [1152, 30, 141, 37, 30, 38, 45, 0],   // 津谷,*唐桑,*陸前広田
    [1153, 30, 141, 37, 30, 40, 30, 0],   // 
    [1154, 30, 141, 52, 30, 40, 5, 0],   // 陸中野田
    [1155, 30, 142, 0, 0, 39, 20, 0],   // 霞露ヶ岳,*霞露ヶ岳,*トドヶ崎
    [1156, 30, 142, 7, 30, 27, 25, 0],   // 嫁島,*嫁島,*媒島
    [1157, 30, 142, 15, 0, 45, 15, 0],   // 猿払
    [1158, 30, 142, 45, 0, 44, 45, 0],   // 乙忠部
    [1159, 30, 144, 0, 0, 42, 50, 0],   // 白糠,*白糠,*庶路,*中庶路,*山花
    [1160, 30, 145, 15, 0, 44, 20, 0],   // 知床岬
    [1161, 30, 145, 30, 0, 43, 5, 0]    // 落石岬,*落石,*根室南部,*友知
  ]
};

export const Range = {
  Area: [
    [0, 502650, 127800, 503550, 128700],   // 川崎,東京国際空港,東京西南部,東京南部,東京西部,東京首部
    [1, 487350, 124500, 488250, 125400],   // 大阪西南部,大阪東南部,大阪西北部,大阪東北部,伊丹,吹田
    [2, 501750, 127500, 502650, 128400],   // 座間,横浜西部,原町田,荏田,武蔵府中,溝口
    [3, 502650, 128700, 503550, 129600],   // 赤羽,草加,浦和,越谷,岩槻,野田市
    [4, 492300, 126300, 493200, 127200],   // 蟹江,名古屋南部,清洲,名古屋北部,一宮,小牧
    [5, 501750, 128400, 502650, 129300],   // 立川,吉祥寺,所沢,志木,川越南部,与野
    [6, 503550, 128100, 504450, 129000],   // 浦安,千葉西部,船橋,習志野,松戸,白井
    [7, 488250, 125400, 489150, 126300],   // 淀,宇治,京都西南部,京都東南部,京都西北部,京都東北部
    [8, 502200, 126900, 503100, 127800],   // 鎌倉,横須賀,戸塚,本牧,*横浜西部,横浜東部
    [9, 508500, 154500, 509400, 155400],   // 石山,清田,札幌,札幌東部,札幌北部,札幌東北部
    [10, 487350, 123600, 488250, 124500],   // 内畑,岩湧山,岸和田東部,富田林,堺,古市
    [11, 488250, 124500, 489150, 125400],   // 信貴山,大和郡山,生駒山,奈良,枚方,田辺
    [12, 486450, 124500, 487350, 125400],   // 神戸南部,神戸首部,西宮,有馬,宝塚
    [13, 468900, 120600, 469800, 121500],   // 福岡西南部,福岡南部,福岡西部,福岡,志賀島,古賀
    [14, 501750, 129300, 502650, 130200],   // 川越北部,上尾,東松山,鴻巣,熊谷,加須
    [15, 501300, 126900, 502200, 127800],   // 平塚,江の島,伊勢原,藤沢,厚木,*座間
    [16, 470700, 121500, 471600, 122400],   // 徳力,苅田,八幡,小倉,六連島,下関
    [17, 492750, 125400, 493650, 126300],   // 半田,西尾,刈谷,安城,鳴海,知立
    [18, 503550, 129000, 504450, 129900],   // 流山,取手,守谷,藤代,水海道,谷田部
    [19, 481500, 123900, 482400, 124800],   // 下津井,宇野,茶屋町,八浜,倉敷,岡山南部
    [20, 500400, 130200, 501300, 131100],   // 藤岡,本庄,高崎,伊勢崎,前橋,大胡
    [21, 506700, 137100, 507600, 138000],   // 岩沼,仙台空港,仙台西南部,仙台東南部,仙台西北部,仙台東北部
    [22, 476550, 123600, 477450, 124500],   // 広島,海田市,祇園,中深川,飯室,可部
    [23, 500850, 128100, 501750, 129000],   // 与瀬,八王子,五日市,拝島,武蔵御岳,青梅
    [24, 484650, 125100, 485550, 126000],   // 姫路南部,加古川,姫路北部,笠原,前之庄,北条
    [25, 497700, 125400, 498600, 126300],   // 焼津,静岡西部,静岡東部,牛妻,清水
    [26, 495450, 124800, 496350, 125700],   // 浜松,磐田,気賀,笠井,伊平,二俣
    [27, 504450, 127800, 505350, 128700],   // 蘇我,東金,千葉東部,八街,佐倉,酒々井
    [28, 491850, 126900, 492750, 127800],   // 竹鼻,*一宮,岐阜西部,岐阜,北方,岐阜北部
    [29, 470250, 117600, 471150, 118500],   // 宇土,御船,熊本,健軍,植木,肥後大津
    [30, 493200, 126000, 494100, 126900],   // *知立,豊田南部,平針,豊田北部,瀬戸,猿投山
    [31, 485550, 124500, 486450, 125400],   // 明石,須磨,東二見,前開,三木,淡河
    [32, 500400, 135600, 501300, 136500],   // 矢代田,村松,白根,新津,新潟南部,水原
    [33, 459450, 94200, 460350, 95100],   // 那覇,与那原,大謝名,沖縄市南部,高志保,沖縄市北部
    [34, 501300, 130200, 502200, 131100],   // 深谷,妻沼,上野境,足利南部,桐生,足利北部
    [35, 486450, 123000, 487350, 123900],   // 和歌山,丸栖,淡輪,岩出,尾崎,樽井
    [36, 488250, 123600, 489150, 124500],   // 五條,吉野山,御所,畝傍山,大和高田,桜井
    [37, 469350, 119400, 470250, 120300],   // 羽大塚,八女,久留米西部,久留米,中原,鳥栖
    [38, 491400, 125400, 492300, 126300],   // 鈴鹿,南五味塚,四日市西部,四日市東部,菰野,桑名
    [39, 503550, 131100, 504450, 132000],   // 上三川,真岡,宇都宮東部,祖母井,宝積寺,仁井田
    [40, 493200, 131700, 494100, 132600],   // 宮森新,速星,高岡,富山,伏木,富山港
    [41, 491400, 131100, 492300, 132000],   // 粟生,鶴来,松任,金沢,金石,栗崎
    [42, 469800, 113700, 470700, 114600],   // 鹿児島北部,桜島北部,脇元,加治木,蒲生,石原
    [43, 494550, 124800, 495450, 125700],   // 二川,新居町,豊橋,三ヶ日,新城,三河富岡
    [44, 467550, 117600, 468450, 118500],   // 長崎東南部,諫早南部,長崎東北部,諫早南部,大村,諫早
    [45, 502650, 129600, 503550, 130500],   // 久喜,宝珠花,栗橋,下総境,古河,諸川
    [46, 472950, 119400, 473850, 120300],   // 小野屋,大,,別府西部,別府東部,豊後豊岡,杵築
    [47, 505350, 130800, 506250, 131700],   // 水戸,那珂湊,石塚,常陸久慈,常陸大宮,常陸太田
    [48, 479250, 123600, 480150, 124500],   // 尾道,常石,三成,福山西部,府中,新市
    [49, 503550, 126900, 504450, 127800],   // 鹿野山,久留里,木更津,上総横田,奈良輪,姉崎
    [50, 499500, 126300, 500400, 127200],   // 沼津,三島,愛鷹山,裾野,印野,御殿場
    [51, 493650, 125100, 494550, 126000],   // 蒲郡,小坂井,幸田,御油,岡崎,三河宮崎
    [52, 487350, 125400, 488250, 126300],   // 広根,高槻,妙見山,法貴,埴生,亀岡
    [53, 477450, 121500, 478350, 122400],   // 郡中,松山南部,三津浜,松山北部,伊予小浜,伊予北条
    [54, 497250, 131700, 498150, 132600],   // 長野,須坂,若槻,中野西部,信濃柏原,替佐
    [55, 469800, 120300, 470700, 121200],   // 二日市,甘木,太宰府,大隈,篠栗,飯塚
    [56, 483750, 122400, 484650, 123300],   // 石井,徳島,大寺,板東,引田,撫養
    [57, 500400, 126600, 501300, 127500],   // 箱根,小田原南部,関本,小田原北部,山北,秦野
    [58, 499500, 134700, 500400, 135600],   // 長岡,栃尾,与板,見附,寺泊,三条
    [59, 498600, 127800, 499500, 128700],   // 市川大門,河口湖西部,甲府,石和,甲府北部,塩山
    [60, 482400, 123000, 483300, 123900],   // 川東,鹿庭,高松南部,志,,高松北部,五剣山
    [61, 504900, 133800, 505800, 134700],   // 矢吹,母畑,須賀川西部,須賀川東部,郡山西部,郡山
    [62, 504900, 137700, 505800, 138600],   // 山形北部,山寺,寒河江,天童,谷地,楯岡
    [63, 490050, 129300, 490950, 130200],   // 鯖江,河和田,福井,永平寺,越前森田,丸岡
    [64, 502200, 130200, 503100, 131100],   // 館林,*古河,佐野,下野藤岡,田沼,栃木
    [65, 504450, 129000, 505350, 129900],   // 龍ヶ崎,下総滑川,牛久,江戸崎,土浦,木原
    [66, 472500, 114600, 473400, 115500],   // 田野,宮崎,日向本庄,宮崎北部,岩崎,佐土原
    [67, 489600, 125700, 490500, 126600],   // 三雲,水口,野洲,日野西部,近江八幡,八日市
    [68, 469800, 121200, 470700, 122100],   // 脇田,直方,筑前東郷,中間,吉木,折尾
    [69, 469350, 118500, 470250, 119400],   // 荒尾,玉名,大牟田,関町,柳川,野町
    [70, 492750, 127200, 493650, 128100],   // 犬山,小泉,美濃関,美濃加茂,美濃,上麻生
    [71, 505350, 146100, 506250, 147000],   // 弘前,黒石,板柳,浪岡,五所川原,大釈迦
    [72, 498600, 126300, 499500, 127200],   // 蒲原,吉原,富士宮,入山瀬,上井出,天母山
    [73, 480600, 120600, 481500, 121500],   // 高知,後免,土佐山,土佐山田,田井,繁藤
    [74, 503100, 130500, 504000, 131400],   // 小山,下館,小金井,久下田,壬生,*上三川
    [75, 496350, 129600, 497250, 130500],   // 北小野,諏訪,塩尻,鉢伏山,松本,山辺
    [76, 505350, 135900, 506250, 136800],   // 福島北部,保原,中茂庭,桑折,関,白石南部
    [77, 481050, 122700, 481950, 123600],   // 観音寺,福良見,仁尾,善通寺,讃岐粟島,丸亀
    [78, 491400, 126600, 492300, 127500],   // 駒野,津島,養老,*竹鼻,大垣,*岐阜西部
    [79, 512100, 157200, 513000, 158100],   // 雨紛,西神楽,旭川,永山,鷹栖,比布
    [80, 490950, 124200, 491850, 125100],   // 大河内,松阪,大仰,松阪港,津西部,津東部
    [81, 507600, 142200, 508500, 143100],   // 志和,日詰,南昌山,矢幅,小岩井農場,盛岡
    [82, 506700, 132900, 507600, 133800],   // 磐城泉,小名浜,常磐湯本,平,水石山,四倉
    [83, 496800, 124500, 497700, 125400],   // 千浜,御前崎,下平川,相良,掛川,島田
    [84, 508500, 145800, 509400, 146700],   // 五戸,八戸西部,犬落瀬,百石,三沢,浜三沢
    [85, 497700, 130200, 498600, 131100],   // 春日本郷,臼田,丸子,小諸,上田,車坂峠
    [86, 506250, 150300, 507150, 151200],   // 函館,五稜郭,七飯,赤川,大沼公園,横津岳
    [87, 468450, 119400, 469350, 120300],   // 牛津,佐賀南部,小城,佐賀北部,古湯,広滝
    [88, 503550, 142800, 504450, 143700],   // 秋田西部,土崎,船越,大久保
    [89, 466200, 119400, 467100, 120300],   // 楠泊,佐世保北部,肥前川内,江迎,平戸,志佐
    [90, 503100, 139200, 504000, 140100],   // 鶴岡,羽黒山,湯野浜,藤島,酒田南部,余目
    [91, 500850, 129000, 501750, 129900],   // 原市場,飯能,正丸峠,越生,安戸,武蔵小川
    [92, 505800, 128400, 506700, 129300],   // 八日市場,旭,岩部,小南,佐原東部,神栖
    [93, 472950, 122400, 473850, 123300],   // 台道,防府,小郡,矢田,山口,仁保
    [94, 499950, 130500, 500850, 131400],   // 富岡,*高崎,下室田,*前橋,伊香保,渋川
    [95, 472050, 122100, 472950, 123000],   // 宇部,宇部東部,厚狭,阿知須,伊佐,湯ノ口
    [96, 470700, 120600, 471600, 121500],   // 筑前山田,伊良原,田川,豊前本庄,金田,行橋
    [97, 503100, 134700, 504000, 135600],   // 会津高田,若松,坂下,会津広田,喜多方西部,喜多方東部
    [98, 493650, 126900, 494550, 127800],   // 多治見,猿爪,土岐,瑞浪,御嵩,武並
    [99, 506250, 146400, 507150, 147300],   // 王余魚沢,雲谷,青森西部,青森東部,油川,浅虫
    [100, 506250, 131700, 507150, 132600],   // 日立,高萩,磯原,大津
    [101, 490050, 126600, 490950, 127500],   // 能登川,高宮,彦根西部,彦根東部,南浜,長浜
    [102, 477000, 123000, 477900, 123900],   // 呉,仁方,吉浦,安芸内海,*海田市,清水原
    [103, 475650, 123000, 476550, 123900],   // 大竹,阿多田島,玖波,厳島,津田,廿日市
    [104, 467550, 119100, 468450, 120000],   // 嬉野,鹿島,有田,武雄,伊万里,多久
    [105, 508050, 138300, 508950, 139200],   // 広淵,石巻,涌谷,飯野川,西野,登米
    [106, 486900, 123300, 487800, 124200],   // *岩出,粉河,*樽井,*内畑,岸和田西部,*岸和田東部
    [107, 474300, 122100, 475200, 123000],   // 笠戸島,光,徳山,呼坂,須々万本郷,菅野湖
    [108, 507600, 141000, 508500, 141900],   // 金ヶ崎,陸中江刺,北上,口内,花巻,土沢
    [109, 479250, 127200, 480150, 128100],   // 広瀬,母里,揖屋,米子,境港,美保関
    [110, 507150, 137700, 508050, 138600],   // *仙台東北部,塩竈,富谷,松島,吉岡,鹿島台
    [111, 480600, 124200, 481500, 125100],   // 笠岡,玉島,矢掛,箭田,三山,総社西部
    [112, 504450, 129900, 505350, 130800],   // 常陸藤沢,常陸高浜,柿岡,石岡,加波山,岩間
    [113, 509400, 153300, 510300, 154200],   // 苫小牧,勇払,胆振高丘,沼の端,胆振蘭越,千歳
    [114, 483750, 125100, 484650, 126000],   // 相生,網干,二木,龍野,三日月,安志
    [115, 475200, 122100, 476100, 123000],   // 柳井,大畠,上久原,由宇,玖珂,岩国
    [116, 499950, 125700, 500850, 126600],   // 修善寺,伊東,韮山,網代,*三島,熱海
    [117, 471600, 113700, 472500, 114600],   // 末吉,尾平野,都城,山王原,庄内,高城
    [118, 491850, 123600, 492750, 124500],   // 五ヶ所浦,磯部,伊勢,鳥羽,明野,二見
    [119, 478800, 121800, 479700, 122700],   // 伊予小松,西条,壬生川,西条北部,今治東部
    [120, 490500, 130500, 491400, 131400],   // 大聖寺,動橋,片山津温泉,小松,美川
    [121, 503550, 132300, 504450, 133200],   // 矢板,佐久山,西那須野,大田原,関谷,黒磯
    [122, 492300, 131400, 493200, 132300],   // 福光,城端,倶利伽羅,砺波,石動,戸出
    [123, 503550, 129900, 504450, 130800],   // 石下,上郷,下妻,筑波,*下館,真壁
    [124, 514800, 153900, 515700, 154800],   // 上帯広,大正,芽室,帯広南部,祥栄,帯広北部
    [125, 482850, 127200, 483750, 128100],   // 用瀬,因幡郡家,鳥取南部,稲葉山,鳥取北部,浦富
    [126, 497250, 133200, 498150, 134100],   // 重倉山,新井,高田西部,高田東部,直江津,潟町
    [127, 504000, 136500, 504900, 137400],   // 米沢北部,糠野目,羽前小松,赤湯,長井,羽前中山
    [128, 469800, 116700, 470700, 117600],   // 日奈久,坂本,八代,鏡,松合,松橋
    [129, 505350, 134700, 506250, 135600],   // 三春,船引,岩代本宮,岩代小浜,二本松,川俣
    [130, 504450, 126900, 505350, 127800],   // 大多喜,国吉,鶴舞,上総一宮,海士有木,茂原
    [131, 489600, 124500, 490500, 125400],   // 名張,阿保,月ヶ瀬,伊勢路,島ヶ原,上野
    [132, 502650, 131400, 503550, 132300],   // 鹿沼,宇都宮西部,文挾,大谷,今市,下野大沢
    [133, 485550, 125400, 486450, 126300],   // 社,天神,西脇,比延,中村町,谷川
    [134, 477900, 126900, 478800, 127800],   // 稗原,木次,出雲今市,宍道,平田,秋鹿
    [135, 492300, 132600, 493200, 133500],   // 羽咋,氷見,柴垣,能登二宮,能登高浜,七尾
    [136, 473400, 116400, 474300, 117300],   // 山陰,平岩,上井野,日向,川水流,延岡
    [137, 504900, 128100, 505800, 129000],   // *八街,成東,*酒々井,多古,成田,新東京国際空港
    [138, 505350, 141300, 506250, 142200],   // 浅舞,横手,角間川,金沢本町,大曲,六郷
    [139, 509400, 154800, 510300, 155700],   // 野幌,長沼,江別,栗沢,石狩当別,上幌向
    [140, 499500, 133500, 500400, 134400],   // 十日町,五日町,岩沢,小出,小千谷,小平尾
    [141, 507150, 138600, 508050, 139500],   // 古川,小牛田,荒谷,高清水,真坂,築館
    [142, 507600, 140100, 508500, 141000],   // 平泉,一関,古戸,前沢,供養塚,水沢
    [143, 495900, 127800, 496800, 128700],   // 飯田,下市田,安平路山,伊那大島,空木岳,赤穂
    [144, 494100, 131700, 495000, 132600],   // 五百石,大岩,上市,越中大浦,滑川,魚津
    [145, 472050, 120300, 472950, 121200],   // 耶馬渓東部,下市,土佐井,宇佐,中津,和間
    [146, 486450, 122100, 487350, 123000],   // 高家,川原河,湯浅,金屋,海南,動木
    [147, 468900, 113700, 469800, 114600],   // 長里,伊集院,串木野,薩摩郡山,川内,塔之原
    [148, 489150, 125400, 490050, 126300],   // 朝宮,信楽,瀬田,*三雲,草津,*野洲
    [149, 519300, 154500, 520200, 155400],   // 釧路港,釧路,大楽毛,遠矢,下幌呂,細岡
    [150, 500400, 129300, 501300, 130200],   // 秩父,*正丸峠,皆野,*安戸,鬼石,寄居
    [151, 482400, 124500, 483300, 125400],   // 西大寺,牛窓,備前瀬戸,片上,万富,和気
    [152, 491850, 125700, 492750, 126600],   // *四日市東部,大野,*桑名,飛島,弥富,*蟹江
    [153, 481950, 125700, 482850, 126600],   // 下弓削,柵原,津山西部,津山東部,香々美,楢
    [154, 478350, 123000, 479250, 123900],   // 木江,木浦,白水,瀬戸田,竹原,三原
    [155, 486450, 125400, 487350, 126300],   // 三田,武田尾,藍本,木津,篠山,福住
    [156, 506250, 136500, 507150, 137400],   // 白石東南部,角田,大河原,亘理,村田,*岩沼
    [157, 501300, 136200, 502200, 137100],   // 天王,上赤谷,新発田,菅谷,稲荷岡,中条
    [158, 495900, 130500, 496800, 131400],   // 信濃小倉,豊科,有明,明科,大町南部,信濃池田
    [159, 507150, 152100, 508050, 153000],   // 室蘭,室蘭,本輪西,室蘭東北部,稀府,鷲別岳
    [160, 482850, 122400, 483750, 123300],   // 脇町,川島,西赤谷,市場,*鹿庭,三本松
    [161, 499500, 127500, 500400, 128400],   // 富士吉田,御正体山,河口湖東部,都留,笹子,大月
    [162, 505350, 129300, 506250, 130200],   // 麻生,潮来,西蓮寺,武井,常陸玉造,鉾田
    [163, 478350, 127200, 479250, 128100],   // *宍道,玉造,*秋鹿,松江,恵曇,加賀
    [164, 506700, 154800, 507600, 155700],   // 赤井川,阿女鱒岳,仁木,於古発山,余市,小樽西部
    [165, 486000, 126300, 486900, 127200],   // 柏原,宮田,黒井,市島,福知山西部,福知山東部
    [166, 470250, 119400, 471150, 120300],   // 黒木,十籠,草野,千足,田主丸,吉井
    [167, 497700, 128100, 498600, 129000],   // 夜叉神峠,小笠原,鳳凰山,韮崎,長坂上条,若神子
    [168, 477450, 123900, 478350, 124800],   // 安芸西条,白市,井原市,乃美,安芸吉田,敷名
    [169, 496350, 124800, 497250, 125700],   // 袋井,*下平川,山梨,*掛川,森,八高山
    [170, 470700, 112200, 471600, 113100],   // 大根占,半ヶ石,神川,上名,鹿屋,大隅高山
    [171, 496350, 128700, 497250, 129600],   // 伊那宮田,信濃溝口,伊那,高遠,宮木,辰野
    [172, 479700, 121500, 480600, 122400],   // 日ノ浦,土佐小松,別子銅山,弟地,新居浜,東予土居
    [173, 468450, 117300, 469350, 118200],   // 口之津,須川,肥前小浜,雲仙,愛野,島原
    [174, 486900, 126900, 487800, 127800],   // 綾部,和知,梅迫,丹波大町,西舞鶴,東舞鶴
    [175, 470250, 118500, 471150, 119400],   // 来民,菊池,山鹿,八方ヶ岳,高井川,宮ノ尾
    [176, 477000, 119400, 477900, 120300],   // 宇和島,松丸,伊予吉田,近永,卯之町,野村
    [177, 496800, 130800, 497700, 131700],   // 信濃西条,別所温泉,麻績,坂城,稲荷山,信濃松代
    [178, 494550, 127500, 495450, 128400],   // 恵那,中津川,美濃福岡,妻籠,付知,三留野
    [179, 510750, 156600, 511650, 157500],   // 滝川,赤平,江部乙,イルムケップ山,妹背牛,石狩深川
    [180, 510300, 155400, 511200, 156300],   // 岩見沢,三笠,美唄,幾春別,晩生内,茶志内
    [181, 479700, 120000, 480600, 120900],   // 須崎,甲崎,佐川,土佐高岡,越知,伊野
    [182, 467550, 120000, 468450, 120900],   // 徳須恵,相知,唐津,浜崎,呼子,岐志
    [183, 499950, 131400, 500850, 132300],   // 金井,鯉沢,上野中山,沼田,猿ヶ京,後閑
    [184, 486900, 121200, 487800, 122100],   // 紀伊白浜,紀伊田辺,紀伊南部,秋津川,古井,西
    [185, 517950, 157200, 518850, 158100],   // 開成,津別,北見,美幌,端野,緋牛内
    [186, 474300, 118500, 475200, 119400],   // 植松,佐伯,津久見,浅海井,臼杵,無垢島
    [187, 498600, 134100, 499500, 135000],   // 越後野田,法坂,柏崎,塚野山,宮川,西山
    [188, 504450, 130800, 505350, 131700],   // 羽黒,笠間,中飯,徳蔵,茂木,野口
    [189, 481050, 126900, 481950, 127800],   // 蒜山,下鍛冶屋,泰久寺,関金宿,伯耆浦安,倉吉
    [190, 499500, 135600, 500400, 136500],   // 弥彦,越後吉田,角田山,巻,内野,内野
    [191, 493650, 129900, 494550, 130800],   // 三日町,高山,飛騨古川,町方,林,船津
    [192, 489600, 127500, 490500, 128400],   // 海津,竹生島,駄口,木之本,敦賀,中河内
    [193, 509400, 139800, 510300, 140700],   // 気仙沼,唐桑,鹿折,陸前広田,今泉,大船渡
    [194, 485100, 127200, 486000, 128100],   // 八鹿,直見,江原,出石,豊岡,須田
    [195, 470250, 115200, 471150, 116100],   // 吉松,加久藤,大塚,肥後大畑,一勝地,人吉
    [196, 492750, 124500, 493650, 125400],   // 福江,師崎,佐久島,河和,吉田
    [197, 486000, 127800, 486900, 128700],   // 四辻,宮津,峰山,日置,網野,丹後平
    [198, 468900, 112500, 469800, 113400],   // 枕崎,石垣,加世田,知覧,唐仁原,神殿
    [199, 508050, 139200, 508950, 140100],   // 佐沼,米谷,若柳,米川,有壁,千廐南部
    [200, 489600, 128700, 490500, 129600],   // 河野,今庄,糠,武生,織田,*鯖江
    [201, 479700, 124200, 480600, 125100],   // *新市,神辺,金丸,井原,小畠,地頭
    [202, 471150, 119100, 472050, 120000],   // 鯛生,宮原,豊後大野,杖立,日田,天ヶ瀬
    [203, 504000, 133200, 504900, 134100],   // 黒田原,旗宿,那須湯本,白河,新甲子,上小屋
    [204, 476550, 120300, 477450, 121200],   // 八幡浜,東多田,出海,大洲,伊予長浜,串
    [205, 487800, 122700, 488700, 123600],   // 梁瀬,上垣内,高野山,猿谷貯水池,橋本,富貴
    [206, 459900, 95100, 460800, 96000],   // 石川,金武,石川,名護南部,瀬底島,名護
    [207, 480600, 121800, 481500, 122700],   // 佐々連尾山,野鹿池山,伊予三島,伊予新宮,川之江,讃岐豊浜
    [208, 506700, 135300, 507600, 136200],   // 小宮,原町,磐城草野,磐城鹿島,青葉,相馬中村
    [209, 508500, 144600, 509400, 145500],   // 一戸,伊保内,陸奥福岡,陸中軽米,三戸,市野沢
    [210, 485100, 123300, 486000, 124200],   // 広田,由良,都志,洲本,郡家,志筑
    [211, 503100, 125700, 504000, 126600],   // 館山,千倉,那古,安房古川,保田,金束
    [212, 505350, 140400, 506250, 141300],   // 横堀,菅生,湯沢,稲庭,西馬音内,十文字
    [213, 490500, 125100, 491400, 126000],   // 平松,椋本,鈴鹿峠,亀山,土山,伊船
    [214, 506700, 128400, 507600, 129300],   // 銚子,*銚子,鹿島矢田部,神栖
    [215, 507600, 146100, 508500, 147000],   // 法量,十和田,銀南木,七戸,上清水目,乙供
    [216, 470700, 113700, 471600, 114600],   // 牛根境,岩川,国,,財部,日当山,高野
    [217, 484200, 121500, 485100, 122400],   // 阿波由岐,阿部,馬場,橘,立江,阿波富岡
    [218, 497250, 129000, 498150, 129900],   // 信濃富士見,小淵沢,茅野,八ヶ岳西部,南大塩,蓼科
    [219, 472950, 115500, 473850, 116400],   // 妻,高鍋,石河内,川南,尾鈴山,都農
    [220, 494550, 132300, 495450, 133200],   // *魚津,宇奈月,三日市,舟見,青木,泊
    [221, 504450, 139200, 505350, 140100],   // 古口,舟形,羽根沢温泉,新庄,大沢,羽前金山
    [222, 504450, 131700, 505350, 132600],   // 烏山,上小瀬,馬頭,常陸大沢,下野小川,大子
    [223, 504000, 144000, 504900, 144900],   // 鹿渡,小又口,森岳,下岩川,能代,二ツ井
    [224, 468450, 120300, 469350, 121200],   // 雷山,脊振山,前原,*福岡西南部,宮浦,*福岡西部
    [225, 504900, 132900, 505800, 133800],   // 八溝山,塙,磐城金山,棚倉,泉崎,磐城石川
    [226, 468900, 115200, 469800, 116100],   // 出水,宮之元,米ノ津,湯出,水俣,水俣
    [227, 471150, 114600, 472050, 115500],   // 高千穂峰,高崎新田,日向小林,高原,日向大久保,須木
    [228, 481950, 122400, 482850, 123300],   // 辻,貞光,内田,讃岐塩工,滝宮,*川東
    [229, 505350, 144300, 506250, 145200],   // 桂瀬,明利又,鷹巣東部,扇田,早口,大館
    [230, 509400, 154200, 510300, 155100],   // 恵庭,長都,石狩広島,南長沼,*野幌,*長沼
    [231, 503550, 141000, 504450, 141900],   // 象潟,川辺,平沢,前郷,本荘,本荘
    [232, 459450, 93600, 460350, 94500],   // 喜屋武岬,糸満,知念,*那覇,*与那原
    [233, 482850, 125400, 483750, 126300],   // 日笠,上郡,林野,上月,真加部,佐用
    [234, 477450, 120600, 478350, 121500],   // 内子,町村,中山,総津,上灘,砥部
    [235, 481050, 125400, 481950, 126300],   // 有漢市場,下加茂,呰部,西川,勝山,久世
    [236, 480150, 125100, 481050, 126000],   // 備中市場,高梁,吹屋,川面市場,新見,井倉
    [237, 472950, 118500, 473850, 119400],   // 竹田,三重町,朝地,田中,豊後今市,野津原
    [238, 471600, 112800, 472500, 113700],   // 大隅柏原,都井岬,志布志,串間,大隅松山,園田
    [239, 505350, 130200, 506250, 131100],   // 下吉影,徳宿,小鶴,磯浜,*水戸,*那珂湊
    [240, 490950, 129000, 491850, 129900],   // 宝慶寺,中竜鉱山,越前大野,荒島岳,山王,越前勝山
    [241, 475200, 125400, 476100, 126300],   // 浜田,石見今福,下府,都野津,江津
    [242, 490950, 127200, 491850, 128100],   // 関ヶ原,*大垣,美束,池野,横山,谷汲
    [243, 472500, 123000, 473400, 123900],   // 秋吉台,*山口,秋吉台北部,佐々並,三隅中,萩
    [244, 477450, 124800, 478350, 125700],   // 安芸横田,甲立,前川,三次,口羽町,上布野
    [245, 477000, 118500, 477900, 119400],   // 城辺,宿毛,柏,楠山,伊予岩松,御内
    [246, 489150, 121200, 490050, 122100],   // 新宮,鵜殿,大里,阿田和,瀞八丁,木本
    [247, 499500, 129900, 500400, 130800],   // 神ヶ原,万場,下仁田,上野吉井,松井田,*富岡
    [248, 499500, 124800, 500400, 125700],   // 伊豆松崎,下田,仁科,湯ヶ野,土肥,湯ヶ島
    [249, 507600, 143100, 508500, 144000],   // 姥屋敷,鷹高,大更,渋民,平館,沼宮内
    [250, 501750, 137100, 502650, 138000],   // 坂町,越後下関,村上,越後門前,柏尾,塩野町
    [251, 500850, 127500, 501750, 128400],   // 大山,*厚木,青野原,上溝,*与瀬,*八王子
    [252, 480150, 126900, 481050, 127800],   // 江尾,延助,伯耆溝口,伯耆大山,淀江,船上山
    [253, 499050, 132900, 499950, 133800],   // 赤沢,越後湯沢,大割野,塩沢,千手,*十日町
    [254, 468450, 116400, 469350, 117300],   // 小宮地,棚底,本渡,大島子,御領,天草赤崎
    [255, 490950, 123300, 491850, 124200],   // 古和浦,贄浦,伊勢佐原,脇出,横野,国束山
    [256, 471600, 117900, 472500, 118800],   // 肥後吉田,高森,阿蘇山,根子岳,坊中,坂梨
    [257, 478350, 123900, 479250, 124800],   // 河内,垣内,下徳良,甲山,備後小国,本郷
    [258, 477000, 126600, 477900, 127500],   // 石見大田,反辺,田儀,神西湖,*大社,大社
    [259, 510300, 141300, 511200, 142200],   // 小佐野,釜石,橋野,大槌,陸中金沢,陸中山田
    [260, 507150, 134400, 508050, 135300],   // 夜の森,磐城富岡,浪江,磐城双葉,小高,塚原
    [261, 500850, 131100, 501750, 132000],   // 鼻毛石,大間々,赤城山,上野花輪,高平,袈裟丸山
    [262, 466650, 117900, 467550, 118800],   // 三重,長崎西北部,神浦,長浦,板浦,喰場
    [263, 489150, 126600, 490050, 127500],   // 比良山,沖島,北小松,勝野,饗庭野,今津
    [264, 490050, 130200, 490950, 131100],   // 三国,越前中川,北潟,*大聖寺,*片山津温泉
    [265, 473400, 120300, 474300, 121200],   // 若宮,下原,両子山,鶴川,香々地,富来浦
    [266, 489150, 123900, 490050, 124800],   // 古市場,高見山,初瀬,大和大野,大和白石,*名張
    [267, 478350, 124800, 479250, 125700],   // 吉舎,上下,三良坂,稲草,永田,庄原
    [268, 471150, 122700, 472050, 123600],   // 川棚温泉,田部,小串,西市,滝部,俵山
    [269, 472050, 119400, 472950, 120300],   // 豊後中村,湯平,豊後森,日出生台,深耶馬渓,斉藤
    [270, 469350, 114600, 470250, 115500],   // 宮之城,薩摩黒木,湯田,永野,*宮之元,大口
    [271, 505350, 127500, 506250, 128400],   // 四天木,上総片貝,木戸,*成東,木戸
    [272, 512100, 159000, 513000, 159900],   // 温根別,士別,西風連,天塩風連,母子里,名寄
    [273, 504450, 137100, 505350, 138000],   // *羽前中山,上山,白鷹山,山形南部,宮宿,*山形北部
    [274, 472500, 113400, 473400, 114300],   // 榎原,油津,飫肥,鵜戸,坂元,郷之原
    [275, 481500, 124800, 482400, 125700],   // 総社東部,岡山北部,東山内,金川,*下加茂,福渡
    [276, 477900, 117900, 478800, 118800],   // 下川口,土佐清水,来栖野,下ノ加江,有岡,土佐中村
    [277, 474300, 124500, 475200, 125400],   // 石見横田,都茂郷,益田,仙道郷,高島,三隅
    [278, 497700, 136200, 498600, 137100],   // 羽茂本郷,赤泊,河原田,畑野,沢根,両津
    [279, 497250, 125100, 498150, 126000],   // *島田,住吉,向谷,*焼津,伊久美,*静岡西部
    [280, 505800, 142200, 506700, 143100],   // 羽後長野,大神成,角館,抱返り渓谷,下桧木内,田沢湖
    [281, 494100, 126000, 495000, 126900],   // 東大沼,三河湖,足助,寧比曽岳,小渡,川ヶ渡
    [282, 487800, 126900, 488700, 127800],   // 島,中,口坂本,久坂,高浜,小浜
    [283, 492300, 133800, 493200, 134700],   // 下唐川,穴水,門前,長沢,皆月,輪島
    [284, 508050, 148200, 508950, 149100],   // 城ヶ沢,近川,むつ,蒲野沢,大畑,入口
    [285, 469800, 112200, 470700, 113100],   // 開聞岳,指宿,今和泉,二月田,喜入
    [286, 510300, 142500, 511200, 143400],   // 茂市,宮古,峠ノ神山,田老,有芸,田老鉱山
    [287, 504900, 126300, 505800, 127200],   // 勝浦,御宿,上総大原,*国吉,上総長者
    [288, 493200, 130800, 494100, 131700],   // 白木峰,打保,利賀,猪谷,山田温泉,八尾
    [289, 492300, 127800, 493200, 128700],   // 岩佐,*美濃,下洞戸,苅安,上ヶ瀬,郡上八幡
    [290, 490950, 126300, 491850, 127200],   // 竜ヶ岳,阿下喜,篠立,*駒野,霊仙山,*養老
    [291, 470700, 117000, 471600, 117900],   // 柿迫,葉木,甲佐,畝野,*御船,浜町
    [292, 498600, 130200, 499500, 131100],   // 信濃田口,荒船山,御代田,南軽井沢,浅間山,軽井沢
    [293, 497700, 132600, 498600, 133500],   // 飯山,往郷,猿橋,野沢温泉,*新井,柳島
    [294, 478350, 120900, 479250, 121800],   // 久万,東川,石墨山,面河渓,伊予川内,石鎚山
    [295, 499050, 131100, 499950, 132000],   // 浅間隠山,榛名湖,長野原,群馬原町,小雨,中之条
    [296, 509850, 144600, 510750, 145500],   // 大川目,久慈,陸中大野,陸中中野,種市,八木
    [297, 506250, 144300, 507150, 145200],   // 大葛,湯瀬,十二所,花輪,小坂,毛馬内
    [298, 498150, 133500, 499050, 134400],   // 安塚,松代,原之町,石黒,柿崎,*越後野田
    [299, 468000, 115200, 468900, 116100],   // 阿久根,指江,黒之瀬戸,牛深,薩摩鷹巣
    [300, 505800, 133800, 506700, 134700],   // 上蓬田,上三坂,田母神,小野新町,柳橋,上大越
    [301, 495000, 125700, 495900, 126600],   // 三河大野,熊,海老,三河本郷,田口,見出
    [302, 486000, 121500, 486900, 122400],   // 印南,三尾,御坊,紀伊由良,*高家
    [303, 504450, 142200, 505350, 143100],   // 新波,刈和野,羽後和田,羽後境,秋田東部,岩見三内
    [304, 483750, 126000, 484650, 126900],   // 土万,山崎,千草,安積,西河内,音水湖
    [305, 518850, 157800, 519750, 158700],   // 女満別,東藻琴,呼人,藻琴,能取湖,網走
    [306, 502650, 126300, 503550, 127200],   // 三浦三崎,*保田,浦賀,上総湊,*横須賀,富津
    [307, 466650, 118800, 467550, 119700],   // 面高,川棚,佐世保南部,早岐,*佐世保北部,蔵宿
    [308, 508500, 140100, 509400, 141000],   // 千廐北部,折壁,沖田,陸中大原,阿原山,鷹ノ巣山
    [309, 504000, 126000, 504900, 126900],   // 安房和田,鴨川,安房小湊,坂畑,上総中野
    [310, 450900, 88800, 451800, 89700],   // 上地,東平安名岬,平良,福北,西平安名岬,*西平安名岬
    [311, 493650, 124500, 494550, 125400],   // 野田,田原,仁崎,老津,*蒲郡,*小坂井
    [312, 498150, 127200, 499050, 128100],   // 身延,人穴,切石,精進,鰍沢,*市川大門
    [313, 495450, 126900, 496350, 127800],   // 平谷,満島,浪合,山田河内,伊那駒場,時又
    [314, 495900, 132900, 496800, 133800],   // 小滝,越後大野,糸魚川,梶屋敷,梶屋敷
    [315, 503100, 132000, 504000, 132900],   // *下野大沢,氏家,玉生,*矢板,高原山,*西那須野
    [316, 504900, 146700, 505800, 147600],   // 森田,*五所川原,菰槌,金木,車力,中里
    [317, 506250, 138600, 507150, 139500],   // 薬莱山,中新田,西上野目,岩出山,鳴子,川渡
    [318, 500400, 134700, 501300, 135600],   // 栃堀,光明山,森町,粟ヶ岳,加茂,越後白山
    [319, 507150, 139500, 508050, 140400],   // 岩ヶ崎,金成,沼倉,萩荘,本寺,*平泉
    [320, 510300, 154200, 511200, 155100],   // 追,,川端,三川,雨霧山,栗山,夕張
    [321, 506700, 152700, 507600, 153600],   // 伊達,*稀府,虻田,壮瞥,洞爺,仲洞爺
    [322, 476550, 124500, 477450, 125400],   // 琴谷,佐々井,志路原,八重,大朝,生田
    [323, 505800, 145200, 506700, 146100],   // 白沢,陸中濁川,阿闍羅山,碇ヶ関,大鰐,沖浦
    [324, 488700, 120300, 489600, 121200],   // 串本,古座,下里,滝の拝,紀伊勝浦
    [325, 468450, 118200, 469350, 119100],   // 湯江,多比良,肥前大浦,多良
    [326, 479250, 125100, 480150, 126000],   // 福永,油木,帝釈峡,東城,小奴可,備中矢田
    [327, 471600, 123000, 472500, 123900],   // *西市,於福,*俵山,長門湯本,長門古市,仙崎
    [328, 473850, 118800, 474750, 119700],   // 犬飼,*津久見,戸次本町,*臼杵,鶴崎,坂ノ市
    [329, 493650, 134100, 494550, 135000],   // 宇出津,宇出津,松波,松波,宝立山,能登飯田
    [330, 472050, 117000, 472950, 117900],   // 胡摩山,諸塚,鞍岡,諸塚山,馬見原,三田井
    [331, 490050, 122400, 490950, 123300],   // 尾鷲,九鬼,引本浦,島勝浦,大杉峡谷,長島
    [332, 506700, 136200, 507600, 137100],   // 丸森,新地,*角田,山下,*亘理,荒浜
    [333, 471150, 115800, 472050, 116700],   // 免田,槻木,多良木,市房山,梶原,古屋敷
    [334, 463050, 117300, 463950, 118200],   // 玉之浦,富江,三井楽,五島福江,肥前柏,岐宿
    [335, 481500, 120300, 482400, 121200],   // 安芸,安芸,手結,土佐土居,美良布,畑山
    [336, 491850, 132000, 492750, 132900],   // 津幡,*石動,加賀高松,宝達山,*羽咋
    [337, 465750, 101700, 466650, 102600],   // 住用,奄美小湊,名瀬西部,名瀬東部,龍郷
    [338, 492300, 123300, 493200, 124200],   // 浜島,波切,*磯部,安乗,*鳥羽,浦村
    [339, 485100, 124200, 486000, 125100],   // 仮屋,仮屋,*明石,高砂,*東二見
    [340, 506250, 129300, 507150, 130200],   // 常陸鹿島,荒野
    [341, 498150, 131400, 499050, 132300],   // 四阿山,大前,御飯岳,上野草津,中野東部,岩菅山
    [342, 490050, 123900, 490950, 124800],   // 菅野,宮前,倶留尊山,伊勢奥津,*阿保,二本木
    [343, 514350, 154500, 515250, 155400],   // 御影,*祥栄,十勝清水,上然別,鹿追,瓜幕
    [344, 487350, 126300, 488250, 127200],   // 園部,殿田,胡麻,四ツ谷,*和知,*島
    [345, 481950, 127200, 482850, 128100],   // 三朝,岩坪,松崎,鹿野,青谷,浜村
    [346, 508950, 145200, 509850, 146100],   // *市野沢,階上岳,苫米地,新井田,*八戸西部,八戸東部
    [347, 485100, 126300, 486000, 127200],   // 生野,丹波和田,但馬新井,大名草,但馬竹田,矢名瀬
    [348, 499950, 128100, 500850, 129000],   // *大月,上野原,七保,猪丸,丹波,奥多摩湖
    [349, 512550, 156000, 513450, 156900],   // 富良野,本幸,上富良野,旭野,美馬牛,置杵牛
    [350, 505350, 138900, 506250, 139800],   // 尾花沢,魚取沼,月楯,羽前赤倉,瀬見,向町
    [351, 503100, 143400, 504000, 144300],   // 船川,*船越,北浦,寒風山,大潟
    [352, 503100, 140100, 504000, 141000],   // 酒田北部,羽後観音寺,十里塚,吹浦,小砂川,小砂川
    [353, 509850, 162600, 510750, 163500],   // 兜沼,沼川,上勇知,樺岡,稚内,声問
    [354, 474750, 123000, 475650, 123900],   // 周防須万,渋前,周防広瀬,周防本郷,六日市,宇佐郷
    [355, 476100, 125400, 477000, 126300],   // 石見今市,矢上,川戸,川本,浅利,大家
    [356, 477900, 122400, 478800, 123300],   // 菊間,今治西部,大浜,波止浜,大長,*木江
    [357, 481500, 121800, 482400, 122700],   // 大歩危,京上,阿波川口,阿波中津,阿波池田,*辻
    [358, 473850, 123000, 474750, 123900],   // 堀,周防鹿野,大原湖,莇ヶ岳,徳佐中,椛谷
    [359, 498150, 129300, 499050, 130200],   // 八ヶ岳東部,御所平,松原湖,信濃中島,高野町,海瀬
    [360, 510300, 156300, 511200, 157200],   // 浦臼,砂川,総進,*滝川,石狩大和,*江部乙
    [361, 493200, 128400, 494100, 129300],   // 沢,焼石,郡上市島,下呂,二間手,萩原
    [362, 478800, 119400, 479700, 120300],   // 土佐川口,窪川,米の川,久礼,新田,萩中
    [363, 475650, 123900, 476550, 124800],   // 湯来,川角,戸河内,坪野,三段峡,加計
    [364, 482850, 123300, 483750, 124200],   // *志,,讃岐津田,*五剣山,五剣山,土庄,草壁
    [365, 483750, 127500, 484650, 128400],   // 扇ノ山,村岡,湯,味取,浜坂,余部
    [366, 446850, 87600, 447750, 88500],   // 石垣,白保,伊野田,伊野田,伊原間,伊原間
    [367, 502200, 132000, 503100, 132900],   // 日光南部,*今市,日光北部,鬼怒川温泉,川俣湖,川治
    [368, 494550, 126600, 495450, 127500],   // *川ヶ渡,根羽,明智,横道,岩村,美濃焼山
    [369, 515700, 153900, 516600, 154800],   // 糠内,農野牛,幕別,川合,十勝川温泉,十勝池田
    [370, 483300, 121500, 484200, 122400],   // 長安口貯水池,桜谷,雲早山,阿井,阿波寄井,阿波三渓
    [371, 492300, 124800, 493200, 125700],   // 内海,*師崎,野間,*河和,常滑,*半田
    [372, 469350, 116400, 470250, 117300],   // 高戸,田浦,姫浦,*日奈久,天草松島,*八代
    [373, 509400, 140700, 510300, 141600],   // 世田米,盛,陸前八日町,五葉山,遠野,陸中大橋
    [374, 476550, 122700, 477450, 123600],   // 大君,倉橋島,江田島,*呉,似島,*吉浦
    [375, 468900, 121500, 469800, 122400],   // 津屋崎,津屋崎,神湊
    [376, 470250, 114600, 471150, 115500],   // 横川,霧島温泉,栗野,韓国岳,*吉松,*加久藤
    [377, 504450, 134700, 505350, 135600],   // 山潟,磐梯熱海,関都,玉井,中ノ沢,安達太良山
    [378, 508050, 141300, 508950, 142200],   // *口内,野手崎,*土沢,宮守,石鳥谷,大迫
    [379, 505350, 131700, 506250, 132600],   // 山方,町屋,大中宿,竪破山,袋田,里美牧場
    [380, 488700, 127500, 489600, 128400],   // 遠敷,熊川,西津,三方,常神,早瀬
    [381, 478800, 122700, 479700, 123600],   // 幸新田,四阪島,*木浦,岩城,*瀬戸田,備後土生
    [382, 496350, 131400, 497250, 132300],   // 日名,*稲荷山,高府,信濃中条,塩島,戸隠
    [383, 471150, 120300, 472050, 121200],   // 英彦山,耶馬渓西部,*伊良原,下河内,*豊前本庄,椎田
    [384, 493650, 127800, 494550, 128700],   // 河岐,切井,金山,神土,*焼石,小和知
    [385, 506700, 153600, 507600, 154500],   // 三ノ原,留寿都,羊蹄山,喜茂別,倶知安,京極
    [386, 495900, 125700, 496800, 126600],   // 秋葉山,犬居,中部,気田,佐久間,門桁
    [387, 480600, 126000, 481500, 126900],   // 刑部,*勝山,上刑部,横部,美作新庄,湯原湖
    [388, 478350, 126000, 479250, 126900],   // 比婆新市,比婆山,阿井町,下横田,湯村,横田
    [389, 512550, 156900, 513450, 157800],   // 美瑛,志比内,*西神楽,岐登牛山,*永山,当麻
    [390, 482850, 126300, 483750, 127200],   // 日本原,古町,大背,坂根,智頭,郷原
    [391, 481500, 123000, 482400, 123900],   // *善通寺,*滝宮,*丸亀,白峰山,本島,五色台
    [392, 477900, 119400, 478800, 120300],   // 江川崎,田野々,下鍵山,土佐松原,土居,梼原
    [393, 469800, 113100, 470700, 114000],   // 瀬々串,垂水,鹿児島南部,桜島南部,*鹿児島北部,*桜島北部
    [394, 502200, 126300, 503100, 127200],   // 三浦三崎,*三浦三崎,秋谷,*浦賀,*鎌倉,*横須賀
    [395, 504900, 144000, 505800, 144900],   // 沖田面,阿仁前田,米内沢,*桂瀬,鷹巣西部,*鷹巣東部
    [396, 515250, 153000, 516150, 153900],   // 尾田,忠類,更別,上更別,中札内,駒畠
    [397, 502200, 134700, 503100, 135600],   // 沼沢沼,宮下,安座,柳津,徳沢,野沢
    [398, 505800, 153900, 506700, 154800],   // 蘭越,ニセコ,チセヌプリ,ニセコアンヌプリ,岩内,小沢
    [399, 508950, 139200, 509850, 140100],   // 志津川,伊里前,馬籠,津谷,津谷川,*気仙沼
    [400, 471150, 109800, 472050, 110700],   // 大隅野間,大隅野間,浜津脇,浜津脇,西之表,安納
    [401, 515250, 159300, 516150, 160200],   // 中宇津々,中渚滑,豊野,紋別,沙留
    [402, 516600, 156900, 517500, 157800],   // 北見勝山,小利別,置戸,訓子府,留辺蘂西部,留辺蘂東部
    [403, 492300, 128700, 493200, 129600],   // 門原,徳永,白鳥,那留,石徹白,大鷲
    [404, 516600, 158400, 517500, 159300],   // 遠軽,若里,上湧別,芭露,中湧別,登栄床
    [405, 495450, 129600, 496350, 130500],   // 寄合渡,贄川,梓湖,古見,上高地,波田
    [406, 484650, 123000, 485550, 123900],   // 鳴門海峡,諭鶴羽山,福良,*広田,都志,*都志
    [407, 504000, 137400, 504900, 138300],   // 荒砥,*白鷹山,太郎,*宮宿,貫見,左沢
    [408, 504450, 141000, 505350, 141900],   // 矢島,羽後田代,大琴,老方,岩野目沢,八沢木
    [409, 466650, 121200, 467550, 122100],   // 郷ノ浦,印通寺,湯本,芦辺,勝本,勝本
    [410, 473400, 123900, 474300, 124800],   // 長門広瀬,十種峰,宇田,長門新市,須佐,江崎
    [411, 463950, 117900, 464850, 118800],   // 浦,佐尾,漁生浦,奈良尾,串島,有川
    [412, 508050, 144900, 508950, 145800],   // 上斗米,*陸奥福岡,田子,*三戸,金ヶ沢,剣吉
    [413, 503550, 135000, 504450, 135900],   // *会津広田,猪苗代,*喜多方東部,磐梯山,熱塩,桧原湖
    [414, 499050, 133800, 499950, 134700],   // 岡野町,*岩沢,*法坂,*小千谷,*塚野山,片貝
    [415, 469350, 117600, 470250, 118500],   // 雲仙,網津,島原,肥後船津,下沖洲,伊倉
    [416, 509850, 157800, 510750, 158700],   // 大和田,幌糠,留萌,ポロシリ山,小平,達布
    [417, 499950, 133200, 500850, 134100],   // 六日町,兎岳,*五日町,八海山,*小出,大湯
    [418, 479700, 126000, 480600, 126900],   // 油野,足立,上石見,千屋実,印賀,根雨
    [419, 469350, 120300, 470250, 121200],   // 不入道,*二日市,*福岡南部,*太宰府,*福岡,*篠栗
    [420, 495450, 128700, 496350, 129600],   // 上松,木曽駒ヶ岳,木曽福島,宮ノ越,末川,薮原
    [421, 482400, 119700, 483300, 120600],   // 室戸岬,室戸岬,羽根,佐喜浜,奈半利,入木
    [422, 501300, 129900, 502200, 130800],   // 三ヶ尻,*熊谷,*深谷,*妻沼,*上野境,*足利南部
    [423, 523800, 155400, 524700, 156300],   // 落石,根室南部,友知,根室北部,婦羅理
    [424, 515250, 154800, 516150, 155700],   // 駒場,東士幌,中士幌,士幌,中音更,上士幌
    [425, 505800, 132900, 506700, 133800],   // 橋場,上平石,磐城新宿,上遠野,竹貫,下市萱
    [426, 476100, 119700, 477000, 120600],   // 伊予高山,伊予高山,伊予大島,三瓶,湊浦,*八幡浜
    [427, 483300, 120600, 484200, 121500],   // 甲浦,奥浦,牟岐,小川口,山河内
    [428, 484650, 127500, 485550, 128400],   // 栃本,*江原,神鍋山,*豊岡,香住,城崎
    [429, 521100, 156000, 522000, 156900],   // 西春別,中西別,計根別,上春別,西竹,中標津
    [430, 477000, 125700, 477900, 126600],   // 木路原,赤名,石見小原,野萱,三瓶山西部,三瓶山東部
    [431, 469350, 115500, 470250, 116400],   // *湯出,山野,*水俣,大関山,計石,佐敷
    [432, 510300, 143400, 511200, 144300],   // 岩泉,小本,沼袋,田野畑,玉川,普代
    [433, 503100, 133800, 504000, 134700],   // 田島,甲子山,林中,湯野上,東尾岐,上三寄
    [434, 499500, 127200, 500400, 128100],   // 須走,駿河小山,*富士吉田,*御正体山,*河口湖東部,*都留
    [435, 506700, 142800, 507600, 143700],   // 国見温泉,雫石,秋田駒ヶ岳,篠崎,曲崎山,松川温泉
    [436, 508950, 138000, 509850, 138900],   // 荻浜,寄磯,女川,出島,雄勝,大須
    [437, 508050, 147000, 508950, 147900],   // 野辺地,平沼,目越,戸鎖,陸奥横浜,陸奥横浜
    [438, 496800, 125700, 497700, 126600],   // 家山,*伊久美,高郷,石上,蕎麦粒山,千頭
    [439, 488700, 123000, 489600, 123900],   // 南日裏,弥山,中戸,洞川,*吉野山,新子
    [440, 472050, 118500, 472950, 119400],   // *坂梨,桜町,久住山,久住,湯坪,大船山
    [441, 463950, 99600, 464850, 100500],   // 伊仙,亀津,平土野,ジャナレ島,山
    [442, 511200, 152700, 512100, 153600],   // 門別,厚賀,富川,庫富,旭岡,平取
    [443, 467100, 117000, 468000, 117900],   // 野母,肥前高島,千々,長崎西南部,*長崎東南部
    [444, 519750, 157200, 520650, 158100],   // 野上峠,緑,上徳,札弦,小清水,清里
    [445, 478800, 120300, 479700, 121200],   // 王在家,長者,柳井川,大崎,*東川,上土居
    [446, 505800, 135600, 506700, 136500],   // 月舘,萩平,*保原,霊山,*桑折,舟生
    [447, 507600, 144000, 508500, 144900],   // 七時雨山,陸奥中山,陸奥荒屋,駒ヶ嶺,稲庭岳,浄法寺
    [448, 522000, 156300, 522900, 157200],   // 中春別,床丹,俵橋,尾岱沼,川北,標津
    [449, 502200, 138300, 503100, 139200],   // 勝木,雷,鼠ヶ関,木野俣,温海,山五十川
    [450, 511650, 156000, 512550, 156900],   // 奥芦別,島ノ下,上芦別,野花南,芦別,瑠辺蘂山
    [451, 506250, 134400, 507150, 135300],   // *上大越,上川内,常葉,古道,上移,下津島
    [452, 473850, 117600, 474750, 118500],   // 熊田,古江,重岡,三川内,千束,上直見
    [453, 490050, 125400, 490950, 126300],   // 甲賀,*鈴鹿峠,*水口,*土山,*日野西部,日野東部
    [454, 515250, 152100, 516150, 153000],   // 札楽古,広尾,中豊似,豊似,開進,大樹
    [455, 510300, 153000, 511200, 153900],   // 上厚真,鵡川,上厚真,軽舞,遠浅,厚真
    [456, 504000, 143100, 504900, 144000],   // *土崎,松原,*大久保,蓬内台,五城目,湯ノ又
    [457, 487350, 120600, 488250, 121500],   // 紀伊日置,江住,富田,市鹿野,*紀伊田辺,合川
    [458, 466650, 119700, 467550, 120600],   // *江迎,楠久,*志佐,今福,鷹島,高串
    [459, 472950, 120300, 473850, 121200],   // 立石,*若宮,豊後高田,*両子山,浜,*香々地
    [460, 490500, 127500, 491400, 128400],   // 虎御前山,*美束,近江川合,*横山,美濃川上,美濃広瀬
    [461, 467550, 118500, 468450, 119400],   // 武留路山,多良岳,彼杵,古枝,*嬉野,*鹿島
    [462, 519750, 155700, 520650, 156600],   // 中久著呂,標茶,上オソツベツ,磯,内,弟子屈,南弟子屈
    [463, 501300, 135300, 502200, 136200],   // 高石,越後豊川,馬下,津川,出湯,東赤谷
    [464, 505800, 137100, 506700, 138000],   // 遠刈田,*村田,今宿,陸前川崎,作並,熊ヶ根
    [465, 480150, 123300, 481050, 124200],   // 宇治島,六島,鞆,白石島,福山東部,寄島
    [466, 478350, 118500, 479250, 119400],   // *土佐中村,田野浦,蕨岡,土佐佐賀,大用,伊与喜
    [467, 503550, 152100, 504450, 153000],   // 左股,後志日進,北檜山,八束,丹羽,今金
    [468, 496800, 129900, 497700, 130800],   // *鉢伏山,霧ヶ峰,*山辺,和田,三才山,武石
    [469, 496800, 132600, 497700, 133500],   // 妙高山,赤倉,湯川内,関山,槙,*重倉山
    [470, 512100, 158100, 513000, 159000],   // 福原,蘭留,三和,和寒,剣淵,上士別
    [471, 491850, 133500, 492750, 134400],   // 富来,中島,剣地,*下唐川,能登黒島,*門前
    [472, 470700, 113100, 471600, 114000],   // 上祓川,持留,百引,野方,*牛根境,*岩川
    [473, 486000, 127200, 486900, 128100],   // 三岳山,河守,大江山,内宮,*四辻,*宮津
    [474, 467550, 116100, 468450, 117000],   // 大江,河浦,天草高浜,鬼海ヶ浦,天草下田
    [475, 504900, 135600, 505800, 136500],   // 土湯温泉,福島南部,板谷,*福島北部,栗子山,*中茂庭
    [476, 464850, 101100, 465750, 102000],   // 瀬武,古仁屋,西古見,奄美久慈,宇検,湯湾
    [477, 491400, 127800, 492300, 128700],   // *谷汲,美濃神海,樽見,谷合,能郷,下大須
    [478, 488250, 121500, 489150, 122400],   // 皆地,本宮,発心門,伏拝,重里,十津川温泉
    [479, 488250, 126300, 489150, 127200],   // 周山,大原,上弓削,花脊,*中,久多
    [480, 471150, 117600, 472050, 118500],   // *浜町,大平,大矢野原,*肥後吉田,立野,*阿蘇山
    [481, 516150, 155100, 517050, 156000],   // 押帯,本別,活込,足寄太,芽登,愛冠
    [482, 504450, 150300, 505350, 151200],   // 桂岡,瓜谷山,江差,館,乙部,鶉町
    [483, 497700, 126300, 498600, 127200],   // 駿河落合,和田島,湯の森,篠井山,梅ヶ島,南部
    [484, 508950, 143700, 509850, 144600],   // 小屋瀬,陸中五日市,葛巻,安家森,陸中戸田,陸中関
    [485, 460800, 95400, 461700, 96300],   // 瀬嵩,天仁屋,仲尾次,国頭平良,大宜味,辺土名
    [486, 479250, 129900, 480150, 130800],   // 菱浦,都万,都万,都万,隠岐北方,隠岐北方
    [487, 504000, 130800, 504900, 131700],   // 岩瀬,*羽黒,*真岡,*中飯,*祖母井,*茂木
    [488, 500400, 125100, 501300, 126000],   // 稲取,天城山,富戸,*伊東,川奈
    [489, 501750, 131100, 502650, 132000],   // 番場,仙波,沢入,中粕尾,足尾,古峰原
    [490, 505800, 150900, 506700, 151800],   // 木地挽山,*大沼公園,姫川,駒ヶ岳,渡島森,砂原
    [491, 484650, 126000, 485550, 126900],   // 寺前,粟賀町,長谷,*生野,神子畑,*但馬新井
    [492, 504450, 146100, 505350, 147000],   // 枯木平,岩木山,種里,十面沢,鰺ヶ沢,*森田
    [493, 507600, 154800, 508500, 155700],   // 余市岳,手稲山,張碓,銭函,小樽東部,銭函
    [494, 504000, 141900, 504900, 142800],   // 岩谷,新沢,内道川,*新波,羽川,*羽後和田
    [495, 510750, 157500, 511650, 158400],   // 石狩沼田,多,志,恵比島,鷹泊,浅野,鷹泊貯水池
    [496, 522000, 155400, 522900, 156300],   // 東円朱別,姉別,上風蓮,奥行,豊原,別海
    [497, 482400, 121500, 483300, 122400],   // 北川,阿波出原,剣山,谷口,阿波古見,阿波川井
    [498, 472950, 117300, 473850, 118200],   // 日之影,行縢山,大菅,祝子川,見立,木浦鉱山
    [499, 460350, 94200, 461250, 95100],   // 津堅,屋慶名,宮城島,宮城島
    [500, 493200, 126900, 494100, 127800],   // 高蔵寺,*多治見,*小泉,*土岐,*美濃加茂,*御嵩
    [501, 472050, 116100, 472950, 117000],   // 石堂山,尾八重,日向大河内,神門,上椎葉,清水岳
    [502, 489150, 124800, 490050, 125700],   // 柳生,*月ヶ瀬,笠置山,*島ヶ原,*朝宮,*信楽
    [503, 475650, 121500, 476550, 122400],   // 平郡島,平郡島東部,阿月,安下庄,*大畠,久賀
    [504, 504000, 134100, 504900, 135000],   // 羽鳥湖,岩代長沼,岩代福良,岩代中野,原,*山潟
    [505, 468450, 112800, 469350, 113700],   // 野間岳,*加世田,片浦,*唐仁原,*久多島,伊作
    [506, 506700, 133800, 507600, 134700],   // 川前,上浅見川,坂シ内,成子内,*上川内,*夜の森
    [507, 491400, 130200, 492300, 131100],   // 加賀丸山,白峰,尾小屋,市原,別宮,口直海
    [508, 509850, 159000, 510750, 159900],   // 力昼,三渓,苫前,上羽幌,羽幌,曙
    [509, 494100, 129300, 495000, 130200],   // 飛騨小坂,胡桃島,久々野,朝日貯水池,*高山,飛騨青屋
    [510, 502200, 133500, 503100, 134400],   // 松戸原,糸沢,会津山口,針生,和泉田,大芦
    [511, 516600, 153600, 517500, 154500],   // 旅来,十勝大津,茂岩,浦幌,十弗,常室
    [512, 499950, 133800, 500850, 134700],   // *小出,*大湯,*小平尾,須原,半蔵金,穴沢
    [513, 474300, 123900, 475200, 124800],   // 津和野,安蔵寺山,日原,石谷,*石見横田,*都茂郷
    [514, 508500, 155400, 509400, 156300],   // 石狩,太美,望来,望来,厚田
    [515, 503550, 136200, 504450, 137100],   // 入田沢,米沢,玉庭,*米沢北部,手ノ子,*羽前小松
    [516, 497700, 131100, 498600, 132000],   // 真田,嬬恋田代,菅平,*四阿山,*須坂,*御飯岳
    [517, 504900, 147600, 505800, 148500],   // 津軽相内,薄市,小泊,増川岳,龍飛崎,三廐
    [518, 504900, 141900, 505800, 142800],   // 悪戸野,*大曲,*刈和野,刈和野東部,*羽後境,稲沢
    [519, 507150, 146700, 508050, 147600],   // 折紙山,*上清水目,東岳,狩場沢,小湊,清水川
    [520, 475200, 124500, 476100, 125400],   // 出合原,*三段峡,宇津川,臥龍山,木都賀,波佐
    [521, 504900, 153000, 505800, 153900],   // 渡島双葉,長万部,黒松内,静狩,熱郛,白井川
    [522, 504450, 138300, 505350, 139200],   // 海味,*谷地,葉山,富並,肘折,海谷
    [523, 503100, 138300, 504000, 139200],   // 大鳥,赤見堂岳,上田沢,湯殿山,下名川,大網
    [524, 500400, 136500, 501300, 137400],   // 新潟北部,松浜,松浜
    [525, 517950, 158100, 518850, 159000],   // 日吉,越歳,浜佐呂間,卯原内,サロマ湖東部,常呂
    [526, 464850, 123000, 465750, 123900],   // 小茂田,厳原,阿連,鶏知,廻,仁位
    [527, 487350, 122100, 488250, 123000],   // 寒川,龍神,紀伊清水,護摩壇山,田,*梁瀬
    [528, 468450, 114300, 469350, 115200],   // 羽島,*川内,西方,東郷,大川,紫尾山
    [529, 504000, 132000, 504900, 132900],   // 喜連川,*馬頭,*佐久山,*下野小川,*大田原,黒羽田町
    [530, 510300, 161400, 511200, 162300],   // 更岸,雄信内,振老,安牛,幌延,本流
    [531, 491400, 124500, 492300, 125400],   // *松阪港,伊勢浜田,*津東部,白子
    [532, 484200, 126900, 485100, 127800],   // 戸倉峠,大屋市場,氷ノ山,関宮,*村岡,*栃本
    [533, 504450, 128700, 505350, 129600],   // 小林,*成田,*龍ヶ崎,*下総滑川,*牛久,*江戸崎
    [534, 499500, 129000, 500400, 129900],   // 雁坂峠,雲取山,中津峡,三峰,両神山,長又
    [535, 495900, 132000, 496800, 132900],   // 白馬町,*塩島,白馬岳,雨中,越後平岩,雨飾山
    [536, 470250, 116100, 471150, 117000],   // 高沢,肥後田代,中津道,頭地,*坂本,宮園
    [537, 498150, 128400, 499050, 129300],   // *韮崎,*甲府北部,*若神子,茅ヶ岳,谷戸,瑞牆山
    [538, 477450, 120300, 478350, 121200],   // 鹿野川,惣川,*内子,*町村,*中山,*総津
    [539, 465300, 123900, 466200, 124800],   // 三根,志多賀,鹿見,琴,佐護,佐須奈
    [540, 500400, 132000, 501300, 132900],   // *後閑,追貝,藤原湖,鎌田,藤原,至仏山
    [541, 483300, 124500, 484200, 125400],   // 西島,日生,幡州赤穂,備前三石,*相生
    [542, 489150, 122100, 490050, 123000],   // 大沼,七色貯水池,池原,高代山,釈迦ヶ岳,河合
    [543, 477900, 126000, 478800, 126900],   // 頓原,*比婆新市,出雲吉田,*阿井町,掛合,*湯村
    [544, 481950, 126600, 482850, 127500],   // 奥津,美作加茂,上斎原,加瀬木,*三朝,*岩坪
    [545, 508500, 153000, 509400, 153900],   // 白老,社台,森野,錦岡,風不死岳,樽前山
    [546, 480600, 121500, 481500, 122400],   // 本山,杉,*佐々連尾山,*野鹿池山,*伊予三島,*伊予新宮
    [547, 506250, 141300, 507150, 142200],   // 羽後黒沢,陸中川尻,左草,新町,真昼岳,陸中猿橋
    [548, 503100, 132900, 504000, 133800],   // 塩原,*関谷,日留賀岳,板室,栗生沢,那須岳
    [549, 492300, 130500, 493200, 131400],   // 中宮温泉,鳩谷,西赤尾,上梨,湯涌,下梨
    [550, 512550, 155100, 513450, 156000],   // 石狩金山,幾寅,山部,西達布,布部,麓郷
    [551, 512100, 152400, 513000, 153300],   // 静内,御園,共栄,明和,新和,太陽
    [552, 492750, 134100, 493650, 135000],   // *長沢,鵜川,*輪島,柳田,輪島,曽々木
    [553, 459900, 96000, 460800, 96900],   // 伊江島,仲宗根,*楚洲,伊是名島
    [554, 499500, 132000, 500400, 132900],   // 四万,*猿ヶ京,三国峠,水上,土樽,茂倉岳
    [555, 502650, 136500, 503550, 137400],   // 長者原,叶水,小国,小国東部,舟渡,五味沢
    [556, 518850, 155100, 519750, 156000],   // 阿寒,*下幌呂,徹別,鶴居,上幌呂,茂雪裡
    [557, 471150, 121800, 472050, 122700],   // *小倉,喜多久,*下関,白野江,安岡,小月
    [558, 479700, 120900, 480600, 121800],   // 思地,川口,日比原,西石原,*日ノ浦,*土佐小松
    [559, 503550, 145800, 504450, 146700],   // 十二湖,白神岳,深浦,長慶平,驫木,北金ヶ沢
    [560, 489150, 129300, 490050, 130200],   // 梅浦,*織田,越前蒲生,越前蒲生,鮎川
    [561, 517500, 156900, 518400, 157800],   // 訓津峠,本岐,常川,*開成,相内,*北見
    [562, 510300, 140400, 511200, 141300],   // 綾里,綾里,越喜来,陸前千歳,小白浜,平田
    [563, 462600, 98100, 463500, 99000],   // 沖永良部島西部,沖永良部島西部,沖永良部島東部,沖永良部島東部
    [564, 513450, 151500, 514350, 152400],   // 浦河,荻伏,西舎,歌笛,上野深
    [565, 477900, 123300, 478800, 124200],   // 三津,*白水,田万里市,*竹原,*白市,*河内
    [566, 490500, 125700, 491400, 126600],   // *土山,*伊船,*日野東部,御在所山,百済寺,*竜ヶ岳
    [567, 511650, 153600, 512550, 154500],   // 荷負,振内,穂別,仁世宇,稲里,胆振福山
    [568, 479250, 126300, 480150, 127200],   // 多里,*上石見,阿毘縁,*印賀,布部,井尻
    [569, 505350, 136800, 506250, 137700],   // 不忘山,白石,蔵王山,*遠刈田,笹谷峠,*今宿
    [570, 514800, 158400, 515700, 159300],   // 上雄柏,丸立峠,滝西,立牛,滝上,北見滝下
    [571, 512550, 161100, 513450, 162000],   // 本幌別,志美宇丹,歌登,下幌別,ポロヌプリ山,枝幸
    [572, 513000, 158700, 513900, 159600],   // 奥士別,岩尾内湖,日進,新下川,上名寄,下川
    [573, 506250, 139500, 507150, 140400],   // 鬼首,花山湖,軍沢,切留,桂沢,栗駒山
    [574, 470700, 109200, 471600, 110100],   // 上中,上中,島間,島間,*大隅野間
    [575, 509400, 155700, 510300, 156600],   // 弁華別,市南,青山中央,月形,二番川,ピンネシリ
    [576, 520200, 154500, 521100, 155400],   // 昆布森,仙鳳趾,上尾幌,尾幌,塘路湖,片無去
    [577, 485100, 127800, 486000, 128700],   // *豊岡,*須田,*城崎,久美浜,城崎,塩江
    [578, 480600, 127800, 481500, 128700],   // 御来屋,赤崎
    [579, 498150, 132300, 499050, 133200],   // 夜間瀬,切明,*往郷,鳥甲山,*野沢温泉,信濃森
    [580, 506700, 148800, 507600, 149700],   // 長後,白土山,佐井,奥戸,大間
    [581, 508050, 137700, 508950, 138600],   // 宮戸島,小野,渡波,*広淵,*石巻
    [582, 507150, 150000, 508050, 150900],   // 汐首,戸井,鉄山,古武井,川汲,尾札部
    [583, 506250, 138000, 507150, 138900],   // 定義,根白石,升沢,七ツ森,*薬莱山,*中新田
    [584, 504900, 149400, 505800, 150300],   // 千軒,涌元,湯ノ里,渡島知内,神明,木古内
    [585, 465300, 119400, 466200, 120300],   // 野子,志々伎,紐差,生月
    [586, 517050, 157800, 517950, 158700],   // 花園,上仁頃,若佐,佐呂間山,*若里,佐呂間
    [587, 514350, 159600, 515250, 160500],   // 上興部,秋里,トーウツ岳,興部,雄武,沢木
    [588, 472950, 123600, 473850, 124500],   // *萩,生雲中,越ヶ浜,*長門広瀬,櫃島,*宇田
    [589, 513000, 157800, 513900, 158700],   // 愛別,中愛別,協和,旭山,乙部山,新奥士別
    [590, 492750, 133200, 493650, 134100],   // *七尾,庵,和倉,小口瀬戸,*穴水,前波
    [591, 472050, 114300, 472950, 115200],   // *高城,築地原,有水,*田野,紙屋,*日向本庄
    [592, 514350, 153300, 515250, 154200],   // 岩内川上流,上札内,拓成,十勝清川,上美生,*上帯広
    [593, 482400, 125400, 483300, 126300],   // 周匝,*日笠,*柵原,*林野,*津山東部,*真加部
    [594, 506250, 147300, 507150, 148200],   // 蓬田,小湊,蟹田,小湊,陸奥平館,脇野沢
    [595, 490050, 123300, 490950, 124200],   // 宮川貯水池,間弓,七日市,江馬,*菅野,*宮前
    [596, 517050, 156000, 517950, 156900],   // 大誉地,上足寄,陸別,陸別東部,釧路川上,上陸別
    [597, 492750, 129600, 493650, 130500],   // 新淵,六廐,御母衣,夏廐,平瀬,猪臥山
    [598, 504000, 144900, 504900, 145800],   // 羽後水沢,根城岱,中浜,羽後焼山,二ッ森,冷水岳
    [599, 476100, 126300, 477000, 127200],   // 温泉津,仁万,大浦
    [600, 472050, 115200, 472950, 116100],   // 大森岳,*岩崎,掃部岳,三納,村所,瓢丹淵
    [601, 506250, 132600, 507150, 133500],   // 川部,勿来,*上平石,*磐城泉,*上遠野,*常磐湯本
    [602, 477000, 117600, 477900, 118500],   // 母島,母島,柏島,福浦,小筑紫
    [603, 507600, 152700, 508500, 153600],   // *鷲別岳,登別温泉,カルルス温泉,飛生,蟠渓,徳舜瞥山
    [604, 501300, 134100, 502200, 135000],   // 田子倉湖,会津小林,只見,会津横田,駒形山,貉ヶ森山
    [605, 470250, 111300, 471150, 112200],   // 佐多岬,佐多岬,浜尻,伊座敷,辺塚
    [606, 508500, 146700, 509400, 147600],   // 甲地,六川目,*平沼,天ヶ森,*戸鎖,尾駮
    [607, 474750, 117900, 475650, 118800],   // 蒲江,蒲江,畑野浦,沖黒島,*佐伯,鶴御崎
    [608, 513450, 154500, 514350, 155400],   // 沙流岳,十勝石山,上トマム,新得,落合,狩勝峠
    [609, 505350, 129000, 506250, 129900],   // 佐原西部,*佐原東部,*麻生,*潮来,*西蓮寺,*武井
    [610, 509850, 143700, 510750, 144600],   // 安家,*沼袋,端神,*玉川,岩瀬張,陸中野田
    [611, 471150, 120000, 472050, 120900],   // 大行司,裏耶馬渓,*英彦山,*耶馬渓西部,*伊良原,*下河内
    [612, 507150, 145200, 508050, 146100],   // 中滝,清水頭,十和田湖東部,戸来岳,陸奥焼山,奥瀬
    [613, 520200, 156000, 521100, 156900],   // *磯,内,泉川,*南弟子屈,虹別,摩周湖南部,養老牛
    [614, 522000, 154500, 522900, 155400],   // 琵琶瀬,琵琶瀬,霧多布,茶内,奔幌戸
    [615, 487800, 120900, 488700, 121800],   // *市鹿野,下露,*合川,木守,栗栖川,*皆地
    [616, 489150, 126300, 490050, 127200],   // 堅田,*近江八幡,*比良山,*沖島,*北小松,*勝野
    [617, 515700, 158100, 516600, 159000],   // 丸瀬布南部,瀬戸瀬温泉,丸瀬布北部,瀬戸瀬,立牛岳,上富美
    [618, 471150, 118500, 472050, 119400],   // 鞍岳,*坊中,立門,満願寺,*鯛生,*宮原
    [619, 481500, 121200, 482400, 122100],   // 奈呂,大栃,東土居,久保沼井,*大歩危,*京上
    [620, 494550, 129600, 495450, 130500],   // *朝日貯水池,野麦,*飛騨青屋,乗鞍岳,旗鉾,焼岳
    [621, 472950, 116400, 473850, 117300],   // 坪谷,*山陰,田代,*上井野,宇納間,*川水流
    [622, 504900, 132600, 505800, 133500],   // 町付,東館,*八溝山,*塙,*磐城金山,*棚倉
    [623, 513900, 157200, 514800, 158100],   // 愛山渓温泉,層雲峡,菊水,ニセイカウシュツペ山,上川,中越
    [624, 474750, 119400, 475650, 120300],   // 佐賀関,佐賀関,*三崎,三崎
    [625, 496350, 126900, 497250, 127800],   // 伊那和田,池口岳,上町,光岳,上久堅,大沢岳
    [626, 507150, 141900, 508050, 142800],   // 鉛,花巻温泉,須賀倉山,*志和,鶯宿,*南昌山
    [627, 504900, 145200, 505800, 146100],   // 真名子,越山,尾太岳,田代岳,陸奥田代,久渡寺
    [628, 478350, 125700, 479250, 126600],   // 比和,西城,*比婆新市,*比婆山,*阿井町,*下横田
    [629, 507150, 148200, 508050, 149100],   // 陸奥川内,戸沢,陸奥畑,恐山,*白土山,薬研温泉
    [630, 518400, 154500, 519300, 155400],   // 白糠,庶路,中庶路,山花,上庶路,*阿寒
    [631, 479250, 124500, 480150, 125400],   // 木野山,*金丸,高蓋,*小畠,*福永,*油木
    [632, 495000, 128400, 495900, 129300],   // 奥三界岳,木曽須原,王滝,*上松,御岳高原,*木曽福島
    [633, 499500, 124500, 500400, 125400],   // 石廊崎,神子元島,*伊豆松崎,*下田,*仁科,*湯ヶ野
    [634, 508500, 142200, 509400, 143100],   // 陸中折壁,早池峰山,区界,松草,大志田,青松葉山
    [635, 490050, 128400, 490950, 129300],   // 板取,広野,*今庄,宅良,*武生,稲荷
    [636, 476100, 124800, 477000, 125700],   // 大仙原,*志路原,石見坂本,*大朝,*石見今市,*矢上
    [637, 521100, 154800, 522000, 155700],   // 厚岸,厚岸湖,釧路太田,糸魚沢,別寒辺牛川中流,茶内原野
    [638, 518850, 156900, 519750, 157800],   // サマッカリヌプリ,屈斜路湖,古梅,藻琴山,北見福住,末広
    [639, 509400, 141900, 510300, 142800],   // 大出,白見山,高桧山,江繋,陸中川内,陸中川井
    [640, 510750, 160800, 511650, 161700],   // 天塩清川,佐久,泉源,天塩中川,*雄信内,問寒別
    [641, 486900, 126300, 487800, 127200],   // 村雲,*園部,莵原,*胡麻,*綾部,*和知
    [642, 520650, 157500, 521550, 158400],   // 斜里岳,瑠辺斯岳,斜里,朱円,斜里,峰浜
    [643, 469350, 108900, 470250, 109800],   // 栗生,尾之間,永田岳,宮之浦岳,一湊,屋久宮之浦
    [644, 511650, 161700, 512550, 162600],   // 松音知,中頓別,イソサンヌプリ山,下頓別,安別,浜頓別
    [645, 508500, 141000, 509400, 141900],   // 人首,種山ヶ原,*野手崎,小友,*宮守,上宮守
    [646, 473400, 122100, 474300, 123000],   // 佐波島,野島,*防府,福川,*矢田,島地
    [647, 482400, 120600, 483300, 121500],   // 馬路,名留川,土佐魚梁瀬,久尾,赤城尾山,湯桶丸
    [648, 469350, 111600, 470250, 112500],   // 長崎鼻,三俣,*開聞岳
    [649, 492750, 132300, 493650, 133200],   // 飯久保,*伏木,*氷見,宇波,*能登二宮,虻ガ島
    [650, 499500, 125700, 500400, 126600],   // 達磨山,*修善寺,大瀬崎,*韮山,*沼津,*三島
    [651, 512100, 159900, 513000, 160800],   // 美深,智恵文,紋穂内,雄木禽,恩根内,函岳
    [652, 486900, 127800, 487800, 128700],   // 丹後由良,青葉山,亀島,成生岬,丹後平田,冠島
    [653, 502650, 118500, 503550, 119400],   // 八丈島南部,八丈小島,八丈島
    [654, 505800, 154800, 506700, 155700],   // 茅沼,銀山,稲倉石,然別,両古美山,豊浜
    [655, 511650, 156900, 512550, 157800],   // 石狩新城,神楽岳,神ノ居古潭,*雨紛,上湯内,*旭川
    [656, 506250, 140400, 507150, 141300],   // 小安温泉,真湯温泉,椿台,焼石岳,田子内,三界山
    [657, 506700, 143700, 507600, 144600],   // 八幡平,茶臼岳,熊沢,竜ヶ森,*湯瀬,田山
    [658, 521550, 156900, 522450, 157800],   // 武佐,*川北,武佐岳,伊茶仁,西古多糠,薫別
    [659, 481500, 126300, 482400, 127200],   // 美作宮原,*香々美,富西谷,*奥津,*下鍛冶屋,*上斎原
    [660, 504450, 136200, 505350, 137100],   // 米沢東部,*栗子山,*糠野目,名号,*赤湯,二井宿
    [661, 495450, 126600, 496350, 127500],   // 茶臼山,三河大谷,*平谷,*満島,*浪合,*山田河内
    [662, 505800, 153000, 506700, 153900],   // 礼文華,豊浦,礼文華峠,大岸,後志立川,昆布岳
    [663, 497250, 136800, 498150, 137700],   // 相川,*沢根,金北山,金北山,北田野浦
    [664, 499050, 128400, 499950, 129300],   // *塩山,大菩薩峠,川浦,柳沢峠,金峰山,*雁坂峠
    [665, 499050, 129300, 499950, 130200],   // 居倉,*中津峡,浜平,*両神山,十石峠,*神ヶ原
    [666, 478350, 120300, 479250, 121200],   // 越知面,*王在家,笠取山,*柳井川,*久万,*東川
    [667, 467550, 101400, 468450, 102300],   // 喜界島南部,*喜界島南部,喜界島南部,喜界島南部,喜界島北部,喜界島北部北部
    [668, 504450, 140100, 505350, 141000],   // 差首鍋,及位,丁岳,松ノ木峠,中直根,上笹子
    [669, 455850, 94200, 456750, 95100],   // *久米島南部,久米島南部,久米島,久米島
    [670, 471150, 111900, 472050, 112800],   // 稲尾岳,*半ヶ石,岸良,*上名,内之浦
    [671, 517500, 154200, 518400, 155100],   // 直別,音別,霧里,河原,ヌプキベツ,縫別
    [672, 464400, 119100, 465300, 120000],   // 津和崎,津和崎,小値賀島,小値賀島,宇久島,宇久島
    [673, 478350, 129300, 479250, 130200],   // *知夫,知夫,知夫,崎,浦郷,菱浦
    [674, 502650, 135600, 503550, 136500],   // 飯里,加納,大日岳,川入,飯豊山,岩倉
    [675, 466650, 102000, 467550, 102900],   // 赤尾木,赤木名,笠利崎
    [676, 504450, 148800, 505350, 149700],   // 白神岬,渡島吉岡,渡島福島,大千軒岳,*千軒
    [677, 469350, 117300, 470250, 118200],   // 三角,*松合,*雲仙,*網津,*島原,*肥後船津
    [678, 494100, 130800, 495000, 131700],   // 鹿間,下之本,東茂住,有峰湖,千垣,小見
    [679, 515250, 155700, 516150, 156600],   // 勢多山,萩ヶ岡,糠平,芽登温泉,幌加,幌加美里別ダム
    [680, 511200, 162600, 512100, 163500],   // エタンパック山,浅茅野,鬼志別,猿払,知来別,浜鬼志別
    [681, 494550, 125700, 495450, 126600],   // 高里,*三河大野,*三河湖,*海老,*寧比曽岳,*田口
    [682, 475650, 120000, 476550, 120900],   // 二名津,*伊予大島,三机,*湊浦,湊浦
    [683, 508500, 143100, 509400, 144000],   // 外山,岩洞,陸中南山形,藪川,陸中北山形,*小屋瀬
    [684, 511650, 160800, 512550, 161700],   // 筬島,音威子府,ペンケ山,小頓別,敏音知,上頓別
    [685, 472500, 117900, 473400, 118800],   // 祖母山,*見立,豊後柏原,小原,*桜町,*竹田
    [686, 505350, 143100, 506250, 144000],   // 番鳥森,上桧木内,比立内,戸鳥内,阿仁合,森吉山
    [687, 504900, 151500, 505800, 152400],   // 野田追岳,濁川,山越,落部,八雲
    [688, 468450, 119100, 469350, 120000],   // 牛屋,七ツ家,*牛津,*佐賀南部,*小城,*佐賀北部
    [689, 499050, 127200, 499950, 128100],   // 富士山,*須走,鳴沢,*富士吉田,*河口湖西部,*河口湖東部
    [690, 496800, 127800, 497700, 128700],   // 信濃大河原,塩見岳,鹿塩,間ノ岳,市野瀬,仙丈ヶ岳
    [691, 495450, 131100, 496350, 132000],   // 烏帽子岳,*大町南部,黒部湖,大町,十字峡,神城
    [692, 510300, 159900, 511200, 160800],   // 天塩有明,正修,初山別,大成,歌越,東野
    [693, 509400, 142800, 510300, 143700],   // 害鷹森,和井内,釜津田,陸中大川,早坂高原,門
    [694, 512550, 154200, 513450, 155100],   // 日高,千栄,占冠中央,双珠別湖,占冠,下トマム
    [695, 499050, 135000, 499950, 135900],   // 出雲崎,*与板,出雲崎,*寺泊,*弥彦
    [696, 475200, 123900, 476100, 124800],   // 安芸冠山,*湯来,野入,*戸河内,*出合原,*三段峡
    [697, 513000, 152100, 513900, 153000],   // 富沢,*歌笛,ペラリ山,美河,農屋,セタウシ山
    [698, 466650, 113700, 467550, 114600],   // 手打,青瀬,青瀬,中甑
    [699, 516150, 153000, 517050, 153900],   // 晩成,湧洞沼南部,生花,湧洞沼,二宮,*旅来
    [700, 510750, 154500, 511650, 155400],   // *雨霧山,紅葉山,*夕張,シュウパロ湖,美流渡,栄町
    [701, 511200, 158100, 512100, 159000],   // *鷹泊貯水池,沼牛,長留内岳,幌加内,三頭山,政和
    [702, 514350, 155400, 515250, 156300],   // 岩松,東ヌプカウシヌプリ,ニペソツ,然別湖,ペンケベツ,ウペペサンケ山ケ山
    [703, 476100, 118800, 477000, 119700],   // 魚神山,日振島,結出,戸島,遊子
    [704, 506700, 145800, 507600, 146700],   // 温川,*陸奥焼山,酸ヶ湯,八甲田山,*雲谷,田代平
    [705, 499500, 130800, 500400, 131700],   // 三ノ倉,*下室田,*榛名湖,*伊香保,*群馬原町,*金井
    [706, 504000, 127800, 504900, 128700],   // 五井,*蘇我,*千葉西部,*千葉東部,*習志野,*佐倉
    [707, 496800, 133500, 497700, 134400],   // 名立大町,*高田西部,名立大町,*直江津
    [708, 508050, 153900, 508950, 154800],   // 漁岳,恵庭岳,札幌岳,空沼岳,定山渓,*石山
    [709, 483750, 126900, 484650, 127800],   // 岩屋堂,*戸倉峠,若桜,*氷ノ山,*扇ノ山,*村岡
    [710, 469350, 113400, 470250, 114300],   // 春山,*鹿児島南部,*伊集院,*鹿児島北部,*薩摩郡山,*脇元
    [711, 493200, 129300, 494100, 130200],   // 飛騨大原,山之口,*六廐,位山,*夏廐,*三日町
    [712, 514350, 151200, 515250, 152100],   // 幌満,様似,アポイ岳,上杵臼,新富
    [713, 468000, 117000, 468900, 117900],   // 天草富岡,*御領,*口之津,*諫早南部,*肥前小浜
    [714, 508050, 162300, 508950, 163200],   // 仙法志,鬼脇,鴛泊,雄忠志内,鴛泊
    [715, 507150, 140700, 508050, 141600],   // 石淵ダム,*供養塚,夏油温泉,*金ヶ崎,和賀仙人,*北上
    [716, 502200, 132900, 503100, 133800],   // 湯西川,五十里湖,湯ノ花,荒海山,*松戸原,*糸沢
    [717, 500850, 126000, 501750, 126900],   // 初島,真鶴岬,*小田原南部
    [718, 503550, 151200, 504450, 152100],   // 相沼,熊石,渡島鮎川,貝取澗,遊楽部岳
    [719, 473400, 121200, 474300, 122100],   // 竹田津,姫島
    [720, 505350, 138000, 506250, 138900],   // *天童,関山峠,*楯岡,船形山,延沢,銀山温泉
    [721, 450450, 89100, 451350, 90000],   // 伊良部島,*平良,伊良部島,*西平安名岬,池間島,池間島
    [722, 502650, 131100, 503550, 132000],   // 下野大柿,*壬生,*鹿沼,*宇都宮西部,*文挾,*大谷
    [723, 469800, 108600, 470700, 109500],   // 栗生,*尾之間,尾之間,*宮之浦岳,安房
    [724, 472500, 112800, 473400, 113700],   // 都井岬,本城,幸島,*榎原,*油津
    [725, 516600, 154500, 517500, 155400],   // 東台,活平,宝生,川流布,*本別,栄穂
    [726, 477000, 125400, 477900, 126300],   // 出羽,*口羽町,*木路原,*赤名,*石見小原,*野萱
    [727, 465750, 118200, 466650, 119100],   // 池島,釜ノ浦,大立島,蛎浦
    [728, 461250, 96000, 462150, 96900],   // *辺土名,安波
    [729, 491400, 128700, 492300, 129600],   // 能郷白山,平家岳,*中竜鉱山,越前朝日,*荒島岳,下山
    [730, 504900, 153900, 505800, 154800],   // 歌棄,目名,島古丹,雷電山,雷電岬
    [731, 519300, 156300, 520200, 157200],   // 辺計礼山,*弟子屈,和琴,美留和,*屈斜路湖,川湯
    [732, 500400, 127500, 501300, 128400],   // 中川,*大山,大室山,*青野原,*上野原,*与瀬
    [733, 473400, 118200, 474300, 119100],   // 中津留,*千束,*三重町,佩楯山,*田中,*犬飼
    [734, 522900, 155400, 523800, 156300],   // 厚床,別当賀,風蓮,東梅,本別海
    [735, 501300, 132300, 502200, 133200],   // 丸沼,男体山,三平峠,川俣温泉,燧ヶ岳,帝釈山
    [736, 509850, 161700, 510750, 162600],   // 音類,*振老,稚咲内,*幌延,豊徳,豊富
    [737, 498600, 131100, 499500, 132000],   // 北軽井沢,*浅間隠山,*大前,*長野原,*上野草津,*小雨
    [738, 510300, 153900, 511200, 154800],   // 早来,幌内,*追,,*川端,*三川,*雨霧山
    [739, 518400, 156000, 519300, 156900],   // 雌阿寒岳,ピリカネップ,阿寒湖,雄阿寒岳,木禽岳,コトニヌプリ
    [740, 511200, 159000, 512100, 159900],   // 霧立峠,添牛内,羽幌岳,朱鞠内,ピッシリ山,蕗之台
    [741, 513900, 158700, 514800, 159600],   // 藻瀬狩山,茂瀬,名寄川上流,上札久留,一の橋,西興部
    [742, 508950, 137400, 509850, 138300],   // 網地島,金華山,網地島,金華山,*荻浜,*寄磯
    [743, 514800, 156600, 515700, 157500],   // 石狩岳,十勝三股,大雪湖,石北峠,大函,武利岳
    [744, 506700, 150900, 507600, 151800],   // *横津岳,臼尻,鹿部,鹿部,松屋崎
    [745, 515700, 156600, 516600, 157500],   // クマネシリ岳,東三国山,曲り沢峠,常元,富士見,大和
    [746, 513450, 160200, 514350, 161100],   // オシトツ,上雄武,シアッシリ山,中幌内,上音標,音標
    [747, 489600, 123000, 490500, 123900],   // 大台ヶ原山,*大杉峡谷,大和柏木,*宮川貯水池,大豆生,*七日市
    [748, 470700, 120300, 471600, 121200],   // 小石原,*英彦山,*筑前山田,*伊良原,*田川,*豊前本庄
    [749, 474750, 121200, 475650, 122100],   // *祝島,宇和島,祝島,室津,光,水場
    [750, 509400, 144900, 510300, 145800],   // 小軽米,*陸中大野,*階上岳,*種市,*新井田,角ノ浜
    [751, 471150, 116700, 472050, 117600],   // 椎原,不土野,*葉木,国見岳,*畝野,緑川
    [752, 498150, 137100, 499050, 138000],   // 両津北部,水津,小田,小田,鷲崎,鷲崎
    [753, 500850, 123000, 501750, 123900],   // 神津島,式根島,式根島,新島,新島
    [754, 484200, 120900, 485100, 121800],   // 牟岐,日和佐,*阿波由岐,*阿部
    [755, 493200, 128100, 494100, 129000],   // 美濃川合,*金山,*沢,*焼石,*郡上市島,*下呂
    [756, 503100, 125400, 504000, 126300],   // 布良,白浜,*館山,*千倉,*那古,*安房古川
    [757, 522000, 158100, 522900, 159000],   // 遠音別岳,八木浜,幌別,羅臼,知床五湖,硫黄山
    [758, 482850, 124200, 483750, 125100],   // 小江,寒霞渓,*牛窓,*片上,*日生
    [759, 507600, 153600, 508500, 154500],   // 双葉,白老岳,栄,*漁岳,中山峠,*札幌岳
    [760, 473850, 116700, 474750, 117600],   // *日向,*延岡,延岡北部,島浦
    [761, 468450, 112200, 469350, 113100],   // 坊,枕崎,坊,*枕崎,*野間岳,*加世田
    [762, 504450, 152100, 505350, 153000],   // 上八雲,*八雲,ルコツ岳,黒岩,美利河,国縫
    [763, 509850, 156900, 510750, 157800],   // 吉野,*石狩大和,国領,恵岱別,信砂御料,美葉牛
    [764, 477900, 118800, 478800, 119700],   // 川登,*蕨岡,口屋内,*大用,*江川崎,*田野々
    [765, 515250, 150900, 516150, 151800],   // 襟裳岬,襟裳岬,えりも,庶野,袴腰山,日高目黒
    [766, 510750, 161700, 511650, 162600],   // *安牛,上問寒別,*本流,豊神,日曹,上猿払
    [767, 504900, 144900, 505800, 145800],   // 藤琴,*早口,*真名子,*越山,*尾太岳,*田代岳
    [768, 506250, 130800, 507150, 131700],   // 那珂湊,常陸久慈,日立南部
    [769, 503100, 126600, 504000, 127500],   // *上総湊,鬼泪山,*富津,*鹿野山,大堀,*木更津
    [770, 481050, 125100, 481950, 126000],   // 豪渓,*東山内,*有漢市場,*下加茂,*呰部,*西川
    [771, 484200, 124500, 485100, 125400],   // 真浦,真浦,真浦,*網干,*姫路南部
    [772, 494100, 128400, 495000, 129300],   // *小和知,加子母,宮地,滝越,湯屋,御嶽山
    [773, 501750, 122400, 502650, 123300],   // 三宅島,三宅島,三宅島,三宅島
    [774, 505350, 150300, 506250, 151200],   // 桂岳,茂辺地,富里,陣屋,設計山,*木地挽山
    [775, 505350, 155100, 506250, 156000],   // 神恵内,*稲倉石,ポンネアンチシ山,*両古美山,余別,美国
    [776, 488250, 120600, 489150, 121500],   // 三尾川,*古座,*下露,*滝の拝,*木守,紀伊大野
    [777, 497250, 126600, 498150, 127500],   // 井川,*湯の森,畑薙湖,*梅ヶ島,上河内岳,七面山
    [778, 478350, 121800, 479250, 122700],   // 東三方ヶ森,*伊予小松,鈍川,*壬生川,*今治西部,*今治東部
    [779, 504450, 132900, 505350, 133800],   // 伊王野,*八溝山,*旗宿,*磐城金山,*白河,*泉崎
    [780, 462150, 97200, 463050, 98100],   // 与論島
    [781, 501750, 151200, 502650, 152100],   // 青苗,*青苗,赤石,赤石,神威脇,奥尻
    [782, 497250, 135900, 498150, 136800],   // 宿根木,小木,宿根木,*羽茂本郷,稲鯨,*河原田
    [783, 517950, 155400, 518850, 156300],   // 右股,布伏内,シュンクシタカラ湖,上徹別,上白愛,*雌阿寒岳
    [784, 460350, 96900, 461250, 97800],   // 伊是名島,伊平屋島南部,伊平屋島北部,伊平屋島北部,伊平屋島北部部
    [785, 500850, 133500, 501750, 134400],   // 奥只見湖,高幽山,未丈が岳,会津朝日岳,毛猛山,*田子倉湖
    [786, 501300, 124800, 502200, 125700],   // 大島南部,大島南部,大島北部,大島北部
    [787, 514800, 157500, 515700, 158400],   // 平山,上支湧別,北見峠,白滝,雄柏山,旧白滝
    [788, 489150, 128400, 490050, 129300],   // 竹波,杉津,*河野,糠,*糠
    [789, 504000, 139500, 504900, 140400],   // 清川,*羽根沢温泉,中野俣,*大沢,升田,*差首鍋
    [790, 498600, 132600, 499500, 133500],   // *鳥甲山,苗場山,*信濃森,*赤沢,松之山温泉,*大割野
    [791, 491400, 129300, 492300, 130200],   // *荒島岳,*下山,*越前勝山,願教寺山,北谷,加賀市ノ瀬
    [792, 488250, 122400, 489150, 123300],   // 伯母子岳,風屋,*上垣内,辻堂,*猿谷貯水池,*南日裏
    [793, 480150, 127800, 481050, 128700],   // 御来屋,*御来屋
    [794, 508950, 156300, 509850, 157200],   // 濃昼,*二番川,柏木,四番川,浜益,御料地
    [795, 520200, 155400, 521100, 156300],   // 五十石,中チャンベツ,*標茶,上チャンベツ,*磯,内,*泉川
    [796, 513450, 156300, 514350, 157200],   // 白金温泉,オプタテシケ山,藤山,トムラウシ山,俵真布,旭岳
    [797, 504000, 153300, 504900, 154200],   // 賀老,大平山,永豊,本目,寿都
    [798, 508500, 147600, 509400, 148500],   // *陸奥横浜,出戸,有畑,陸奥泊,*近川,小田野沢
    [799, 517050, 155100, 517950, 156000],   // *栄穂,ピラウンナイ川,奥仙美里,ウコタキヌプリ,螺湾,上螺湾
    [800, 498600, 125700, 499500, 126600],   // 駒越,興津,*蒲原,*吉原
    [801, 515700, 159000, 516600, 159900],   // 上渚滑,志文,*中渚滑,小向,*紋別
    [802, 508950, 157200, 509850, 158100],   // 群別岳,暑寒別岳,別苅,暑寒沢,別苅,増毛
    [803, 510300, 155100, 511200, 156000],   // 上志文,*美流渡,*岩見沢,*三笠,*美唄,*幾春別
    [804, 506250, 145500, 507150, 146400],   // *碇ヶ関,十和田湖西部,*沖浦,*温川,温湯,*酸ヶ湯
    [805, 510750, 162900, 511650, 163800],   // 曲淵,*鬼志別,モイマ山,*知来別,宗谷,峰岡
    [806, 445500, 87300, 446400, 88200],   // 西表大原,西表大原,美原,小浜島,鳩間島
    [807, 504000, 149700, 504900, 150600],   // 原口,七ツ岳,石崎,湯ノ岱,上ノ国,*桂岡
    [808, 490050, 121800, 490950, 122700],   // 磯崎,賀田,早田,*尾鷲,*九鬼
    [809, 503100, 152400, 504000, 153300],   // 太櫓,*北檜山,瀬棚,*丹羽,美谷,カスベ岳
    [810, 509400, 141600, 510300, 142500],   // 土淵,能舟木,*大出,*白見山,*高桧山,*江繋
    [811, 512100, 153300, 513000, 154200],   // 日高旭,貫気別山,*振内,豊糠,*仁世宇,三岩
    [812, 507600, 135300, 508500, 136200],   // 大甕,南海老,相馬中村
    [813, 505350, 139800, 506250, 140700],   // 神室山,鬼首峠,羽後川井,秋ノ宮,*横堀,*菅生
    [814, 495000, 129300, 495900, 130200],   // 木曽西野,*末川,*野麦,*寄合渡,*乗鞍岳,*梓湖
    [815, 516150, 156000, 517050, 156900],   // 喜登牛,上利別,喜登牛山,西斗満,*東三国山,勲祢別川上流
    [816, 497700, 129900, 498600, 130800],   // 蓼科山,*高野町,*春日本郷,*臼田,*丸子,*小諸
    [817, 510750, 141900, 511650, 142800],   // *陸中山田,霞露ヶ岳,津軽石,トドヶ崎,*宮古,閉伊崎
    [818, 510300, 158400, 511200, 159300],   // *達布,滝下,ルペシュペナイ川,大天狗岳,*三渓,白頭山
    [819, 502200, 139200, 503100, 140100],   // 三瀬,三瀬,羽前加茂
    [820, 471600, 121200, 472500, 122100],   // 蓑島,神ノ島,*喜多久
    [821, 506250, 143100, 507150, 144000],   // 田沢,*秋田駒ヶ岳,羽後玉川,*曲崎山,玉川温泉,*八幡平
    [822, 479250, 121200, 480150, 122100],   // 筒上山,*日比原,瓶ヶ森,*日ノ浦,*西条,*別子銅山
    [823, 490500, 124800, 491400, 125700],   // 佐田,*津西部,*平松,*椋本,*鈴鹿峠,*亀山
    [824, 508050, 145800, 508950, 146700],   // 切田,*五戸,*十和田,*犬落瀬,*七戸,*三沢
    [825, 493200, 130500, 494100, 131400],   // 角川,*林,*白木峰,*打保,*利賀,*猪谷
    [826, 478800, 126900, 479700, 127800],   // 上山佐,*布部,*玉造,*広瀬,*松江,*揖屋
    [827, 503550, 135900, 504450, 136800],   // 飯森山,白布温泉,*入田沢,*米沢,*玉庭,*米沢北部
    [828, 505800, 147600, 506700, 148500],   // 津軽小国,*蟹田,大川平,*陸奥平館,袰月,袰月
    [829, 502200, 136200, 503100, 137100],   // 二王子岳,*飯豊山,エブリ差岳,*長者原,安角,*小国
    [830, 509850, 160800, 510750, 161700],   // 遠別,丸松,天塩,*更岸
    [831, 476550, 121800, 477450, 122700],   // 周防小泊,由利島,伊保田,津和地,柱島,鹿老渡
    [832, 513000, 159600, 513900, 160500],   // 見晴山,サンル,ピヤシリ山,幌内越峠,仁宇布,*オシトツ
    [833, 513000, 160500, 513900, 161400],   // 黒岩山,*シアッシリ山,上徳志別,*上音標,*志美宇丹,乙忠部
    [834, 513900, 153600, 514800, 154500],   // 礼内岳,*拓成,妙敷山,*上美生,芽室岳,渋山
    [835, 508500, 144000, 509400, 144900],   // 宇別,*葛巻,仁昌寺,*陸中戸田,*一戸,*伊保内
    [836, 495450, 132600, 496350, 133500],   // 小川温泉,*越後平岩,親不知,*小滝,親不知,*糸魚川
    [837, 503550, 137700, 504450, 138600],   // 朝日岳,*太郎,大井沢,*貫見,*赤見堂岳,本道寺
    [838, 471150, 115500, 472050, 116400],   // 白髪岳,田代ヶ八重,*免田,*槻木,*多良木,*市房山
    [839, 506700, 144600, 507600, 145500],   // *花輪,四角岳,*毛馬内,犬吠森,小坂鉱山,*中滝
    [840, 516150, 157500, 517050, 158400],   // 花丘,*留辺蘂西部,岩戸,伊吹,*瀬戸瀬温泉,生田原
    [841, 487350, 123000, 488250, 123900],   // 龍門山,*高野山,*粉河,*橋本,*内畑,*岩湧山
    [842, 495450, 124500, 496350, 125400],   // 中田島,掛塚,*浜松,*磐田,*気賀,*笠井
    [843, 472950, 114300, 473850, 115200],   // 日向青島,*宮崎,*宮崎北部
    [844, 491850, 122700, 492750, 123600],   // 片田,相賀浦,*浜島
    [845, 511650, 154500, 512550, 155400],   // 長和,ニニウ,白金,屏風山,滝ノ沢岳,夕張岳
    [846, 505350, 127200, 506250, 128100],   // 東浪見,*四天木,*上総片貝,*木戸
    [847, 506700, 147900, 507600, 148800],   // *脇野沢,脇野沢,源藤城,*陸奥川内,牛滝,*陸奥畑
    [848, 511200, 159900, 512100, 160800],   // 遠別川上流,苫頓別山,茶古志山,小車岳,共和,小車
    [849, 506250, 135300, 507150, 136200],   // 飯樋,*小宮,*萩平,*磐城草野,*霊山,*青葉
    [850, 464850, 122400, 465750, 123300],   // 豆酘,豆酘,豆酘,*小茂田,*厳原
    [851, 470700, 123300, 471600, 124200],   // 滝部,*滝部,角島,阿川,長門川尻
    [852, 488250, 127200, 489150, 128100],   // *久坂,古屋,*小浜,*遠敷,鋸崎,*西津
    [853, 495450, 127800, 496350, 128700],   // 兀岳,*飯田,南木曽岳,*安平路山,*木曽須原,*空木岳
    [854, 507150, 162900, 508050, 163800],   // 香深,礼文岳,礼文岳,船泊,船泊
    [855, 501300, 133200, 502200, 134100],   // 会津駒ヶ岳,檜枝岐,*高幽山,内川,*会津朝日岳,城郭朝日山
    [856, 502200, 134400, 503100, 135300],   // 野尻,博士山,*沼沢沼,*宮下,*安座,*柳津
    [857, 479250, 126000, 480150, 126900],   // 道後山,*油野,*多里,*上石見,*阿毘縁,*印賀
    [858, 480600, 120300, 481500, 121200],   // 土佐長浜,*高知,*後免,*土佐山,*土佐山田
    [859, 464400, 118200, 465300, 119100],   // *奈良尾,友住,*有川,友住,立串,頭ヶ島
    [860, 511200, 155400, 512100, 156300],   // 桂沢湖,幾春別岳,芦別湖,崕山,美唄山,*奥芦別
    [861, 505800, 132600, 506700, 133500],   // 磐城片貝,*川部,*橋場,*上平石,*磐城新宿,*上遠野
    [862, 503550, 149100, 504450, 150000],   // 松前,江良,江良,原口,*原口
    [863, 507600, 133500, 508500, 134400],   // 四倉,下浅見川,井出
    [864, 498600, 136500, 499500, 137400],   // 岩首,水津,*水津
    [865, 504900, 143100, 505800, 144000],   // 太平山,*番鳥森,天上倉山,*比立内,八木沢,*阿仁合
    [866, 517950, 156300, 518850, 157200],   // イユダニヌプリ山,*阿寒湖,北見相生,*木禽岳,*本岐,上里
    [867, 508950, 153900, 509850, 154800],   // 支笏湖温泉,*胆振蘭越,島松山,*恵庭,*清田,*石狩広島
    [868, 508950, 148500, 509850, 149400],   // 猿ヶ森,尻屋,尻尾崎
    [869, 512100, 162000, 513000, 162900],   // *下頓別,斜内,*浜頓別,頓別,浅茅野台地
    [870, 473400, 123300, 474300, 124200],   // 長門峡,*大原湖,*生雲中,*徳佐中,*長門広瀬,*十種峰
    [871, 482400, 123900, 483300, 124800],   // 豊島,*土庄,犬島,*小江,*西大寺,*牛窓
    [872, 471600, 110700, 472500, 111600],   // 国上,国上
    [873, 502650, 143400, 503550, 144300],   // 加茂青砂,*船川,戸賀,*北浦,戸賀
    [874, 467100, 114000, 468000, 114900],   // *青瀬,*中甑,里,海鼠池,里
    [875, 508050, 150300, 508950, 151200],   // 恵山,渡島銚子
    [876, 480600, 123000, 481500, 123900],   // 紫雲出山,*仁尾,*六島,*讃岐粟島,*白石島,讃岐広島
    [877, 472050, 92700, 472950, 93600],   // 南大東島,南大東島,南大東島,南大東島,*北大東島,北大東島
    [878, 473850, 119700, 474750, 120600],   // 家島,佐賀関,住吉浜,*下原
    [879, 490950, 128400, 491850, 129300],   // 美濃徳山,*能郷,冠山,*能郷白山,*宝慶寺,*中竜鉱山
    [880, 442350, 87900, 443250, 88800],   // 与那国島,与那国島
    [881, 501750, 138000, 502650, 138900],   // 笹川,蒲萄,寒川,*勝木,*鼠ヶ関
    [882, 511650, 97200, 512550, 98100],   // 父島,兄島,兄島
    [883, 477900, 125700, 478800, 126600],   // 櫃田,*比和,*頓原,*比婆新市,*出雲吉田,*阿井町
    [884, 485550, 122700, 486450, 123600],   // 初島町,由良,加太,*由良,加太
    [885, 505800, 147000, 506700, 147900],   // 源八森,*油川,大倉岳,*蓬田,*津軽小国,*蟹田
    [886, 465750, 120300, 466650, 121200],   // 生月島北部,的山大島,的山大島,二神島
    [887, 501750, 135000, 502650, 135900],   // 御神楽岳,*安座,*越後豊川,*徳沢,*津川,日出谷
    [888, 512550, 151500, 513450, 152400],   // 三石,東静内,*富沢
    [889, 495000, 131400, 495900, 132300],   // 立山,*黒部湖,劒岳,*十字峡,毛勝山,欅平
    [890, 509400, 144600, 510300, 145500],   // 戸呂町,*大川目,*小軽米,*陸中大野,*階上岳,*種市
    [891, 487800, 121800, 488700, 122700],   // 恩行司,*発心門,*龍神,*重里,*護摩壇山,*伯母子岳
    [892, 504450, 151200, 505350, 152100],   // ササマクリ山,乙部岳,砂蘭部岳,*野田追岳,春日,*山越
    [893, 497250, 127500, 498150, 128400],   // 赤石岳,新倉,*塩見岳,奈良田,*間ノ岳,*夜叉神峠
    [894, 521550, 157800, 522450, 158700],   // 海別岳,根室峯浜,真鯉,*遠音別岳,宇登呂,*幌別
    [895, 516150, 154800, 517050, 155700],   // 十勝高島,*宝生,*押帯,*本別,*活込,*足寄太
    [896, 448650, 88500, 449550, 89400],   // 多良間島,多良間島,水納島
    [897, 508950, 138900, 509850, 139800],   // 折立,陸前相川,*志津川,*伊里前,*馬籠,*津谷
    [898, 494550, 130500, 495450, 131400],   // 長倉,笠ヶ岳,*下之本,三俣蓮華岳,*有峰湖,薬師岳
    [899, 490950, 129900, 491850, 130800],   // 龍谷,*北谷,山中,*加賀丸山,*動橋,*尾小屋
    [900, 519300, 155400, 520200, 156300],   // *鶴居,下久著呂,*茂雪裡,*中久著呂,奥久著呂,*上オソツベツ
    [901, 513450, 155400, 514350, 156300],   // 北落合,佐幌岳,シーソラプチ川上流,十勝ペンケ山,十勝岳,チカベツ山ツ山
    [902, 504000, 138600, 504900, 139500],   // 月山,*葉山,立谷沢,*肘折,木の沢,*古口
    [903, 504450, 145800, 505350, 146700],   // 川原平,*陸奥田代,*枯木平,*岩木山,*種里,*十面沢
    [904, 511200, 153600, 512100, 154500],   // 胆振豊田,*荷負,上幌内,*穂別,十三里,*稲里
    [905, 457650, 94200, 458550, 95100],   // 久場島,座間味,渡名喜島
    [906, 468450, 116100, 469350, 117000],   // 宮野河内,唐木崎,*小宮地,*棚底,*本渡,*大島子
    [907, 478350, 117600, 479250, 118500],   // 足摺岬,足摺岬,*土佐清水,津呂,*下ノ加江,大名鹿
    [908, 509400, 162300, 510300, 163200],   // 清明,*豊徳,夕来,*兜沼,抜海,*上勇知
    [909, 513900, 159900, 514800, 160800],   // 毛鐘尻山,*トーウツ岳,*上雄武,*雄武,*中幌内,北見幌内
    [910, 520200, 156900, 521100, 157800],   // 摩周湖北部,養老牛温泉,*緑,サマッケヌプリ山,*札弦,*斜里岳
    [911, 513900, 158100, 514800, 159000],   // 宇江内山,天塩岳,於鬼頭岳,渚滑岳,*藻瀬狩山,*茂瀬
    [912, 496350, 126600, 497250, 127500],   // 水窪湖,寸又峡温泉,*伊那和田,*池口岳,*上町,*光岳
    [913, 493650, 135000, 494550, 135900],   // 馬緤,珠州岬
    [914, 513450, 157200, 514350, 158100],   // 石狩瑞穂,*愛山渓温泉,東山,*菊水,*中愛別,*上川
    [915, 507600, 144900, 508500, 145800],   // 石亀,*上斗米,*清水頭,*田子,*戸来岳,*金ヶ沢
    [916, 506700, 141600, 507600, 142500],   // *新町,尻平川,*陸中猿橋,*鉛,北川舟,*須賀倉山
    [917, 462600, 117000, 463500, 117900],   // 坪,玉之浦,*玉之浦,嵯峨ノ島,*三井楽
    [918, 500850, 134400, 501750, 135300],   // 守門岳,*只見,*光明山,*駒形山,*粟ヶ岳,室谷
    [919, 512100, 155400, 513000, 156300],   // 芦別岳,*山部,布部岳,*布部,*島ノ下,*富良野
    [920, 506700, 154500, 507600, 155400],   // 瑞穂,本倶登山,*赤井川,*阿女鱒岳,*仁木,*於古発山
    [921, 517050, 153300, 517950, 154200],   // 湧洞沼,*十勝大津,*浦幌,厚内
    [922, 503100, 145200, 504000, 146100],   // 岩館,大間越,十二湖,*十二湖
    [923, 476550, 117900, 477450, 118800],   // 鵜来島,*母島,高茂岬,*福浦,伊予鹿島,*城辺
    [924, 503100, 153300, 504000, 154200],   // 須築,狩場山,原歌
    [925, 497700, 134100, 498600, 135000],   // 柿崎,*柿崎,青梅川
    [926, 507600, 149100, 508500, 150000],   // 下風呂,木野部
    [927, 508500, 156900, 509400, 157800],   // 幌,*浜益,雄冬,*群別岳,別苅,*別苅
    [928, 521100, 155700, 522000, 156600],   // フッポウシ川,矢臼別,*西春別,*中西別,*計根別,*上春別
    [929, 508500, 159600, 509400, 160500],   // 焼尻島,*焼尻島,焼尻島,焼尻島
    [930, 503100, 137100, 504000, 138000],   // *五味沢,羽前上郷,徳網,羽前葉山,相模山,*朝日岳
    [931, 515700, 157500, 516600, 158400],   // ,岐,*花丘,上武利,*岩戸,*丸瀬布南部,*瀬戸瀬温泉
    [932, 504900, 155400, 505800, 156300],   // 珊内,*ポンネアンチシ山,神威岬,*余別,*神威岬,積丹岬
    [933, 465300, 101400, 466200, 102300],   // *奄美久慈,山間,*湯湾,*住用,大棚,*名瀬西部
    [934, 511650, 157800, 512550, 158700],   // 江丹別,*鷹栖,*沼牛,*福原,*幌加内,*三和
    [935, 502200, 121800, 503100, 122700],   // 御蔵島,御蔵島,*三宅島
    [936, 479250, 119100, 480150, 120000],   // 興津浦,*窪川,土佐志和,*久礼,一子碆
    [937, 504450, 135600, 505350, 136500],   // 吾妻山,*土湯温泉,天元台,*板谷,*米沢東部,*栗子山
    [938, 505800, 155400, 506700, 156300],   // *両古美山,*豊浜,*美国,古平,積丹岬
    [939, 503100, 127500, 504000, 128400],   // 東扇島,*奈良輪,*東京国際空港,*東京南部,*浦安
    [940, 511200, 156300, 512100, 157200],   // 文珠,*上芦別,*赤平,*芦別,*イルムケップ山,*石狩新城
    [941, 522900, 156300, 523800, 157200],   // 床丹,野付崎,野付崎
    [942, 517950, 155100, 518850, 156000],   // 上茶路,*上庶路,*右股,*布伏内,*シュンクシタカラ湖,*上徹別
    [943, 503100, 151800, 504000, 152700],   // 久遠,*貝取澗,後志太田,*左股,*太櫓,*北檜山
    [944, 477450, 127500, 478350, 128400],   // 日御碕,*平田,坂浦,坂浦,坂浦
    [945, 514350, 152400, 515250, 153300],   // ピリカヌプリ,トヨニ岳,神威岳,ヌビナイ川上流,ポンヤオロマップ岳,拓進  拓進
    [946, 486000, 123600, 486900, 124500],   // *尾崎,田之代
    [947, 501300, 132000, 502200, 132900],   // 皇海山,中禅寺湖,*丸沼,*男体山,*三平峠,*川俣温泉
    [948, 499050, 132000, 499950, 132900],   // 野反湖,*四万,佐武流山,*三国峠,*苗場山,*土樽
    [949, 510750, 159300, 511650, 160200],   // 幌別山,*羽幌岳,羽幌貯水池,*ピッシリ山,*正修,*遠別川上流
    [950, 492300, 129600, 493200, 130500],   // 二ノ峰,*新淵,白山,*御母衣,新岩間温泉,*平瀬
    [951, 505800, 150000, 506700, 150900],   // 当別,立待岬,*茂辺地,*函館,*陣屋,*七飯
    [952, 524700, 156000, 525600, 156900],   // 納沙布
    [953, 486900, 120600, 487800, 121500],   // *紀伊日置,鴨居,*富田,*紀伊白浜,*紀伊田辺
    [954, 504000, 140400, 504900, 141300],   // 湯ノ台,*丁岳,鳥海山,*中直根,*川辺,*矢島
    [955, 517050, 158700, 517950, 159600],   // *芭露,サロマ湖,*登栄床,三里浜
    [956, 446400, 87300, 447300, 88200],   // 竹富島,竹富島,石垣,*石垣,川平,*伊野田
    [957, 513000, 161400, 513900, 162300],   // *下幌別,徳志別,*枝幸,目梨泊
    [958, 519300, 158100, 520200, 159000],   // *藻琴,浜小清水,*網走,能取岬
    [959, 509850, 158700, 510750, 159600],   // 港町,*ルペシュペナイ川,*力昼,*三渓,*苫前,*上羽幌
    [960, 483300, 128100, 484200, 129000],   // 田後,*浜坂
    [961, 515250, 151800, 516150, 152700],   // 広尾岳,音調津,*札楽古,*広尾,*中豊似,*豊似
    [962, 487800, 120300, 488700, 121200],   // 江住,田並,*江住,*三尾川,*市鹿野,*下露
    [963, 509850, 156600, 510750, 157500],   // 南幌加,*総進,*吉野,*石狩大和,*国領,*恵岱別
    [964, 509850, 163500, 510750, 164400],   // 野寒布岬,富磯
    [965, 470250, 122100, 471150, 123000],   // 岩屋,*六連島,白島,六連島,蓋井島
    [966, 490950, 122700, 491850, 123600],   // 錦,見江島,*古和浦,*贄浦
    [967, 467100, 120600, 468000, 121500],   // 波戸岬,*呼子,加唐島,小川島,*印通寺,烏帽子島
    [968, 516150, 152400, 517050, 153300],   // 豊似,浜大樹,*晩成,*湧洞沼南部
    [969, 502650, 137400, 503550, 138300],   // 三面,*徳網,円吾山,*相模山,鳴海山,大鳥池
    [970, 514350, 156300, 515250, 157200],   // トムラウシ山,ニペソツ山,五色ヶ原,*石狩岳,白雲岳,*大雪湖
    [971, 499950, 132900, 500850, 133800],   // 巻機山,奥利根湖,*六日町,*兎岳,*五日町,*八海山
    [972, 465750, 124800, 466650, 125700],   // 泉
    [973, 521100, 154500, 522000, 155400],   // 尻羽岬,床潭,*厚岸,*厚岸湖,*釧路太田,*糸魚沢
    [974, 522450, 158700, 523350, 159600],   // *硫黄山,岬,ルシャ川,知床岳,知床岬,知床岬
    [975, 511200, 95400, 512100, 96300],   // 母島南部,母島南部,母島北部,母島北部,母島北部
    [976, 521100, 156900, 522000, 157800],   // 第二俣落,*武佐,俣落岳,*武佐岳,*瑠辺斯岳,*西古多糠
    [977, 501300, 123900, 502200, 124800],   // 鵜渡根島,利島
    [978, 486450, 128700, 487350, 129600],   // 丹後中浜,丹後中浜
    [979, 500400, 129000, 501300, 129900],   // 武蔵日原,*原市場,*秩父,*正丸峠,*皆野,*安戸
    [980, 510750, 162600, 511650, 163500],   // 下豊別,*エタンパック山,*曲淵,*鬼志別,*モイマ山,*知来別
    [981, 504000, 153000, 504900, 153900],   // メップ岳,二股温泉,*賀老,*大平山,*永豊,*本目
    [982, 492750, 124200, 493650, 125100],   // 答志,伊良湖岬,*福江,*師崎,*佐久島
    [983, 508050, 152400, 508950, 153300],   // 登別温泉,*登別温泉,登別温泉,*飛生,*白老
    [984, 491850, 133200, 492750, 134100],   // 能登福浦,*能登高浜,*富来,*中島,*剣地,*下唐川
    [985, 513450, 152700, 514350, 153600],   // *セタウシ山,ピリガイ山,日高大山,ヤオロマップ岳,イドンナップ岳,札内川上流   札内川上流
    [986, 486000, 122400, 486900, 123300],   // 箕島,*湯浅,*初島町,*海南,*加太,*和歌山
    [987, 500850, 138300, 501750, 139200],   // 粟島,粟島
    [988, 508950, 141900, 509850, 142800],   // 竪沢,*大出,*早池峰山,*高桧山,*松草,*陸中川内
    [989, 507600, 154500, 508500, 155400],   // 無意根山,*定山渓,*余市岳,*手稲山,*張碓,*銭函
    [990, 457650, 95400, 458550, 96300],   // 粟国島,*粟国島,粟国島,*粟国島
    [991, 518850, 158700, 519750, 159600],   // 能取岬,*能取岬
    [992, 503100, 116700, 504000, 117600],   // 八丈青ヶ島
    [993, 505350, 151200, 506250, 152100],   // 狗神岳,*姫川,*濁川,*渡島森,*落部
    [994, 505800, 144000, 506700, 144900],   // 太平湖,サンケ森,*明利又,*大葛,*扇田,*十二所
    [995, 467550, 110700, 468450, 111600],   // 薩摩黒島,薩摩黒島
    [996, 469350, 108600, 470250, 109500],   // 栗生,*栗生,*栗生,*尾之間,*永田岳,*宮之浦岳
    [997, 472050, 124500, 472950, 125400],   // 見島
    [998, 510750, 163800, 511650, 164700],   // 宗谷岬
    [999, 505350, 142800, 506250, 143700],   // 羽後庄内,*下桧木内,*番鳥森,*上桧木内,*比立内,*戸鳥内
    [1000, 487800, 127800, 488700, 128700],   // 難波江,*鋸崎
    [1001, 514350, 152100, 515250, 153000],   // 日高幌別川上流,楽古岳,*ピリカヌプリ,*トヨニ岳,*神威岳,*ヌビナイ川上流ナイ川上流
    [1002, 503550, 144300, 504450, 145200],   // 羽後浜田,*森岳,能代,*能代,*羽後水沢
    [1003, 494550, 124500, 495450, 125400],   // 高塚,*二川,*新居町,*豊橋,*三ヶ日
    [1004, 496800, 132300, 497700, 133200],   // 高妻山,*信濃柏原,*妙高山,*赤倉,*湯川内,*関山
    [1005, 459000, 94500, 459900, 95400],   // 慶伊瀬島,*大謝名,*高志保,残波岬
    [1006, 473400, 115200, 474300, 116100],   // 日向日置,*高鍋,*川南
    [1007, 496350, 124500, 497250, 125400],   // 向岡,*千浜,*袋井,*下平川,*山梨,*掛川
    [1008, 500850, 132900, 501750, 133800],   // 尾瀬ヶ原,*燧ヶ岳,平ガ岳,*会津駒ヶ岳,*奥只見湖,*高幽山
    [1009, 513900, 159600, 514800, 160500],   // 奥興部,*上興部,*毛鐘尻山,*トーウツ岳,*上雄武,*雄武
    [1010, 513000, 153300, 513900, 154200],   // 新冠湖,*イドンナップ岳,ヌカンライ岳,幌尻岳,二岐岳,ピパイロ岳
    [1011, 504000, 146700, 504900, 147600],   // 田野沢,*鰺ヶ沢
    [1012, 468450, 114000, 469350, 114900],   // 荒川浜,*串木野,*羽島,*川内,*西方,*東郷
    [1013, 479700, 130200, 480600, 131100],   // *都万,西郷,*隠岐北方,布施,西村
    [1014, 472950, 122100, 473850, 123000],   // 竹島,*佐波島,*台道,*防府,*小郡,*矢田
    [1015, 467100, 107100, 468000, 108000],   // 中之島,中之島,中之島,中之島,口之島
    [1016, 463500, 117000, 464400, 117900],   // 坪,黄島,*富江,崎山,*五島福江,螺蠑島
    [1017, 471600, 123900, 472500, 124800],   // 長門古市,青海島北部
    [1018, 445500, 86400, 446400, 87300],   // 波照間島,*西表大原,黒島
    [1019, 507150, 140400, 508050, 141300],   // 鳴沢温泉,*古戸,*石淵ダム,*供養塚,*夏油温泉,*金ヶ崎
    [1020, 510300, 142200, 511200, 143100],   // 高滝森,*津軽石,*茂市,*宮古,*峠ノ神山,*田老
    [1021, 497700, 124800, 498600, 125700],   // 相良,*住吉,*焼津
    [1022, 473850, 124800, 474750, 125700],   // 飯浦,*益田,*高島,高島
    [1023, 483300, 120300, 484200, 121200],   // 伏越ノ鼻,*甲浦,*奥浦,*牟岐
    [1024, 479700, 122700, 480600, 123600],   // 魚島,伊吹島,魚島,百貫島,*宇治島
    [1025, 478800, 128100, 479700, 129000],   // 瀬崎,瀬崎
    [1026, 475200, 118800, 476100, 119700],   // 保戸島,*水ノ子島,保戸島,*日振島,*戸島
    [1027, 482850, 119400, 483750, 120300],   // 室戸岬,*室戸岬,*佐喜浜
    [1028, 502200, 141000, 503100, 141900],   // 飛島
    [1029, 505350, 154800, 506250, 155700],   // 後志泊,*茅沼,*神恵内,*稲倉石,*ポンネアンチシ山,*両古美山
    [1030, 468000, 120900, 468900, 121800],   // 芥屋,*宮浦,玄界島
    [1031, 468450, 109500, 469350, 110400],   // 口永良部島,口永良部島
    [1032, 507150, 147600, 508050, 148500],   // 小湊,*脇野沢,*陸奥川内,*戸沢
    [1033, 511650, 151800, 512550, 152700],   // 東静内,静内,*静内
    [1034, 513000, 153000, 513900, 153900],   // 岩清水,*日高大山,*新冠湖,*イドンナップ岳,*ヌカンライ岳,*幌尻岳岳
    [1035, 446400, 87000, 447300, 87900],   // 黒島,*竹富島,*竹富島,*石垣,*石垣
    [1036, 447300, 88500, 448200, 89400],   // 平久保崎
    [1037, 497250, 128700, 498150, 129600],   // 甲斐駒ヶ岳,*長坂上条,*信濃富士見,*小淵沢,*茅野,*八ヶ岳西部
    [1038, 500400, 124800, 501300, 125700],   // 下田,*稲取,*天城山,*富戸
    [1039, 501300, 137100, 502200, 138000],   // 坂町,*坂町,*村上,*柏尾
    [1040, 516600, 159300, 517500, 160200],   // 沼上浜
    [1041, 508500, 88800, 509400, 89700],   // 硫黄島,硫黄島,*硫黄島
    [1042, 480600, 122700, 481500, 123600],   // 伊吹島,*観音寺,*紫雲出山,*仁尾,*六島,*讃岐粟島
    [1043, 522900, 155100, 523800, 156000],   // 厚床,落石岬,*厚床,*別当賀,*風蓮,*東梅
    [1044, 483750, 123300, 484650, 124200],   // 引田
    [1045, 504900, 148500, 505800, 149400],   // 龍飛崎,*渡島福島
    [1046, 484650, 122400, 485550, 123300],   // 阿波富岡,板東,諭鶴羽山,*鳴門海峡,*諭鶴羽山
    [1047, 444600, 87000, 445500, 87900],   // 仲御神島,*ウビラ石,舟浮,船浦
    [1048, 503100, 146100, 504000, 147000],   // 深浦,*深浦,*驫木
    [1049, 513900, 152400, 514800, 153300],   // 元浦川上流,*ピリカヌプリ,*ピリガイ山,*神威岳,*ヤオロマップ岳,*ポンヤオロマップ岳ポンヤオロマップ岳
    [1050, 477900, 117600, 478800, 118500],   // 下川口,*足摺岬,*下川口,*土佐清水,*来栖野,*下ノ加江
    [1051, 464850, 104700, 465750, 105600],   // 宝島,小宝島
    [1052, 466200, 105900, 467100, 106800],   // 悪石島,諏訪瀬島
    [1053, 476550, 121200, 477450, 122100],   // 伊予青島,上灘,大水無瀬島,*周防小泊,*由利島
    [1054, 522450, 157200, 523350, 158100],   // 伊茶仁
    [1055, 461700, 95700, 462600, 96600],   // 高江,*安波
    [1056, 465300, 100500, 466200, 101400],   // 秋徳,秋徳,*古仁屋,節子
    [1057, 499050, 124800, 499950, 125700],   // 伊豆松崎,*伊豆松崎,*仁科,*仁科,*土肥
    [1058, 465300, 118500, 466200, 119400],   // 肥前江島,肥前江島,*大立島,野子,帆上ノ瀬
    [1059, 466200, 119100, 467100, 120000],   // 肥前黒島,*佐世保南部,*楠泊,*佐世保北部,*肥前川内,*江迎
    [1060, 481050, 123900, 481950, 124800],   // 水島港,*下津井,*玉島,*茶屋町,*箭田,*倉敷
    [1061, 513450, 154200, 514350, 155100],   // ペンケヌーシ岳,*芽室岳,*沙流岳,*十勝石山,*上トマム,*新得
    [1062, 465750, 123300, 466650, 124200],   // 鶏知,仁位,*志多賀
    [1063, 506700, 142500, 507600, 143400],   // 羽後朝日岳,*鶯宿,*国見温泉,*雫石,*秋田駒ヶ岳,*篠崎
    [1064, 468900, 110700, 469800, 111600],   // 薩摩硫黄島,薩摩竹島
    [1065, 514800, 159300, 515700, 160200],   // 欝岳,*中宇津々,*秋里,*豊野,*興部,*沙留
    [1066, 472500, 123900, 473400, 124800],   // 通,*越ヶ浜,相島,*櫃島
    [1067, 491850, 134400, 492750, 135300],   // 皆月,*皆月,*七ツ島
    [1068, 489600, 130200, 490500, 131100],   // 三国,*三国,北潟,*北潟
    [1069, 495450, 130500, 496350, 131400],   // 穂高岳,*信濃小倉,槍ヶ岳,*有明,*烏帽子岳,*大町南部
    [1070, 509850, 159900, 510750, 160800],   // 天塩有明,*天塩有明,*初山別,*歌越
    [1071, 466200, 106800, 467100, 107700],   // 平島,諏訪瀬島,臥蛇島
    [1072, 450450, 88800, 451350, 89700],   // 上地,*上地,*伊良部島,*平良,*伊良部島,*西平安名岬
    [1073, 502200, 135900, 503100, 136800],   // 蒜場山,*大日岳,*二王子岳,*飯豊山,*エブリ差岳,*長者原
    [1074, 512550, 160800, 513450, 161700],   // 屋根棟山,*上徳志別,*本幌別,*志美宇丹,*歌登,*下幌別
    [1075, 553950, 87300, 554850, 88200],   // 南鳥島
    [1076, 460350, 93900, 461250, 94800],   // 久高島,*津堅,*屋慶名
    [1077, 463950, 99300, 464850, 100200],   // 伊仙崎,*伊仙,*亀津,*平土野,*ジャナレ島
    [1078, 520200, 158100, 521100, 159000],   // 止別,*斜里
    [1079, 467550, 115500, 468450, 116400],   // 片島,*指江,魚貫崎,*牛深,*大江,*河浦
    [1080, 508500, 156300, 509400, 157200],   // *濃昼,柏木,*柏木,*幌,*浜益
    [1081, 464850, 100800, 465750, 101700],   // 与路,*秋徳,*瀬武,*古仁屋,*西古見,*奄美久慈
    [1082, 472050, 112500, 472950, 113400],   // 内之浦,*都井岬,*都井岬,*串間,*本城
    [1083, 492750, 136200, 493650, 137100],   // 舳倉島
    [1084, 474750, 117000, 475650, 117900],   // 深島
    [1085, 501300, 149100, 502200, 150000],   // 渡島大島,渡島大島,渡島大島,渡島大島
    [1086, 466650, 117000, 467550, 117900],   // 野母崎,*野母,端島,*肥前高島,*長崎西南部
    [1087, 458100, 93900, 459000, 94800],   // 阿波連岬,*座間味,前島,前島
    [1088, 461700, 114900, 462600, 115800],   // 男島及女島,*男島及女島,男島及女島,男島及女島
    [1089, 475650, 117600, 476550, 118500],   // 鵜来島,*沖黒島
    [1090, 476550, 127200, 477450, 128100],   // *大社,*日御碕,日御碕
    [1091, 477450, 122400, 478350, 123300],   // 安居島,*菊間,上黒島,*大浜,*仁方,*大長
    [1092, 506250, 152100, 507150, 153000],   // *伊達
    [1093, 511200, 99000, 512100, 99900],   // *嫁島,媒島,聟島,聟島
    [1094, 475650, 121200, 476550, 122100],   // 周防八島,*平郡島,*平郡島東部,*阿月,*安下庄
    [1095, 444150, 92400, 445050, 93300],   // 魚釣島,魚釣島,*魚釣島
    [1096, 445050, 93000, 445950, 93900],   // 黄尾嶼,黄尾嶼
    [1097, 456750, 94800, 457650, 95700],   // 久米島東部,渡名喜島
    [1098, 463950, 103500, 464850, 104400],   // 横当島,横当島
    [1099, 463950, 119100, 464850, 120000],   // 肥前赤島,*津和崎,肥前赤島,*小値賀島,*宇久島
    [1100, 465750, 110700, 466650, 111600],   // 草垣群島,草垣群島
    [1101, 465750, 111900, 466650, 112800],   // 宇治群島,*宇治群島,宇治群島,*宇治群島
    [1102, 468000, 112800, 468900, 113700],   // 野間岳,*野間岳,片浦,*片浦,*久多島
    [1103, 470700, 110400, 471600, 111300],   // 馬毛島,*西之表,馬毛島
    [1104, 474300, 116400, 475200, 117300],   // 
    [1105, 476100, 122400, 477000, 123300],   // 伊勢小島,*柱島,甲島,*大君,*阿多田島,*江田島
    [1106, 485100, 121500, 486000, 122400],   // 伊島,伊島
    [1107, 492300, 135300, 493200, 136200],   // 七ツ島,七ツ島
    [1108, 504000, 150600, 504900, 151500],   // 江差,*江差,乙部,*乙部,*相沼,*ササマクリ山
    [1109, 505350, 152400, 506250, 153300],   // 国縫,*長万部,*礼文華
    [1110, 508500, 91200, 509400, 92100],   // 北硫黄島,北硫黄島
    [1111, 511200, 142800, 512100, 143700],   // 田老,田老鉱山
    [1112, 448200, 93300, 449100, 94200],   // 赤尾嶼
    [1113, 456300, 95700, 457200, 96600],   // 鳥島
    [1114, 457650, 93900, 458550, 94800],   // 久場島,*阿波連岬,*久場島,*座間味
    [1115, 459000, 94200, 459900, 95100],   // 慶伊瀬島,*那覇,*慶伊瀬島,*大謝名,*高志保
    [1116, 460800, 95100, 461700, 96000],   // 金武,*瀬嵩,*天仁屋,*仲尾次,*国頭平良
    [1117, 461250, 100200, 462150, 101100],   // 硫黄鳥島
    [1118, 463500, 118200, 464400, 119100],   // 漁生浦,*漁生浦,*串島
    [1119, 464400, 117600, 465300, 118500],   // 佐尾,*佐尾,*奈良尾,*友住
    [1120, 466650, 120600, 467550, 121500],   // 波戸岬,*波戸岬,*加唐島,*郷ノ浦,*印通寺
    [1121, 467550, 108000, 468450, 108900],   // 口之島,*吐カ喇平瀬
    [1122, 468000, 121800, 468900, 122700],   // 小呂島
    [1123, 468000, 123000, 468900, 123900],   // 沖島,*沖島
    [1124, 468000, 124500, 468900, 125400],   // 
    [1125, 472050, 87900, 472950, 88800],   // 沖大東島
    [1126, 472950, 124800, 473850, 125700],   // *須佐
    [1127, 474750, 125400, 475650, 126300],   // 浜田,*浜田,*下府
    [1128, 475200, 120300, 476100, 121200],   // 三崎,*三机
    [1129, 476550, 117600, 477450, 118500],   // 鵜来島,*母島,*鵜来島,*母島,*高茂岬,*福浦
    [1130, 478350, 128100, 479250, 129000],   // *瀬崎
    [1131, 479250, 129600, 480150, 130500],   // 崎,*菱浦,*都万,*都万,*都万
    [1132, 479700, 122400, 480600, 123300],   // 新居浜,*魚島,*伊吹島,*魚島
    [1133, 481500, 127800, 482400, 128700],   // 倉吉,*青谷
    [1134, 484200, 128400, 485100, 129300],   // 余部
    [1135, 486900, 124200, 487800, 125100],   // 堺,*堺,*大阪西南部,*西宮,*大阪西北部
    [1136, 488700, 120000, 489600, 120900],   // *串本,*古座,*下里
    [1137, 488700, 128700, 489600, 129600],   // *糠,*梅浦
    [1138, 490950, 131400, 491850, 132300],   // 松任,*松任,*金石
    [1139, 495450, 132300, 496350, 133200],   // 黒薙温泉,*白馬岳,*小川温泉,*越後平岩,*親不知,*小滝
    [1140, 498150, 138000, 499050, 138900],   // 鷲崎
    [1141, 500400, 123000, 501300, 123900],   // 神津島,*神津島,*式根島,*新島
    [1142, 502200, 152100, 503100, 153000],   // 奥尻
    [1143, 503100, 148800, 504000, 149700],   // 小島,*江良
    [1144, 504000, 148800, 504900, 149700],   // 松前,*白神岬,*松前,*渡島吉岡,*江良,*大千軒岳
    [1145, 504900, 109500, 505800, 110400],   // 鳥島
    [1146, 505800, 148500, 506700, 149400],   // 
    [1147, 507150, 97800, 508050, 98700],   // 西之島
    [1148, 507150, 128100, 508050, 129000],   // *銚子
    [1149, 507600, 137400, 508500, 138300],   // 塩竈,*塩竈,*宮戸島,*松島,*小野
    [1150, 508050, 147900, 508950, 148800],   // 有畑,*有畑,*城ヶ沢,*近川,*むつ,*蒲野沢
    [1151, 508950, 87000, 509850, 87900],   // 南硫黄島
    [1152, 509850, 139500, 510750, 140400],   // 津谷,*唐桑,*陸前広田
    [1153, 509850, 145800, 510750, 146700],   // 
    [1154, 510750, 144300, 511650, 145200],   // 陸中野田
    [1155, 511200, 141600, 512100, 142500],   // 霞露ヶ岳,*霞露ヶ岳,*トドヶ崎
    [1156, 511650, 98700, 512550, 99600],   // 嫁島,*嫁島,*媒島
    [1157, 512100, 162900, 513000, 163800],   // 猿払
    [1158, 513900, 161100, 514800, 162000],   // 乙忠部
    [1159, 518400, 154200, 519300, 155100],   // 白糠,*白糠,*庶路,*中庶路,*山花
    [1160, 522900, 159600, 523800, 160500],   // 知床岬
    [1161, 523800, 155100, 524700, 156000]    // 落石岬,*落石,*根室南部,*友知
  ]
};